import { setSanitizedHtml } from 'src/app/common/_helpers/html-sanitizer.util';
import {
  Component,
  Input,
  EventEmitter,
  Output,
  HostListener,
  SimpleChanges,
  ChangeDetectorRef,
  ElementRef,
  Renderer2,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { CrosstabService } from 'src/app/common/services/crosstab.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';
import { AlertMessageModel } from 'src/app/common/models/common.model';
import { CONFIG_TYPE } from '../../topics-configuration/topics-configuration.model';
import * as _ from 'lodash';
import { Subject, Subscription, forkJoin, of } from 'rxjs';
import { takeUntil, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SnapshotSharedVariablesService } from '../../Services/snapshot-shared-variables.service';
import { SharedPopupService } from 'src/app/common/services/shared-popup.service';
import { SnapshotService } from '../../Services/snapshot.service';
import { CustomsnapshotService } from '../../Services/customsnapshot.service';
import {
  checkboxSelectionWithParentSnapshot,
  DataObjectSnapshot,
} from 'src/app/common/models/crosstab.model';

import { UserProjectManagementService } from 'src/app/common/services/user-project-management.service';
import { CheckboxSelectionModel } from 'src/app/common/constants/common-constants';
import { ToastService } from 'src/app/common/services/toast.service';

interface MetricOptions {
  Name: string;
  isActive: boolean;
  responseCode: string;
}

interface Config {
  key: string;
  value: boolean;
}



interface Level2Item {
  Level2_value: string;
  [key: string]: any;
}

interface Level1Block {
  Level1_value: string;
  Level2: Level2Item[];
}

@Component({
  selector: 'app-leftpanel-snapshot',
  templateUrl: './leftpanel.component.html',
  styleUrls: ['./leftpanel.component.css'],
})
export class LeftpanelComponent implements OnDestroy {
  @Input() isCustomSnapshot: boolean = false;
  @Output() issubmitReset = new EventEmitter<boolean>();
  @Output() additionalFeatures = new EventEmitter<any>();
  @Output() IsEntrypointSelected = new EventEmitter<any>();
  @Output() customContentEnabled = new EventEmitter<boolean>();
  @Input() isGlobalDefaultSelectionEnabled: boolean = false;
  @Input() selectedBrandFromConfig: any = null;
  @ViewChild('variablesScroll') variablesScroll!: ElementRef;

  isAdditionalFeatures: boolean = false;
  issavelaodcheck: boolean = true;
  isadditionalfeatureDropdownOpen: boolean = false;

  additionalFeaturesList: any = [
    { name: 'Custom Variable', value: 'Custom Variable' },
    { name: 'Custom Reports', value: 'Custom Reports' },
  ];

  singleorMultiSelectMandatory1: string = '';
  timeperiodMandatory2: string = '';
  brandMandatory3: string = '';

  entryPointsData: any;
  snapshotData: any;
  snapshotDataConfig: any;
  top: string = '0px';
  topLev1: string = '0px';
  topEP: string = '0px';

  level0EP: string[] = [];
  Level0Variables: string[] = [];
  level0Filters: string[] = [];
  snapshotcohortType: string = "";
  selectedObjects: any[] = [];

  levelNumFor3n4: number = 0;
  mandatoryVariableMapping: any;
  multiCohort: boolean = false;
  mandatoryMaxLimitReached: boolean = false;

  @Output() showOutput = new EventEmitter<void>();
  @Output() baseValuesChanged = new EventEmitter<{ insufficientBase: number, lowBase: number }>();
  @Output() isLoadSelection = new EventEmitter<boolean>();
  @Input() snapshotselected: any = "";
  @Input() sectionselected: any = "";
  @Input() subsectionselected: any = "";
  bgWidth:any=0;


  compareacross: any = [
    { name: 'Market', value: 'standard', selected: true },
    { name: 'Brands', value: 'custom', selected: false },
    { name: 'Metrics', value: 'builder', selected: false },
  ];

  prevCompareAcrossValue: string = "";
  prevSectionValue: string = "";

  uniqueSelections: string[] = [];

  private destroy$ = new Subject<void>();
  $unSubscribeSubmitData1!: Subscription;
  $unSubscribeSubmitData2!: Subscription;
  // $unSubscribeSubmitData3!: Subscription;
  Reciveddata: any;

  selectionSummary: string = '';
  selectionSummaryTitle: string = '';
  audienceTooltip: string = 'No selections';


  variablesSummaryObj: any = [];
  variablesSummaryObjRadio: any = [];
  isMultiSelectEP: boolean = false;
  isLoader: boolean = false;
private _isMirroringBrandSelection = false;
  @Output() BindImageURL = new EventEmitter<any>();
  @Input() ImageURL: string = '';
  @Input() landingdata: any;
  @Input() ReceivedVarData: any;
  @Input() selected_study: string = '';
  uiStudyName: string = '';
  @Input() selected_client: string = '';
  @Input() isSavedScenarioSelected: boolean = false;
  dimensionList: string[] = [];
  @Input() isbackButton: boolean = false;
  @Input() isChangeEntryPoint: boolean = false;
  @Input() isCreateCustomGroup: boolean = false;
  @Input() isCustomGroupClick: boolean = false;
  @Input() isBrandAnalysis: boolean = false;
  @Input() selectedScenarioData: any;
  @Input() output_data: any;

  custom_calculation: string[] = [];
  custom_group: string[] = [];
  custom_report: string[] = [];
  export_download: string[] = [];
  metricOption: string[] = [];
  isStudyPanel = false;
  sidePanelblock: boolean = false;
  entryFlag: boolean = false;
  isEntry_Point = false;
  isVariableTab = false;
  isEntry_Tab = true;
  left_panel_collapse: boolean = false;
  is_variable_expand: boolean = false;
  is_load_btn: boolean = true;
  isPanelLoaded: boolean = false;
  isSavedSelection: boolean = false;

  selectedEP1 = '';
  selectedEP2 = '';
  selectedEP3 = '';

  /* @Output() isBtnVisible = new EventEmitter<string>();*/
  @Output() selectedVariableLevel1 = new EventEmitter<any>();
  @Output() selectedVariableLevel0 = new EventEmitter<string>();
  @Output() entryListChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() dataListChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() selectedConfig = new EventEmitter<any>();
  @Output() LeftPanelClick = new EventEmitter<any>();
  @Output() btnVisible = new EventEmitter<any>();
  @Output() dimensionListChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() cancelEntryPointChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output() snapNameNavHeader = new EventEmitter<any>();
  @Output() additionalList = new EventEmitter<any>();
  variable_expand: string = '';
  variable_expandLev1: string = '';
  variable_expandLev2: string = '';
  variable_expandLev3: string = '';
  variable_expandLev4: string = '';
  variable_expandLev5: string = '';
  variable_expandLev6: string = '';
  variable_expandLev7: string = '';
  variable_expandLev8: string = '';
  variable_expandLev9: string = '';

  entry_items_expand: string = '';
  entry_items_expand_lvl: boolean = false;
  entry_nested_items_expand: string = '';
  entry_nested_items_expand1: string = '';
  entry_nested_items_expand2: string = '';
  entry_nested_items_expand3: string = '';
  entry_nested_items_expand4: string = '';
  entry_nested_items_expand5: string = '';
  entry_nested_items_expand6: string = '';
  entry_nested_items_expand7: string = '';
  entry_nested_items_expand8: string = '';
  entry_nested_items_expand9: string = '';
  entry_nested_items_expandParent1: string = '';
  entry_nested_items_expandParent2: string = '';
  entry_nested_items_expandParent3: string = '';
  entry_nested_items_expandParent4: string = '';
  entry_nested_items_expandParent5: string = '';
  entry_nested_items_expandParent6: string = '';
  entry_nested_items_expandParent7: string = '';
  entry_nested_items_expandParent8: string = '';
  entry_nested_items_expandParent9: string = '';
  studyname: string = '';
  isLoadSubmitted: boolean = false;
  @Output() valueChange = new EventEmitter<boolean>();
  @Output() sendHelpGuide: EventEmitter<boolean> = new EventEmitter<boolean>();
  isSelectAll: boolean = false;
  isconfigCustomGrpPresent: boolean = false;
  selectAllCheck: number = 0;

  // ---- O(1) cache for toggleStatus / toggleStatusRadio ---------------------
  // Rebuilt whenever dataArray or EPdataFor_Multiple changes.
  // Without this, every CD cycle calls find+some+some for every row in the
  // entry-panel *ngFor, which is O(N×M×K) per item and accumulates badly.
  private _toggleStatusCache = new Map<string, boolean>();
  private _varCodeToEntryKeyCache = new Map<string, string>();
  // Cache for the .variableHeader element's top position (used for Level-0
  // expand positioning). The header never moves during a session, so we only
  // compute this once and reuse it on every subsequent Level-0 expand click.
  private _topLev1Cache: string | null = null;
  // Same cache for the .variables-sub-itemsLev1 panel (Level-1 expand positioning).
  private _topCache: string | null = null;
  // Track the last element that had 'selectedTextClick' so we can remove it
  // directly without a querySelectorAll on every expand click.
  private _lastSelectedTextClickEl: Element | null = null;
  // Cached reference to the submit button DOM element — avoids
  // document.getElementById on every checkbox click.
  private _submitButtonEl: HTMLElement | null = null;

  // Cached references to stable in-component elements that were previously
  // re-queried via document.querySelector on every repeatable action
  // (entry-point expand, EP radio click, compare-across change, load, etc.).
  // These live inside this component's template and are never structurally
  // recreated (they toggle visibility via the `DN` class / [style]), so a
  // one-time lookup is safe. Reset in ngOnDestroy.
  private _entryHeaderEl: HTMLElement | null = null;
  private _entryTabEl: Element | null = null;
  private _btnLoadEl: Element | null = null;
  private _variableTabEl: Element | null = null;

  private getEntryHeaderEl(): HTMLElement | null {
    if (!this._entryHeaderEl) {
      this._entryHeaderEl = document.querySelector('.EntryHeader') as HTMLElement;
    }
    return this._entryHeaderEl;
  }
  private getEntryTabEl(): Element | null {
    if (!this._entryTabEl) {
      this._entryTabEl = document.querySelector('.EntryTab');
    }
    return this._entryTabEl;
  }
  private getBtnLoadEl(): Element | null {
    if (!this._btnLoadEl) {
      this._btnLoadEl = document.querySelector('.btn-load');
    }
    return this._btnLoadEl;
  }
  private getVariableTabEl(): Element | null {
    if (!this._variableTabEl) {
      this._variableTabEl = document.querySelector('.variableTab');
    }
    return this._variableTabEl;
  }

  private _rebuildToggleStatusCache(): void {
    this._varCodeToEntryKeyCache.clear();
    this._toggleStatusCache.clear();
    for (const a of (this.EPdataFor_Multiple || [])) {
      const entryKey = ((a.variable_label ?? '') as string).replaceAll(' ', '');
      const codes = a.variable_code;
      if (Array.isArray(codes)) {
        for (const c of codes) { this._varCodeToEntryKeyCache.set(c, entryKey); }
      } else if (typeof codes === 'string') {
        this._varCodeToEntryKeyCache.set(codes, entryKey);
      }
    }
    for (const entry of (this.dataArray || [])) {
      for (const entryKey of Object.keys(entry)) {
        const val = entry[entryKey];
        if (!val?.Level1 || !Array.isArray(val.Level2)) continue;
        // checkBoxClick stores entries with 'EntryPoint1/2/3' keys while toggleStatus
        // looks up with label-based keys from _varCodeToEntryKeyCache.
        // Resolve to the label-based key so both paths are consistent.
        const effectiveKey = this._varCodeToEntryKeyCache.get(val.variableCode ?? '') ?? entryKey;
        for (const l2 of val.Level2) {
          if (!Array.isArray(l2.MetricOptions)) continue;
          for (const mo of l2.MetricOptions) {
            this._toggleStatusCache.set(`${effectiveKey}|${val.Level1}|${mo.Name}`, true);
          }
        }
      }
    }
  }
  // --------------------------------------------------------------------------
  entryPanel: {
    Level1: string;
  }[] = [];

  @Input() dataArray: any[] = [];
  entryPanel_Lvl2: {
    Level1: string;
    Level2: string;
  }[] = [];

  entryPanel_Lvl3: {
    Level: number;
    Level1: string;
    Level2: string;
    MetricOptions: string;
    responseCode: string;
    isActive: boolean;
    variableCode: string;
    e1_variable_code: string;
    e2_variable_code: string;
    e3_variable_code: string;
    mandatory_variable_mapping: any[];
    dimension: any[];
  }[] = [];

  entryList: {
    Level1: string;
    variableCode: string;

    mandatory_variable_mapping: any[];
    dimension: any[];
    NestedEntryArray: {
      Level2: any[];
      MetricOptions: {
        Name: string;
        responseCode: string;
        isActive: boolean;
        e1_variable_code: string;
        e2_variable_code: string;
        e3_variable_code: string;
      }[];
    }[];
    entryDetails: string;
  }[] = [];

  private selectedItem: HTMLElement | null = null;

  searchText: string = '';
  filteredStudies: string[] = [];
  filteredEntryStudies: {
    study_name: string;
    entry_name: string;
    values: any[];
  }[] = [];
  entryArray: string[] = [];
  filterdEntryList: any[] = [];

  NestedEntryPoints = false;
  searchTextLevel2: string = '';
  searchMetricOption: string = '';
  selectedMarketItems: string[] = [];
  searchVariable: string = '';
  searchVariable2: string = '';
  searchVariable3: string = '';
  searchVariable4: string = '';
  searchVariable5: string = '';
  searchVariable6: string = '';
  searchVariable7: string = '';
  searchVariable8: string = '';
  searchVariable9: string = '';
  searchVariable10: string = '';
  isBrowserRefresh: boolean = false;

  searchVariableFil: string = '';
  searchVariable2Fil: string = '';
  searchVariable3Fil: string = '';
  searchVariable4Fil: string = '';
  searchVariable5Fil: string = '';
  searchVariable6Fil: string = '';
  searchVariable7Fil: string = '';
  searchVariable8Fil: string = '';
  searchVariable9Fil: string = '';
  searchVariable10Fil: string = '';

  showCancelBtn: boolean = false;
  // variableTabData: string[] = [];
  variableTabData: any = [];

  e1_forMultiple: string = '';
  e2_forMultiple: string = '';
  e3_forMultiple: string = '';
  mandatory_variable_mapping_Multiple: any[] = [];
  dimension_Multiple: any[] = [];
  dataArray_Multiple: any[] = [];
  EPdataFor_Multiple: any;
  isMultiMarketOrCateg: boolean = false;
  isAudienceSnapshot: boolean = false;
  variableListMultiMarketAndCateg: {
    Level0: string;
    isEntryPoint: boolean;
    hasNextLevel: boolean;
    is_selected: boolean;
    Level1: {
      Level1_value: string;
      is_derived: string;
      is_brand_analysis: number;
      calc_type: string;
      tooltip: string;
      hasNextLevel: boolean;
      data_variable_code: string;
      response_code: string;
      derived_metric_calculation: string;
      sort_id: string;
      is_multi_punch: string;
      date: string;
      year_code: string;
      is_dimension: string;
      isCustomGrpPresent: string;
      kibanaFilterScript: string;
      customGroupId: string;
      dataYearCode: string;
      is_time_Period_Present: string;
      is_selected: boolean;
      Level2: any;
    }[];
  }[] = [];

  EntryPointHeader = 'ENTRY POINT';
  defaultBrandList:any;
  variableList: {
    Level0: string;
    isEntryPoint: boolean;
    hasNextLevel: boolean;
    is_selected: boolean;
    Level1: {
      Level1_value: string;
      is_derived: string;
      is_brand_analysis: number;
      calc_type: string;
      tooltip: string;
      hasNextLevel: boolean;
      data_variable_code: string;
      response_code: string;
      derived_metric_calculation: string;
      sort_id: string;
      is_multi_punch: string;
      date: string;
      year_code: string;
      is_dimension: string;
      isCustomGrpPresent: string;
      kibanaFilterScript: string;
      customGroupId: string;
      dataYearCode: string;
      is_time_Period_Present: string;
      is_selected: boolean;
      Level2: any;
    }[];
  }[] = [];

  totalSampleObj = {
    Level1_value: "Total Sample",
    is_derived: "",
    is_brand_analysis: 0,
    calc_type: "",
    tooltip: "Total Sample",
    hasNextLevel: false,
    data_variable_code: "total_sample",
    response_code: "",
    derived_metric_calculation: "",
    sort_id: "0",
    is_multi_punch: "",
    date: "",
    year_code: "",
    is_dimension: "",
    isCustomGrpPresent: "",
    kibanaFilterScript: "",
    customGroupId: "",
    dataYearCode: "",
    is_time_Period_Present: "",
    is_selected: false,
    Level2: []
  };

  variableListFilter: {
    LevelMinus: string;
    isEntryPoint: boolean;
    hasNextLevel: boolean;
    is_selected: boolean;
    Level1: {
      Level0: string;
      isEntryPoint: boolean;
      is_selected: boolean;
      hasNextLevel: boolean;
      Level1: {
        Level1_value: string;
        is_derived: string;
        is_brand_analysis: number;
        calc_type: string;
        tooltip: string;
        hasNextLevel: boolean;
        data_variable_code: string;
        response_code: string;
        derived_metric_calculation: string;
        sort_id: string;
        is_multi_punch: string;
        date: string;
        year_code: string;
        is_dimension: string;
        isCustomGrpPresent: string;
        kibanaFilterScript: string;
        customGroupId: string;
        dataYearCode: string;
        is_time_Period_Present: string;
        Weekno_forSigcalculation: string;
        is_selected: boolean;
        Level2: any;
      }[];
    }[];
  }[] = [];

  @Input() landingData!: any[];
  @Input() isAcrossdropDown: boolean = false;
  clientcode: string = '';
  SelectionObject: {
    Row: {
      Parent: string;
      Data: {
        Child: string;
      }[];
    }[];
    Row_Nest: {
      Parent: string;
      Data: {
        Child: string;
      }[];
    }[];
    Column: {
      Parent: string;
      Data: {
        Child: string;
      }[];
    }[];
    ColumnNest: {
      Parent: string;
      Data: {
        Child: string;
      }[];
    }[];
  }[] = [];
  @Output() isClearEverything = new EventEmitter<boolean>();

  snapshotType_details: any[] = [];
  isSingleaudienceCohortType: boolean = false;
  audienceLimit: boolean = false;
  isAudienceTotalSample: boolean = false;
  totalSample: boolean = false;
  isTotalSampleAudienceActive: boolean = false;
  audienceRawVariableData: any[] = [];
  constructor(
    private router: Router,
    private crossTabService: CrosstabService,
    private _alertService: AlertMessageService,    
    public _configService: SnapshotService,
    private clientDetails: SnapshotSharedVariablesService,
    private _loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private elRef: ElementRef,
    private _usermanagementService: UserProjectManagementService,
    private _configCustomService: CustomsnapshotService,
    private toastService: ToastService
  ) {
    this.landingdata = this.router.getCurrentNavigation()?.extras.state;
  }

  iscompareacrossDropdownOpen = false;
  selectedcompareacrossOption: string = '';
  clientSnapshotNames: any;
  clientSnapshotNameObject: any;
  snapshotName: any;
  datarrayformultiplemarkorcategories: any = [];
  ngOnInit() {
    let localUserdefined: any = localStorage.getItem('leftPanelFilters');
    if (
      localUserdefined != undefined &&
      localUserdefined != null &&
      localUserdefined != ''
    ) {
      localStorage.removeItem('leftPanelFilters');
    }
    const [navEntry] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];

    // this.isBrowserRefresh = navEntry?.type === 'reload';
    this.isBrowserRefresh =
  navEntry?.type === 'reload' || navEntry?.type === 'navigate';
    this._loaderService.showLoader();
    this.dimensionList = [];
    this.entryPanel = [];
    this.variableList = [];
    this.compareacross = [];
    this.variableListMultiMarketAndCateg = [];
    // this.getEntryData();
    this.crossTabService.selectedStudyName.next(this.selected_study);

    if (this.dataArray.length > 0) {
      this.datarrayformultiplemarkorcategories = this.dataArray;
    }

    let data = {
      client_code: this.clientDetails.clientDetails.client_code,
      snapshot_name: this.clientDetails.clientDetails.study,
    };

    this._configService.getClientStudyData(data).pipe(takeUntil(this.destroy$)).subscribe((c) => {
      let data = JSON.parse(c.body.Data);

      this._configService.outputSnapshotData = data;
      this.customContentEnabled.emit(this.isCustomPercentageOrMeanSelected());
      this.snapshotName = data.snapshot_name;
      this.snapNameNavHeader.emit(data.snapshot_name);
      this.additionalList.emit(data.additional_list);
      // if (
      //   this._configService.outputSnapshotData?.snapshotType_details?.[1]?.snapshot_type === 'Audience Snapshot'
      // ) {
      //   this.snapshotcohortType = this._configService.outputSnapshotData?.audienceCohortType;
      // }
      this.isMultiSelectEP = data.additional_list.some(
        (item: any) =>
          item.key ===
          CheckboxSelectionModel.additionalCheckBoxSelection[5].name
      );
      this.snapshotType_details = data.snapshotType_details;
      let studyName = data.study_list[0].study_name;
      this.selected_study = studyName;
      this.selected_client = data.client_name;
      this._configService.staticText =
        data.static_text != null ? data.static_text : '';
      let compareacross: any = [];
      if (data?.saveselection) {
        this._configService.globalDefaultSelectionFlag =
          data.saveselection.find(
            (item: { key: string; value: boolean }) =>
              item.key === 'Global Default Selection'
          )?.value ?? false;
      }

      this._configService
        .getConfigurationByClientName(
          this.clientDetails.clientDetails.client_code
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe((EPData) => {
          let data = JSON.parse(EPData.Data);

          let selectedStudyData = data.filter(
            (item: any) => item.configData.study == this.selected_study
          );
          this.EPdataFor_Multiple = selectedStudyData[0].configData.entry_point;
          this._rebuildToggleStatusCache();
          this.cdr.markForCheck();
        });

      this.issavelaodcheck =
        this._configService.outputSnapshotData?.saveselection != null
          ? this._configService.outputSnapshotData?.saveselection?.find(
            (m: any) => m.key === 'Save/Load'
          )?.value ?? false
          : false;
      // this.snapshotType_details.forEach((type: any) => {
      //   compareacross.push({
      //     name: type.snapshot_type,
      //     value: type.snapshot_type,
      //     selected: false,
      //   });
      // });

      // this.compareacross = compareacross;

      this._configService.widgetVariable$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
        compareacross = [];
        if (value != null && value.length != 0) {
          if (this._configService.snapshotProductType == 'custom') {
            value.snapshotType.forEach((type: any) => {
              compareacross.push({
                name: type.snapshotType_name,
                value: type.snapshotType_name,
                selected: false,
                section: type.section.map((section: any) => ({
                  name: section.section_name,
                  selected: false,
                  subsection: section.subsection
                    .filter((a: any) => a.subsection_name != 'NA')
                    .map((subsection: any) => ({
                      name: subsection.subsection_name,
                      selected: false,
                    })),
                })),
              });
            });
          } else if (this._configService.snapshotProductType == 'standard') {
            value.forEach((type: any) => {
              compareacross.push({
                name: type.snapshotType,
                value: type.snapshotType,
                selected: false,
                section: [
                  {
                    name: type.sections,
                    selected: false,
                    subsection:
                      type.subsection == 'NA'
                        ? []
                        : [
                          {
                            name: type.subsection,
                            selected: false,
                          },
                        ],
                  },
                ],
              });
            });
          }

          compareacross.forEach((c: any) => {
            c.section.sort((a: any, b: any) => a.name.localeCompare(b.name));
            c.section.forEach((s: any) => {
              s.subsection.sort((a: any, b: any) =>
                a.name.localeCompare(b.name)
              );
            });
          });

          compareacross.forEach((item: any) => {
            const sectionsOnly = item.section.filter(
              (section: any) => section.subsection.length === 0
            );
            const sectionsWithSubsections = item.section.filter(
              (section: any) => section.subsection.length > 0
            );

            // Sort sections alphabetically
            sectionsOnly.sort((a: any, b: any) => a.name.localeCompare(b.name));
            sectionsWithSubsections.sort((a: any, b: any) =>
              a.name.localeCompare(b.name)
            );

            // Sort subsections alphabetically
            sectionsWithSubsections.forEach((section: any) => {
              section.subsection.sort((a: any, b: any) =>
                a.name.localeCompare(b.name)
              );
            });

            // Reassign sorted sections back
            item.section = [...sectionsOnly, ...sectionsWithSubsections];
          });

          this.compareacross = compareacross;
        }

        const noDataScreen = document.querySelector('.no-data-screen');
        if (compareacross.length == 0) {
          if (noDataScreen) {
            noDataScreen.classList.remove('DN');
            this.collapsePanel();
          }
        } else {
          if (noDataScreen) {
            noDataScreen.classList.add('DN');
            this.expandPanel();
          }
        }
        this.cdr.markForCheck();
      });

      let parameter = {
        snapshot_name: this.clientDetails.clientDetails.study,
        client_name: this.clientDetails.clientDetails.client_code,
        client_code: this.clientDetails.clientDetails.client_code,
        study: studyName,
        snapshot_type: this._configService.snapshotSelectedName || this.clientDetails.clientDetails.snapshotselected,
        section_name: this._configService.selectedSection,
        subsection_name: this._configService.selectedSubSection == "NA" ? "" : this._configService.selectedSubSection,
      };

      let parameter1 = {
        study: studyName,
        client_name: this.clientDetails.clientDetails.client_code,
        client_code: this.clientDetails.clientDetails.client_code,
        isBrandAnalysis: true,
      };

      forkJoin({
        generalConfig: this._configService.getGeneralConfigData(parameter1),
        entryPointData: this._configService.getSnapshotEntryPointData(parameter),
      }).pipe(takeUntil(this.destroy$)).subscribe(({ generalConfig, entryPointData: data }) => {
          // --- process generalConfig ---
          if (generalConfig.Data != '') {
            let lsORisData = JSON.parse(generalConfig.Data);
            this.uiStudyName = lsORisData?.configData?.uiStudyName || '';
            this._configService.setDropdownValue('uiStudyName', this.uiStudyName);
            this.mandatoryVariableMapping = lsORisData?.configData?.mandatory_variable_mapping;
            this.ImageURL = lsORisData.logoFile.url;
            this.BindImageURL.emit({
              Image: this.ImageURL,
            });
            this._configService.LBthreshold = Number(
              lsORisData.configData.low_base_identifier.find(
                (item: any) => item.key === 'Low Base'
              )?.data_value
            );
            this._configService.ISthreshold = Number(
              lsORisData.configData.low_base_identifier.find(
                (item: any) => item.key === 'Insufficient Base'
              )?.data_value
            );
            this._configService.weights = lsORisData.configData.weight.filter(
              (m: any) => m.is_selected == true
            );
            if (
              lsORisData.configData.threshold_identifier[0].data_value != undefined ||
              lsORisData.configData.threshold_identifier[0].data_value != null
            ) {
              this._configService.thresholdIndex = Number(
                lsORisData.configData.threshold_identifier[0].data_value
              );
            }
          }
          // --- process entryPointData (was getSnapshotEntryPointData subscribe) ---
          {
        this.entryPointsData = JSON.parse(data.Data);
      

          // if (this.entryPointsData.length > 0) {
          //   this.ImageURL = this.entryPointsData[0].url_logo;
          //   this.BindImageURL.emit({
          //     Image: this.ImageURL,
          //   });
          // }

          this.snapshotData = this.entryPointsData.Common_config;
          this.snapshotDataConfig = this.snapshotData.snap_config;
          this.customContentEnabled.emit(this.isCustomPercentageOrMeanSelected());
          //this.selectedWeight=this.snapshotData.
          this.aggregatedVariables = this.snapshotData.aggregatedvariables;
          var x = [];
          for (let i = 0; i < this.snapshotData.dataformat.length; i++) {
            if (this.snapshotData.dataformat[i].value == true) {
              x.push(this.snapshotData.dataformat[i].key);
            }
          }

          for (let j = 0; j < x.length; j++) {
            if (x[j] == 'Respondent Level') this.isRespondentLevel = true;
            else if (x[j] == 'Semi-Aggregated')
              this.isSemiAggregatedData = true;
            else if (x[j] == 'Aggregated') this.isAggregatedData = true;
          }

          // ;

          this.BindEntryData(
            this.entryPointsData.EntryPoints,
            this.selected_study,
            this.clientDetails.clientDetails.client_code,
            true
          );

          // to remove custom variables if semi aggregated or aggregated
          if (this.isAggregatedData || this.isSemiAggregatedData) {
            this.additionalFeaturesList = this.additionalFeaturesList.filter(
              (item: any) => item.name !== 'Custom Variable'
            );
          }

          //check if default selections are made in load selection
          if (
            !this.isAcrossdropDown ||
            (this._configService.tiggerSelectionSnapshotType &&
              !this._configService.isGlobalDefaultSelectionEnabled) ||
            this._configService.isFomChanged ||
            this._configService.reapplySelectionAfterReload
          ) {
            this.LoadSelection(true);
          }

          this.selectedSnapshotType = 'Single Brand';
          let option = {
            name: 'Single Brand',
            value: 'Single Brand',
            selected: true,
            section: [
              { name: '05pie chart', selected: true, subsection: [] },
              { name: '13 Jan ', selected: false, subsection: [] },
              { name: 'bips-comparision', selected: false, subsection: [] },
              { name: 'D', selected: false, subsection: [] },
              { name: 'fill chart', selected: false, subsection: [] },
              { name: 'HART1', selected: false, subsection: [] },
              { name: 'lollipop_ssr', selected: false, subsection: [] },
              { name: 'Rader_Chart', selected: false, subsection: [] },
              { name: 'task_74068', selected: false, subsection: [] },
              {
                name: 'Lollipop Chart Check',
                selected: false,
                subsection: [{ name: 'Bug 1', selected: false }],
              },
            ],
          };
          if (
            this._configService.snapshotSelectedName === '' ||
            (this._configService.snapshotSelectedName === undefined &&
              this._configService.selectedSection === '') ||
            (this._configService.selectedSection === undefined &&
              this._configService.selectedSubSection === '') ||
            this._configService.selectedSubSection === undefined
          ) {
            this._configService.snapshotSelectedName =
              localStorage.getItem('snapshotselected_landing') || '';
            this._configService.selectedSection =
              localStorage.getItem('sectionselected_landing') || '';
            this._configService.selectedSubSection =
              localStorage.getItem('subsectionselected_landing') || '';
          }

          option = this.compareacross.find(
            (option: any) =>
              option.name == this._configService.snapshotSelectedName
          );
   this.selectcompareacrossOption(
            this._configService.snapshotSelectedName,
            option,
            this._configService.selectedSection,
            this._configService.selectedSubSection
          );

          if (this._configService.reapplySelectionAfterReload) {
            setTimeout(() => this.reapplyStoredSelectionAsSavedScenario(), 0);
          }

          if (
            !this._configService.isGlobalDefaultSelectionEnabled &&
            !this.isSavedScenarioSelected
          ) {
            this._loaderService.hideLoader();
          }
          } // end entryPointData block
          this.cdr.markForCheck();
        });

      this._configService.loadSelec$.pipe(
        takeUntil(this.destroy$),
        // Use switchMap to avoid nested subscription leak — each new
        // loadSelec$ emission disposes the previous hasLoadSelec$ subscription.
      ).subscribe((a: any) => {});
      // Flat subscription: listen once, filter by truthy value.
          this._configService.hasLoadSelec$.pipe(takeUntil(this.destroy$)).subscribe((result: any) => {
            if (result) {
              this.collapsePanel();
        }
        this.cdr.markForCheck();
      });
      this.cdr.markForCheck();
    });
  }

  @Input() moduleLists: any;
  sectionSelected: string = '';
  ngOnChanges(changes: SimpleChanges): void {
    //To get section data
    if (changes['moduleLists']) {
      let moduleList = changes['moduleLists'].currentValue;
      for (let i = 0; i < moduleList.length; i++) {
        if (moduleList[i].isSelected == true) {
          this.sectionSelected = moduleList[i].name;
        }
      }
    }
    if (
      changes['isGlobalDefaultSelectionEnabled']?.currentValue &&
      this._configService.isGlobalDefaultSelectionEnabled &&
      this._configService.globalDefaultSelectionFlag &&
      !this.isPanelLoaded &&
      !this.isSavedScenarioSelected &&
      this._configService.tiggerSelectionSnapshotType
    ) {
      this.isPanelLoaded = true;
      let option = {
        name: 'Single Brand',
        value: 'Single Brand',
        selected: true,
        section: [
          { name: '05pie chart', selected: true, subsection: [] },
          { name: '13 Jan ', selected: false, subsection: [] },
          { name: 'bips-comparision', selected: false, subsection: [] },
          { name: 'D', selected: false, subsection: [] },
          { name: 'fill chart', selected: false, subsection: [] },
          { name: 'HART1', selected: false, subsection: [] },
          { name: 'lollipop_ssr', selected: false, subsection: [] },
          { name: 'Rader_Chart', selected: false, subsection: [] },
          { name: 'task_74068', selected: false, subsection: [] },
          {
            name: 'Lollipop Chart Check',
            selected: false,
            subsection: [{ name: 'Bug 1', selected: false }],
          },
        ],
      };
      if (
        this._configService.snapshotSelectedName === '' ||
        (this._configService.snapshotSelectedName === undefined &&
          this._configService.selectedSection === '') ||
        (this._configService.selectedSection === undefined &&
          this._configService.selectedSubSection === '') ||
        this._configService.selectedSubSection === undefined
      ) {
        this._configService.snapshotSelectedName =
          localStorage.getItem('snapshotselected_landing') || '';
        this._configService.selectedSection =
          localStorage.getItem('sectionselected_landing') || '';
        this._configService.selectedSubSection =
          localStorage.getItem('subsectionselected_landing') || '';
      }
      let entryPointsData = this.entryPointsData.EntryPoints.filter(
        (a: any) =>
          a.study === this.selected_study &&
          a.MetricOption !== '' &&
          a.Level1 != null &&
          !a.Level1.toLowerCase().includes('market')
      );
      if (
        this._configService.snapshotSelectedName !== 'Multiple Markets' ||
        (entryPointsData && entryPointsData.length > 0) ||
        this._configService.askMePreselection != null
      ) {
        option = this.compareacross.find(
          (option: any) =>
            option.name == this._configService.snapshotSelectedName
        );
        if (this._configService.askMePreselection != null) {
          setTimeout(() => {
            this.selectcompareacrossOption(
              this._configService.snapshotSelectedName,
              option,
              this._configService.selectedSection,
              this._configService.selectedSubSection
            );
          }, 0);
        } else {
          this.selectcompareacrossOption(
            this._configService.snapshotSelectedName,
            option,
            this._configService.selectedSection,
            this._configService.selectedSubSection
          );
        }
      }
    }
    //whenever load is clicked for particular saved scenario to bind leftpanel data this is called
    // This method will be called whenever there is a change in the @Input properties
    this.showCancelBtn = false;
    if (changes['dataArray']) {
      // Rebuild the O(1) toggle-status cache whenever the dataArray input changes.
      this._rebuildToggleStatusCache();
    }
    if (
      changes['dataArray'] &&
      this.isSavedScenarioSelected &&
      (!this.isPanelLoaded || this.hasSelectionNameChanged(changes))
    ) {
      this.isPanelLoaded = true;
      this.updateLeftPanel();
    } else if (changes['isbackButton'] && this.isbackButton) {
      //this.getVariableData();
    } else if (changes['isChangeEntryPoint'] && this.isChangeEntryPoint) {
      this.isVariableTab = false;
      this.is_load_btn = true;
      this.isEntry_Tab = true;
      this.showCancelBtn = true;
    }
    // else if (changes['isCustomGroupClick'] && this.isCustomGroupClick && this.variableList.length > 0) {
    //   let customObject = this.variableList;
    //   //let listToUpdate = this.customGroupSelectionsObj;

    //   let listToUpdate = customObject.filter(
    //     (a) => a.isEntryPoint != true && a.Level0 != 'Time Period' && a.Level0 != 'Custom Group'
    //   );
    //   this.variableList = listToUpdate;
    // }
    else if (
      changes['isCreateCustomGroup'] &&
      this.isCreateCustomGroup &&
      this.variableList.length > 0
    ) {
      let customObject = this.variableList;
      //let listToUpdate = this.customGroupSelectionsObj;

      let listToUpdate = customObject.filter(
        (a) =>
          a.isEntryPoint != true &&
          a.Level0 != 'Time Period' &&
          a.Level0 != 'Custom Group'
      );
      this.variableList = listToUpdate;
    }

    // else if (changes['isCustomGroupClick'] && this.isCustomGroupClick && this.variableTabData.length > 0) {
    //   this.BindVariableDataLeftPanel(this.variableTabData);
    //   this.crossTabService.setVariableTabData(this.variableTabData);
    // }
  }

  /**
   * reloadApply case: the section changed FOM but the current selection is still
   * valid. Rebuild a saved-scenario-shaped object from the persisted selection
   * (finalLeftPanelInputSelectedObject / finalLeftPanelSubmitObject / entryPointData)
   * and replay it through the existing saved-selection path, which auto-submits.
  */
  private reapplyStoredSelectionAsSavedScenario(): void {
    const input = this._configService.finalLeftPanelInputSelectedObject;
    const output = this._configService.finalLeftPanelSubmitObject;
    const entry = this._configService.entryPointData ?? [];

    // Consume the flag first so it only ever runs once per reload.
    this._configService.reapplySelectionAfterReload = false;

    if (!input || !output) {
      this._loaderService.hideLoader();
      return;
    }

    this.selectedScenarioData = [{
      leftpanel_input_data: JSON.stringify(input),
      output_selection_data: JSON.stringify(output),
      entry_point_selection_data: JSON.stringify(entry),
      section: this._configService.selectedSection,
      subSection: this._configService.selectedSubSection,
      snapshotType: this.selectedcompareacrossOption,
      selection_summary: this._configService.selectionSummaryText ?? '',
      selectedCustomBaseReference: JSON.stringify(this.selectedCustomBaseReference ?? []),
    }];

    if (output?.widegtconfigdetails) {
      output.widegtconfigdetails = {
        ...output.widegtconfigdetails,
        section: this._configService.selectedSection,
        subSection: this._configService.selectedSubSection,
      };
    }

    this.isSavedScenarioSelected = true;
    this.isPanelLoaded = true;                 // parity with the ngOnChanges saved-load path
    this._configService.saveSelectionLoad = true;
    this.output_data = output;
    this.dataArray = entry;                     // entry points the saved flow expects

    // Drive the FULL saved-scenario auto-sequence:
    // bind entry points -> loadBtnClick (loads variables) -> LoadSelectionVariableData -> SubmitClicked(true).
    // updateLeftPanel() reads selectedScenarioData[0], so it must be set above first.
    this.updateLeftPanel();
  }

  hasSelectionNameChanged = (changes: any): boolean => {
    const previousValue = changes["selectedScenarioData"]?.previousValue;
    const currentValue = changes["selectedScenarioData"]?.currentValue;

    if (!previousValue || !currentValue) return false;

    const prevNames = previousValue
      .map((item: any) => item.selection_name)
      .filter(Boolean);

    const currNames = currentValue
      .map((item: any) => item.selection_name)
      .filter(Boolean);

    return !prevNames.every((name: string) => currNames.includes(name)) ||
          !currNames.every((name: string) => prevNames.includes(name));
  };

  togglecompareacrossDropdown() {
    this.iscompareacrossDropdownOpen = !this.iscompareacrossDropdownOpen;

    this.sidePanelblock = false;
    this.entry_items_expand = '';
    this.variable_expand = '';
    this.variable_expandLev1 = '';
    this.variable_expandLev2 = '';
    this.variable_expandLev3 = '';
    this.variable_expandLev4 = '';
    this.variable_expandLev5 = '';
    this.variable_expandLev6 = '';
    this.variable_expandLev7 = '';
    this.variable_expandLev8 = '';
    this.variable_expandLev9 = '';
  }

  closecompareacrossDropdown() {
    this.iscompareacrossDropdownOpen = false;
  }

  @Output() selectedType = new EventEmitter();
  @Output() increaseLeftpanelHeight = new EventEmitter();
  selectedSnapshotType = '';
  selectedSection = '';
  selectedSubSection = 'NA';
  isSubSectionDropdownOpen = false;
  isSectionDropdownOpen = false;
  ShowSection(SnapshotType: string) {
    let sectionDiv = document.querySelector('.section-options');
    sectionDiv?.classList.remove('DN');
    event?.stopPropagation();

    this.selectedSnapshotType = SnapshotType;
    this._configService.selectedSnapshotType = this.selectedSnapshotType;
    this.isSubSectionDropdownOpen = false;
    this.isSectionDropdownOpen = true;
  }

  ShowSubSection(section: string) {
    let subSectionDiv = document.querySelector('.sub-section-options');
    subSectionDiv?.classList.remove('DN');
    event?.stopPropagation();

    this.selectedSection = section;
    this.isSubSectionDropdownOpen = true;
  }

  dimensionVariableList: any[] = [];
  selectcompareacrossOption(
    option: string,
    object: any,
    section: string = 'NA',
    subSection: string = 'NA'
  ) {
    this._configService.setDropdownValue('compareAcross', option);
    object.selected = true;
    this.compareacross.forEach((c: any) => {
      if (c.name !== option) {
        c.selected = false;
      } else c.selected = true;

      c.section.forEach((s: any) => {
        if (c.name == option && s.name == section) {
          s.selected = true;
          this.selectedSection = s.name;
          if (s.subsection.length == 0) {
            this.selectedSubSection = 'NA';
          }
        } else {
          s.selected = false;
        }
        s.subsection.forEach((ss: any) => {
          if (c.name == option && s.name == section && ss.name == subSection) {
            ss.selected = true;
            this.selectedSubSection = ss.name;
          } else {
            ss.selected = false;
          }
        });
      });
    });
    this.selectedcompareacrossOption = option;
    this._configService.selectedcompareacrossOption = option;
    this.iscompareacrossDropdownOpen = false;
    this.isSubSectionDropdownOpen = false;
    this.isSectionDropdownOpen = false;
    this.selectedType.emit(option); /////

    if (
      this.selectedSnapshotType != this.prevCompareAcrossValue ||
      (this._configService.isGlobalDefaultSelectionEnabled &&
        this._configService.globalDefaultSelectionFlag)
    ) {
      this.prevCompareAcrossValue = option;
      this.prevSectionValue = section;

      this.entry_nested_items_expand = '';

      this.entry_nested_items_expand1 = '';
      this.entry_nested_items_expandParent1 = '';
      this.entry_nested_items_expand2 = '';
      this.entry_nested_items_expandParent2 = '';
      this.entry_nested_items_expand3 = '';
      this.entry_nested_items_expandParent3 = '';

      this.variableListMultiMarketAndCateg = [];
      this.variableList = [];
      this.variableListFilter = [];

      this.GetMandatorySelectionsList();

      if (this.snapshotDataConfig.snapshotType_details.length > 0) {
        let snapshotTypeEPandD =
          this.snapshotDataConfig.snapshotType_details.find(
            (x: any) => x.snapshot_type === option
          );

        const entryTabDiv = this.getEntryTabEl();
        const loadDiv = this.getBtnLoadEl();
        const variableTab = this.getVariableTabEl();

        entryTabDiv?.classList.add('DN');
        loadDiv?.classList.add('DN');
        variableTab?.classList.add('DN');

        const submitreset = document.querySelector('.submit-reset-btn');
        if (!submitreset?.classList.contains('disabled'))
          submitreset?.classList.add('disabled');

        this.dataArray = [];
        let validSelectedEPs = snapshotTypeEPandD.entry_point.filter(
          (x: any) => x.is_selected === true
        );
        const selectedEPs = validSelectedEPs.filter((ep: any) => ep.variable_code && ep.variable_label !== 'None');
        let selectedEPsVariableCodes = selectedEPs.map(
          (x: any) => x.variable_code
        );

        this.level0EP = [];
        this.entryPanel = [];
        this.entryPanel_Lvl2 = [];
        this.entryPanel_Lvl3 = [];
        //if(option != this.selectedSnapshotType)
        if (selectedEPs.length > 0) {
          if (entryTabDiv) {
            entryTabDiv.classList.remove('DN');
          }
          if (loadDiv) loadDiv.classList.remove('DN');
          let entryPointsData = this.entryPointsData.EntryPoints.filter((a: any) =>
            selectedEPsVariableCodes.includes(a.VariableCode)
          );

          const Leve1 = _.uniq(
            _.map(
              _.filter(
                entryPointsData,
                (item) =>
                  item.Level1 !== null &&
                  item.Level2 !== '' &&
                  item.study == this.selected_study
              ),
              'Level1'
            )
          );
          let index = 0;
          let uniqueVariableCode: string[] = [];

          let isEntryPoints = false;
          for (const element of Leve1) {
            this.entryPanel.push({
              Level1: element,
            });

            this.level0EP.push(element);
            if (
              this._configService.isGlobalDefaultSelectionEnabled &&
              this._configService.globalDefaultSelectionFlag &&
              !this.isSavedScenarioSelected &&
              this._configService.tiggerSelectionSnapshotType
            ) {
              let entryPointsDataForSelection = this.entryPointsData.EntryPoints.find(
                (a: any) =>
                  a.Level1 == element &&
                  a.study == this.selected_study &&
                  a.MetricOption != ''
              );
              const match = this.EPdataFor_Multiple?.find(
                (a: any) =>
                  a.variable_code === entryPointsDataForSelection.VariableCode
              );
              if (
                match &&
                this.selectedcompareacrossOption !== 'Multiple Markets'
              ) {
                uniqueVariableCode.push(
                  entryPointsDataForSelection.VariableCode
                );
                match.variable_label = `Entry Point ${index + 1}`;
              }
              if (this.isMultiSelectEP) {
                if (entryPointsDataForSelection) {
                  isEntryPoints = true;
                  this.checkBoxClick(
                    0,
                    index,
                    entryPointsDataForSelection.Header,
                    entryPointsDataForSelection.Level1,
                    entryPointsDataForSelection.Level2,
                    entryPointsDataForSelection.MetricOption,
                    entryPointsDataForSelection.VariableCode,
                    entryPointsDataForSelection.ResponseCode,
                    entryPointsDataForSelection.mandatory_variable_mapping,
                    entryPointsDataForSelection.is_SelectAll_Metrics,
                    entryPointsDataForSelection.e1_variable_code,
                    entryPointsDataForSelection.e2_variable_code,
                    entryPointsDataForSelection.e3_variable_code,
                    entryPointsDataForSelection.dimension
                  );
                }
              } else {
                if (entryPointsDataForSelection) {
                  isEntryPoints = true;
                  this.EPRadioClick(
                    0,
                    index,
                    entryPointsDataForSelection.Header,
                    entryPointsDataForSelection.Level1,
                    entryPointsDataForSelection.Level2,
                    entryPointsDataForSelection.MetricOption,
                    entryPointsDataForSelection.VariableCode,
                    entryPointsDataForSelection.ResponseCode,
                    entryPointsDataForSelection.mandatory_variable_mapping,
                    entryPointsDataForSelection.is_SelectAll_Metrics,
                    entryPointsDataForSelection.e1_variable_code,
                    entryPointsDataForSelection.e2_variable_code,
                    entryPointsDataForSelection.e3_variable_code,
                    entryPointsDataForSelection.dimension
                  );
                }
              }
              index++;
            }
          }
          if (uniqueVariableCode && uniqueVariableCode.length > 0) {
            this.EPdataFor_Multiple = this.EPdataFor_Multiple.filter(
              (item: any) =>
                item.variable_code === '' ||
                uniqueVariableCode.includes(item.variable_code)
            );
          }
          if (
            isEntryPoints &&
            this._configService.isGlobalDefaultSelectionEnabled &&
            this._configService.globalDefaultSelectionFlag &&
            !this.isSavedScenarioSelected
          ) {
            this.loadBtnClick(true);
          }
        } else {
          this.dataArray = [];
          const clientStudyInfo = {
            clientName: this.clientDetails.clientDetails.client_code,
            studyName: this.selected_study,
            snapshotType: this.selectedcompareacrossOption,
            isMandatoryLoadClicked:
              this.selectedcompareacrossOption == 'Multiple Markets' ||
                this.selectedcompareacrossOption == 'Multiple Categories'
                ? true
                : false,
          };
          //this.dataArray.push(clientStudyInfo);
          this.dataArray.push(clientStudyInfo);
          this._rebuildToggleStatusCache();
          //this.dataArray_Multiple.push(clientStudyInfo);
          this.loadBtnClick(false);

          // const variableTab = document.querySelector('.variableTab');
          // if (variableTab)
          //   variableTab.classList.remove('DN');
        }

        this.selectedObjects = [];
        this.variablesSummaryObj = [];
        this.variablesSummaryObjRadio = [];
      }
    }

    event?.stopPropagation();
  }

  errorPopup(message: string, headerTxt: string = 'Error'): void {
    const alertObj: AlertMessageModel = {
      header: headerTxt,
      message: message,
      show: true,
    };
    this._alertService.showAlert(alertObj);
  }

  togglePanel(Name: string, SelectedValue: string) {
    if (Name == 'study') {
      this.isStudyPanel = !this.isStudyPanel;
      this.isEntry_Point = false;
      this.entry_items_expand = '';
      this.sidePanelblock = false;
    }
  }
  selectedStudy(Name: string) {
    this.studyname = Name;
    this.selected_study = Name;
    this.isStudyPanel = true;
    this.configChanges(this.Reciveddata, Name);
    this.BindEntryData(this.Reciveddata, Name, this.selected_client, true);
    this.crossTabService.selectedStudyName.next(this.selected_study);
  }
  collapsePanel() {
    this.left_panel_collapse = true; //////
    this.iscompareacrossDropdownOpen = false;
    // const leftCollapseBlock = document.querySelector('.left-collapse-block');
    // if (leftCollapseBlock instanceof HTMLElement) {
    //   leftCollapseBlock.classList.remove('DN');
    // }
    // const leftPanelMainExpandBlock = document.querySelector(
    //   '.leftpanel-main-expand-block'
    // );
    // if (leftPanelMainExpandBlock instanceof HTMLElement) {
    //   leftPanelMainExpandBlock.classList.add('DN');
    // }

    this.valueChange.emit(this.left_panel_collapse);
  }
  expandPanel() {
    this.left_panel_collapse = false; /////
    // const leftCollapseBlock = document.querySelector('.left-collapse-block');
    // if (leftCollapseBlock instanceof HTMLElement) {
    //   leftCollapseBlock.classList.add('DN');
    // }
    // const leftPanelMainExpandBlock = document.querySelector(
    //   '.leftpanel-main-expand-block'
    // );
    // if (leftPanelMainExpandBlock instanceof HTMLElement) {
    //   leftPanelMainExpandBlock.classList.remove('DN');
    // }
    this.valueChange.emit(this.left_panel_collapse);
  }
  entrypointcollapse: boolean = false;
  toggleEntryPoint() {
    this.entrypointcollapse = !this.entrypointcollapse;
  }
  selectioncollapse: boolean = false;
  toggleSelection() {
    this.selectioncollapse = !this.selectioncollapse;
  }

  checkMaxLimit(lev: string) {
    // Count unique brands by Level2 to avoid double-counting mirrored Default/Brands entries
    const summaryArr = this.variablesSummaryObj;
    const uniqueBrandsCount = new Set(
      (summaryArr || []).filter((item: any) => item.Level0 === 'Brands').map((item: any) => item.Level2)
    ).size;
    const target = event?.target as HTMLElement;
    if (
      target?.className !== 'checkbox' &&
      target?.className !== 'sub-items-names-parent' &&
      uniqueBrandsCount >= 6
    ) {
      this.mandatoryMaxLimitReached = true;
    } else {
      this.mandatoryMaxLimitReached = false;
    }
  }
  variableExpand(variableName: string, level: number, nextLevelData?: any, typeData?: string, event?: Event) {
    if (variableName === 'Custom Percentage Variable - User Defined') {
      //remove custom percentage variable from left panel when clicked on it becuase it is giving duplicate data
      //this.BindLocalStorageVariableDataPanel();
    }
    event?.stopPropagation();
    this.sidePanelblock = false;
    this.mandatoryMaxLimitReached = false;
    this.entry_items_expand = '';
    this.entry_nested_items_expand = '';
    this.iscompareacrossDropdownOpen = false;

    // --- Handle toggle for the clicked level ---
    const expandVars = [
      'variable_expand', 'variable_expandLev1', 'variable_expandLev2',
      'variable_expandLev3', 'variable_expandLev4', 'variable_expandLev5',
      'variable_expandLev6', 'variable_expandLev7', 'variable_expandLev8',
      'variable_expandLev9'
    ] as const;
    const searchVars = [
      'searchVariable', 'searchVariable2', 'searchVariable3',
      'searchVariable4', 'searchVariable5', 'searchVariable6',
      'searchVariable7', 'searchVariable8', 'searchVariable9',
      'searchVariable10'
    ] as const;
    const searchFilVars = [
      'searchVariableFil', 'searchVariable2Fil', 'searchVariable3Fil',
      'searchVariable4Fil', 'searchVariable5Fil', 'searchVariable6Fil',
      'searchVariable7Fil', 'searchVariable8Fil', 'searchVariable9Fil',
      'searchVariable10Fil'
    ] as const;

    // Toggle the current level
    const currentVar = expandVars[level];
    if (this.is_variable_expand && (this as any)[currentVar] === variableName) {
      this.is_variable_expand = false;
      (this as any)[currentVar] = '';
      if (level === 0) {
        this.increaseLeftpanelHeight.emit({ isReset: true });
      }
    } else {
      (this as any)[currentVar] = variableName;
      this.is_variable_expand = true;
    }

    // Clear all child-level expand/search states in one pass
    for (let i = level + 1; i < expandVars.length; i++) {
      (this as any)[expandVars[i]] = '';
    }
    // Clear search for the next level and all below
    for (let i = level + 1; i < searchVars.length; i++) {
      (this as any)[searchVars[i]] = '';
    }
    // Clear filter-search from the appropriate start index
    const filStart = level === 0 ? 0 : level + 1;
    for (let i = filStart; i < searchFilVars.length; i++) {
      (this as any)[searchFilVars[i]] = '';
    }
    if (level === 0) {
      this.searchVariable = '';
    }

    // --- Level-specific side-effects ---
    if (level === 0) {
      // Compute header position once (it never moves)
      if (!this._topLev1Cache) {
        const divElement1 = document.querySelector('.variableHeader') as HTMLElement;
        if (divElement1) {
          const height = this.GetHeightAboveElement(divElement1);
          this._topLev1Cache = ((height / document.body.offsetHeight) * 100) + '%';
        }
      }
      if (this._topLev1Cache) {
        this.topLev1 = this._topLev1Cache;
      }
    } else if (level === 1) {
      // Compute sub-items panel position once (it never moves)
      if (!this._topCache) {
        const divElement = document.querySelector('.variables-sub-itemsLev1') as HTMLElement;
        if (divElement) {
          const height = this.GetHeightAboveElement(divElement);
          this._topCache = ((height / document.body.offsetHeight) * 100) + '%';
        }
      }
      if (this._topCache) {
        this.top = this._topCache;
      }
    } else if (level >= 3) {
      const currentExpanded = (this as any)[expandVars[level]];
      const isIncrease = currentExpanded !== '';
      if (level <= 4) {
        this.increaseLeftpanelHeight.emit({ isIncrease, isDecrease: !isIncrease, level });
        this.increaseLeftbgpanelWidth({ isIncrease, isDecrease: !isIncrease, level });
      } else if (level === 5) {
        this.increaseLeftpanelHeight.emit({ isIncrease, isDecrease: !isIncrease, level });
      }
      if (level >= 5) {
        // Use requestAnimationFrame instead of setTimeout for smoother scroll
        requestAnimationFrame(() => this.scrollToRightEnd());
      }
    }

    // --- Update max-limit entirely from data (no DOM queries) ---
    this.updateMaxLimit(variableName);

    // --- Highlight the clicked element ---
    const clickedElement = event?.target as HTMLElement;
    if (clickedElement) {
      if (this._lastSelectedTextClickEl) {
        this._lastSelectedTextClickEl.classList.remove('selectedTextClick');
        this._lastSelectedTextClickEl = null;
      }

      const nearestDiv =
        clickedElement.parentElement?.parentElement?.classList.contains('sub-items-block')
          ? clickedElement.parentElement!.parentElement as HTMLElement
          : clickedElement.parentElement?.classList.contains('sub-items-block')
            ? clickedElement.parentElement as HTMLElement
            : null;

      if (nearestDiv) {
        nearestDiv.classList.add('selectedTextClick');
        this._lastSelectedTextClickEl = nearestDiv;
      }
    }

    this.checkAndExpand(variableName, level, this.variable_expand === 'Audience', nextLevelData, typeData);
  }
  private updateMaxLimit(variableName: string) {
    // Count from data arrays — zero DOM queries
    const summaryArr = this.variablesSummaryObj;

    // Audience count with early exit
    let audienceCount = 0;
    if (summaryArr) {
      for (let i = 0, len = summaryArr.length; i < len; i++) {
        if (summaryArr[i].Level0 === 'Audience' && ++audienceCount >= 3) break;
      }
    }

    // Count unique brands by Level2 across both 'Brands' and 'Default' Level1 groups
    // (mirroring adds each brand twice, so deduplication by Level2 gives the real count)
    const uniqueBrandsCount = new Set(
      (summaryArr || []).filter((item: any) => item.Level0 === 'Brands').map((item: any) => item.Level2)
    ).size;

    this.audienceLimit = audienceCount >= 3;
    const isMultiCohortAudienceSnapshot = this.selectedcompareacrossOption === 'Audience Snapshot' && !this.isSingleaudienceCohortType;
    this.mandatoryMaxLimitReached = (variableName === 'Audience' || isMultiCohortAudienceSnapshot)
      ? audienceCount >= 3
      : uniqueBrandsCount >= 6;
  }
checkAndExpand(
  variableName: string,
  level: number,
  variableExpandIsAudience: boolean = false,
  nextLevelData: any = null,
  typeData: string = ''
) {
  let subValue = typeData !== 'filter' ? level + 1 : level;

  const nextLevel = nextLevelData?.[`Level${subValue}`];

  if (nextLevelData?.hasNextLevel && nextLevel?.length === 1) {
    const nextData = nextLevel[0];

    if (nextData?.hasNextLevel) {
      Promise.resolve().then(() => {
        this.variableExpand(
          nextData[`Level${subValue}_value`],
          level + 1,
          nextData,
          typeData
        );
        this.cdr.markForCheck();
      });
    }
  }
}
  // findItemInList(
  //   list: any[],
  //   variableName: string,
  //   targetLevel: number,
  //   currentLevel: number = 0,
  //   isFromFilter = false,
  // ): any | null {
  //   if (!list || list.length === 0) return null;

  //   if (list.some(item => `Level${targetLevel}` in item)) {
  //     for (const item of list) {
  //       let levelNumber = isFromFilter ? 0 : targetLevel;
  //       if (item[`Level${levelNumber}`] === variableName) {
  //         return item;
  //       }
  //       const nextLevel = currentLevel + 1;
  //       const childList = item[`Level${nextLevel}`];
  //       if (Array.isArray(childList) && childList.length != 0) {
  //         const found = this.findItemInList(childList, variableName, targetLevel, nextLevel, isFromFilter);
  //         if (found) return found;
  //       }
  //     }
  //   }
  //   return null;
  // }


  // getListForVariable(
  //   variableName: string,
  //   level: number
  // ): { item: any | null; fromFilter: boolean } {

  //   if (this.variableListMultiMarketAndCateg.length > 0) {
  //     const fromMulti = this.findItemInList(this.variableListMultiMarketAndCateg, variableName, level);
  //     if (fromMulti) return { item: fromMulti, fromFilter: false };
  //   }

  //   if (this.variableList.length > 0) {
  //     const fromList = this.findItemInList(this.variableList, variableName, level);
  //     if (fromList) return { item: fromList, fromFilter: false };
  //   }

  //   if (this.variableListFilter.length > 0) {
  //     const fromFilter = this.findItemInList(this.variableListFilter, variableName, level, 0, true);
  //     if (fromFilter) return { item: fromFilter, fromFilter: true };
  //   }

  //   return { item: null, fromFilter: false };
  // }
//   checkAndExpand(variableName: string, level: number, variableExpandIsAudience: boolean = false, nextLevelData: any = null,typeData:string='') {
//     let  subValue=level;
//       if(typeData !='filter')
//       {
//         subValue =level+1;
//       }
      
//       if (
//         nextLevelData.hasNextLevel &&
//         nextLevelData[`Level${subValue}`]?.length === 1
//       ) {
//         const nextData = nextLevelData[`Level${subValue}`][0];
//         if (nextData.hasNextLevel) {
//            setTimeout(() => {
//             this.variableExpand(
//             nextData[`Level${subValue}_value`],
//             level + 1,
//             nextData,
//             typeData
//           );
//            },0)
//         }
//       }
// }
  // checkAndExpand(variableName: string, level: number, variableExpandIsAudience:boolean = false) {
   // let { item: currentItem, fromFilter } = this.getListForVariable(variableName, level);
    // if (!currentItem) return;
    // if(variableExpandIsAudience){
    //   fromFilter = false;
    //  }
    // const nextLevel = fromFilter ? 1 : level + 1;
    // const nextList = currentItem[`Level${nextLevel}`];

    // if (nextList?.length === 1 && currentItem.hasNextLevel) {
    //   const nextData = nextList[0];
    //   this.variableExpand(nextData[`Level${nextLevel}_value`], level + 1);
    // }
  // }
  onItemClicked(event: MouseEvent) {
    if (this.selectedItem) {
      this.selectedItem.classList.remove('clicked');
    }
    this.selectedItem = event.currentTarget as HTMLElement;

    const hasNextLevelValue = this.selectedItem
      .getAttribute('data-hasNextLevel')
      ?.toString();
    const has_nextLevel = hasNextLevelValue === 'true'; // Consider 'true' as true, anything else as false

    const dimension = this.selectedItem
      .getAttribute('data-is_dimension')
      ?.toString();
    const is_dimension = dimension === 'true'; // Consider 'true' as true, anything else as false

    const iscustomGrpPresent = this.selectedItem
      .getAttribute('data-is_CustomGroup')
      ?.toString();
    const is_custmGrpPresent = iscustomGrpPresent === 'true';

    const isTimePeriodPresent = this.selectedItem
      .getAttribute('data-is_time_Period_Present')
      ?.toString();
    const is_Time_Period_Present = isTimePeriodPresent === 'true';
    this.selectedVariableLevel1.emit({
      tooltip: this.selectedItem.title,
      title: this.selectedItem.getAttribute('data-variable-name')?.toString(),
      Parent: this.selectedItem.getAttribute('data-attr')?.toString(),
      is_derived: this.selectedItem.getAttribute('data-is_derived')?.toString(),
      is_brand_analysis: this.selectedItem.getAttribute(
        'data-is_brand_analysis'
      ),
      is_calc_type: this.selectedItem
        .getAttribute('data-calc_type')
        ?.toString(),
      has_nextLevel,
      data_variable_code: this.selectedItem
        .getAttribute('data_variable_code')
        ?.toString(),
      data_response_code: this.selectedItem
        .getAttribute('data_response_code')
        ?.toString(),
      derived_metric_calculation: this.selectedItem
        .getAttribute('data_derived_metric_calculation')
        ?.toString(),
      data_sort_id: this.selectedItem.getAttribute('data_sort_id')?.toString(),
      data_is_multi_punch: this.selectedItem
        .getAttribute('data_is_multi_punch')
        ?.toString(),
      data_date: this.selectedItem.getAttribute('data_date')?.toString(),
      data_year_code: this.selectedItem
        .getAttribute('data_year_code')
        ?.toString(),
      is_dimension,
      is_custmGrpPresent,
      data_kibanaFilterScript: this.selectedItem
        .getAttribute('data-kibanaFilterScript')
        ?.toString(),
      data_customGroupId: this.selectedItem
        .getAttribute('data-customGroupId')
        ?.toString(),

      dataYearCode: this.selectedItem
        .getAttribute('data-dataYearCode')
        ?.toString(),
      is_Time_Period_Present,
      data_Weekno_forSigcalculation: this.selectedItem
        .getAttribute('data-Weekno_forSigcalculation')
        ?.toString(),
    });

    //this.selectedItem.classList.add('clicked');
  }

  MultipleloadBtnClick(
    isZeroEntryPoint: boolean,
    isNotSaved: boolean = true,
    clickFromButton: boolean = false
  ) {
    if (
      this.dataArray.length > 0 &&
      this.datarrayformultiplemarkorcategories.length == 0
    ) {
      this.datarrayformultiplemarkorcategories = _.cloneDeep(this.dataArray);
    } else if (
      this.dataArray.length > 0 &&
      this.datarrayformultiplemarkorcategories.length > 0 &&
      this.dataArray != this.datarrayformultiplemarkorcategories
    ) {
      this.dataArray = _.cloneDeep(this.datarrayformultiplemarkorcategories);
    }
    if (this.dataArray_Multiple.length == 0) {
      this.getValidation('2ndLoadClick');
    } else {
      let newDataArray = _.cloneDeep(this.dataArray);

      newDataArray.forEach((item) => {
        if (item.isMandatoryLoadClicked) item.isMandatoryLoadClicked = false;
      });

      this.dataArray_Multiple.forEach((item) => {
        newDataArray.push(item);
      });

      this.isVariableTab = true;
      this.is_load_btn = false;
      this.isEntry_Tab = false;
      this.sidePanelblock = false;
      this.isEntry_Point = false;
      this.entry_items_expand = '';
      this.variable_expand = '';
      this.variable_expandLev1 = '';
      this.variable_expandLev2 = '';
      this.variable_expandLev3 = '';
      this.variable_expandLev4 = '';
      this.variable_expandLev5 = '';
      this.variable_expandLev6 = '';
      this.variable_expandLev7 = '';
      this.variable_expandLev8 = '';
      this.variable_expandLev9 = '';

      this.btnVisible.emit({
        save: true,
        load: true,
        custom_groups: this.isconfigCustomGrpPresent ? true : false,
        custom_calc: false,
        create_table: true,
        weighted_btns: true,
      });

      this._loaderService.showLoader();
      if (this.$unSubscribeSubmitData2 && !this.$unSubscribeSubmitData2.closed) {
        this.$unSubscribeSubmitData2.unsubscribe();
      }

      // add snapshot_name, section_name, subsection_name to the request payload
      this.dataArray[0].snapshot_name = this.snapshotName;
      this.dataArray[0].section_name = this._configService.selectedSection;
      this.dataArray[0].subsection_name = this._configService.selectedSubSection == "NA" ? "" : this._configService.selectedSubSection;

      this.$unSubscribeSubmitData2 = this._configService
        .getSnapshotLeftPanelData(newDataArray)
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          if (data.Data !== '') {
            this.isAdditionalFeatures = true;
            let jsonLeftPanelData = JSON.parse(data.Data);
            jsonLeftPanelData = jsonLeftPanelData.filter(
              (item: any) => item.calculation_type?.toUpperCase() !== 'MEAN' && item.calculation_type?.toUpperCase() !== 'MEANPERCENTAGE'
            );
            this._configService.leftPanelData = jsonLeftPanelData;
            if (this.selectedcompareacrossOption == 'Multiple Markets') {
              this._configService.brandData = jsonLeftPanelData.filter(
                (item: any) => item.Level0 === 'Markets'
              );
              jsonLeftPanelData = jsonLeftPanelData.filter(
                (item: any) => item.Level0 != 'Markets'
              );
              
            } else if(this.selectedcompareacrossOption == 'Audience Snapshot'){
              this._configService.brandData = jsonLeftPanelData.filter(
                (item: any) => item.Level0 === 'Audience'
              );
              jsonLeftPanelData = jsonLeftPanelData.filter(
                (item: any) => item.Level0 != 'Audience'
              );
            }
              else {
              this._configService.brandData = jsonLeftPanelData.filter(
                (item: any) => item.Level0 === 'Brands'
              );
            }

            // Duplicate Brands items as "Default" with Level1 and Level2 set to 'Default'
            if (this.defaultBrandList?.length > 0) {
              const defaultBrandsItems = jsonLeftPanelData
                .filter((item: any) => item.Level0 === 'Brands')
                .map((item: any) => ({ ...item, Level1: 'Default', Level2: 'Default' }));
              jsonLeftPanelData = [...defaultBrandsItems, ...jsonLeftPanelData];
            }

            jsonLeftPanelData = jsonLeftPanelData.filter(
              (item: any) => item.is_snapshot === 1
            );
          
            this._configCustomService.uniqueMetricOptions = [
                  ...new Set(
                      jsonLeftPanelData.filter((a: any) => a.Level1 !== 'Brands' && a.Level1 !== 'Time Period').flatMap((item: any) => [  
                          item.Level2,
                          item.Level3,
                          item.Level4,
                          item.Level5,
                          item.Level6,
                          item.Level7,
                          item.MetricOption
                      ]).filter(Boolean)
                  )
            ]; 
const audienceRequired =
  (this._configService.outputSnapshotData?.audienceComparsion || []).some(
    (x: any) => x.is_selected
  ) ||
  this._configService.outputSnapshotData?.audienceTotalSample?.is_selected;

if (
  this.selectedcompareacrossOption === 'Audience Snapshot' &&
  !audienceRequired
) {
  jsonLeftPanelData = jsonLeftPanelData.filter(
    (item: any) => item.Level0 !== 'Audience'
  );
}

            this.BindVariableDataPanel(jsonLeftPanelData);
            if (this.isSavedScenarioSelected && isNotSaved) {
              //isZeroEntryPoint &&
              this.LoadSelectionVariableData();
            } else if (
              this._configService.isGlobalDefaultSelectionEnabled &&
              this._configService.globalDefaultSelectionFlag &&
              isNotSaved
            ) {
              this.GlobalDefaultSelection();
            }

            this.autoSelectDefaultBrands();

            this._configService.leftPanelSelectionsData = this.variableList;
            this.GetUniqueSelectionsList();
            this.CheckIfMandatorySelected();
            let weightOptions = this._configService.leftPanelData.filter(
              (lp: any) => lp.Level1 == 'Weight Metrics'
            );
            this._configService.weights?.forEach((wp: any) => {
              //if (wp.variable_code == "") {
              wp.key = wp.variable_label;
              //}
              let wop = weightOptions.find(
                (w1: any) => w1.data_variable_code == wp.variable_code
              );
              if (wop) {
                wp.key = wop.Level2;
              }
            });
            const variableTab = this.getVariableTabEl();
            if (variableTab) variableTab.classList.remove('DN');
          }
          if (
            clickFromButton ||
            (!this._configService.isGlobalDefaultSelectionEnabled &&
              !this.isSavedScenarioSelected)
          ) {
            this._loaderService.hideLoader();
          }
          //this._loaderService.hideLoader();
          this.cdr.markForCheck();
        });

      //disable Study Dropdown click Event
      this.isLoadSubmitted = true;
      this.showCancelBtn = false;

      if (
        !(
          this.selectedcompareacrossOption == 'Multiple Markets' ||
          this.selectedcompareacrossOption == 'Multiple Categories'
        )
      ) {
        this.selectedObjects = [];
        this.variablesSummaryObj = [];
        this.variablesSummaryObjRadio = [];
      }
    }
  }

  loadBtnClick(
    isZeroEntryPoint: boolean,
    isNotSaved: boolean = true,
    clickFromButton: boolean = false
  ) {
    // this.isLoader = true;
    this._loaderService.showLoader();
    if (
      isZeroEntryPoint &&
      (this.dataArray.length == 0 ||
        // this.dataArray.length != this.entryPanel.length
        this.dataArray.length < this.entryPanel.length)
    ) {
      // this.isLoader = false;
      this._loaderService.hideLoader();
      this.getValidation('EntryPoint');
    } else {
      this.isVariableTab = true;
      this.is_load_btn = false;
      this.isEntry_Tab = false;
      this.sidePanelblock = false;
      this.isEntry_Point = false;
      this.entry_items_expand = '';
      this.variable_expand = '';
      this.variable_expandLev1 = '';
      this.variable_expandLev2 = '';
      this.variable_expandLev3 = '';
      this.variable_expandLev4 = '';
      this.variable_expandLev5 = '';
      this.variable_expandLev6 = '';
      this.variable_expandLev7 = '';
      this.variable_expandLev8 = '';
      this.variable_expandLev9 = '';
      this.isTotalSampleAudienceActive = false;
      this.totalSampleObj.is_selected = false;
      this.IsEntrypointSelected.emit(true);

      this.btnVisible.emit({
        save: true,
        load: true,
        custom_groups: this.isconfigCustomGrpPresent ? true : false,
        custom_calc: false,
        create_table: true,
        weighted_btns: true,
      });

      this.entryListChange.emit(this.entryPanel);

      if (this.isMultiMarketOrCateg && this.selectedcompareacrossOption == 'Multiple Markets') {
        this.dataListChange.emit(this.dataArray_Multiple);
      } else {
        this.dataListChange.emit(this.dataArray);
      }
      this.dimensionListChange.emit(this.dimensionList);

      this._configService.getTopicsConfigurationBySnapshot({
        clientName: this.clientDetails.clientDetails.client_code,
        studyName: this.selected_study,
        snapshot_type: this._configService.snapshotSelectedName,
        section_name: this._configService.selectedSection,
        snapshot_name: this.snapshotName,
        subsection_name: this.subsectionselected ? this.subsectionselected : ''
      }).pipe(
        takeUntil(this.destroy$),
        catchError(() => of(null))
      ).subscribe((topicsConfig: any) => {
        if (topicsConfig?.Data) {
          this._configService.topicsConfigurationBySnapshot = JSON.parse(topicsConfig.Data);
          const allRows: any[] = (this._configService.topicsConfigurationBySnapshot?.rows || [])
            .filter((row: any) => row.configType !== CONFIG_TYPE.bips);

          // Extract selected EP Names from dataArray (EP is selected by the time loadBtnClick fires)
          const ep1Names: string[] = this.dataArray.find((e: any) => e.EntryPoint1)
            ?.EntryPoint1?.Level2?.flatMap((l2: any) => l2.MetricOptions?.map((mo: any) => mo.Name).filter(Boolean) || []) || [];
          const ep2Names: string[] = this.dataArray.find((e: any) => e.EntryPoint2)
            ?.EntryPoint2?.Level2?.flatMap((l2: any) => l2.MetricOptions?.map((mo: any) => mo.Name).filter(Boolean) || []) || [];
          const ep3Names: string[] = this.dataArray.find((e: any) => e.EntryPoint3)
            ?.EntryPoint3?.Level2?.flatMap((l2: any) => l2.MetricOptions?.map((mo: any) => mo.Name).filter(Boolean) || []) || [];

          const filteredRows = allRows.filter((row: any) => {
            const ep1Match = !ep1Names.length || !row.EntryPoint1 ||
              row.EntryPoint1.Level2?.some((l2: any) => l2.MetricOptions?.some((mo: any) => ep1Names.includes(mo.Name)));
            const ep2Match = !ep2Names.length || !row.EntryPoint2 ||
              row.EntryPoint2.Level2?.some((l2: any) => l2.MetricOptions?.some((mo: any) => ep2Names.includes(mo.Name)));
            const ep3Match = !ep3Names.length || !row.EntryPoint3 ||
              row.EntryPoint3.Level2?.some((l2: any) => l2.MetricOptions?.some((mo: any) => ep3Names.includes(mo.Name)));
            return ep1Match && ep2Match && ep3Match;
          });

          this.defaultBrandList = [...new Set(
            filteredRows.flatMap((row: any) => row.brandList || [])
          )];        

          if (this.variableList && this.variableList.length > 0) {
              const filterbrands = this.variableList
                    ?.find(a => a.Level0 === "Brands")
                    ?.Level1?.find((a: any) => a.Level1_value === "Brands")
                    ?.Level2?.map((a: any) => a.Level2_value) ?? [];

              this.defaultBrandList = this.defaultBrandList.filter((brand: string) =>
                  filterbrands.includes(brand)
                );
               this.autoSelectDefaultBrands();
          }
        } else {
          this._configService.topicsConfigurationBySnapshot = null;
          this.defaultBrandList = [];
        }
        this.cdr.markForCheck();
      });

      this._loaderService.showLoader();
      if (this.$unSubscribeSubmitData1 && !this.$unSubscribeSubmitData1.closed) {
        this.$unSubscribeSubmitData1.unsubscribe();
      }

      // add snapshot_name, section_name, subsection_name to the request payload
      this.dataArray[0].snapshot_name = this.snapshotName;
      this.dataArray[0].section_name = this._configService.selectedSection;
      this.dataArray[0].subsection_name = this._configService.selectedSubSection == "NA" ? "" : this._configService.selectedSubSection;

      // if this is audience snapshot then check if total sample is also present, if yes then pass its value
      let audienceFomCheck$: any = of(null);
      let audienceTotalSampleConfig: [string, string] | null = null;
      if (this.selectedcompareacrossOption == 'Audience Snapshot') {
        audienceTotalSampleConfig = this.getTotalSampleConfigKey();
        // totalSampleConfig is an array - ['Audience', 'Gender']. We need to pass the second value.
        if (audienceTotalSampleConfig && audienceTotalSampleConfig.length > 1) {
          this.dataArray[0].audienceTotalSampleVariableLabel = audienceTotalSampleConfig[1];

          audienceFomCheck$ = this._configService.checkSeparateFomExists({
            client_name: this.clientDetails.clientDetails.client_code,
            study_name: this.selected_study,
            snapshot_name: this.snapshotName,
            snapshot_type: sessionStorage.getItem('snapshotType'),
            section_name: this._configService.selectedSection,
            subsection_name: this._configService.selectedSubSection == "NA" ? '' : this._configService.selectedSubSection,
            includeData: true
          });
        }
      }

      this.$unSubscribeSubmitData1 = forkJoin({
        data: this._configService.getSnapshotLeftPanelData(this.dataArray),
        fom: audienceFomCheck$.pipe(catchError(() => of(null)))
      })
        .pipe(takeUntil(this.destroy$))
        .subscribe(({ data, fom }: any) => {
          if (data.Data !== '') {
            if (this.selectedcompareacrossOption != 'Multiple Markets') {
              this.isAdditionalFeatures = true;
            }
            let jsonLeftPanelData = JSON.parse(data.Data);

            if (this.selectedcompareacrossOption == 'Audience Snapshot' && fom?.exists && audienceTotalSampleConfig) {
              const [level0, level1] = audienceTotalSampleConfig;

              // 1. Extract & store all variables matching the total-sample config key (Level0/Level1)
              this._configService.audienceTotalSampleVariables = jsonLeftPanelData.filter(
                (item: any) =>
                  item.Level0?.trim() === level0 &&
                  item.Level1?.trim() === level1?.trim() ||
                  item.Level2?.trim() === level1?.trim() ||
                  item.Level3?.trim() === level1?.trim() ||
                  item.Level4?.trim() === level1?.trim()
              );

              // 2. Remove variables that were removed from the separate FOM (matched by data_variable_code + response_code)
              const removedRows: any[] = fom?.data?.variables_removed_from_fom ?? [];
              if (removedRows.length > 0) {
                const removedKeys = new Set<string>(
                  removedRows.map((r: any) => this.fomRemovedItemKey(r))
                );
                jsonLeftPanelData = jsonLeftPanelData.filter(
                  (item: any) => !removedKeys.has(this.leftPanelItemKey(item))
                );
              }
            }

            jsonLeftPanelData = jsonLeftPanelData.filter(
              (item: any) => item.calculation_type?.toUpperCase() !== 'MEAN' && item.calculation_type?.toUpperCase() !== 'MEANPERCENTAGE'
            );
            this._configService.leftPanelData = jsonLeftPanelData;
            if (this.selectedcompareacrossOption == 'Multiple Markets') {
              this._configService.brandData = jsonLeftPanelData.filter(
                (item: any) => item.Level0 === 'Markets'
              );
            } else {
              this._configService.brandData = jsonLeftPanelData.filter(
                (item: any) => item.Level0 === 'Brands'
              );
            }

       
            // Duplicate Brands items as "Default" with Level1 and Level2 set to 'Default'
            if (this.defaultBrandList?.length > 0) {
              const defaultBrandsItems = jsonLeftPanelData
                .filter((item: any) => item.Level0 === 'Brands')
                .map((item: any) => ({ ...item, Level1: 'Default', Level2: 'Default' }));
              jsonLeftPanelData = [...defaultBrandsItems, ...jsonLeftPanelData];
            }
            jsonLeftPanelData = jsonLeftPanelData.filter(
              (item: any) => item.is_snapshot === 1
            );
          
            this._configCustomService.uniqueMetricOptions = [
                    ...new Set(
                      jsonLeftPanelData.filter((a: any) => a.Level1 !== 'Brands' && a.Level1 !== 'Time Period').flatMap((item: any) => [
                          item.Level2,
                          item.Level3,
                          item.Level4,
                          item.Level5,
                          item.Level6,
                          item.Level7,
                          item.MetricOption
                      ]).filter(Boolean)
                  )
                ]; 

            if (
              this.selectedcompareacrossOption == 'Multiple Markets' ||
              this.selectedcompareacrossOption == 'Multiple Categories'
            ) {
              if (this.variableListMultiMarketAndCateg.length == 0) {
                this.BindVariableDataPanelMultiple(jsonLeftPanelData);
              }
            } else {this.BindVariableDataPanel(jsonLeftPanelData)};
            
           
            if (this.isSavedScenarioSelected && isNotSaved) {
              //isZeroEntryPoint
              this.LoadSelectionVariableData();
            } else if (
              this._configService.isGlobalDefaultSelectionEnabled &&
              this._configService.globalDefaultSelectionFlag &&
              isNotSaved
            ) {
              this.GlobalDefaultSelection();
            }

            this.autoSelectDefaultBrands();
            

            this._configService.leftPanelSelectionsData = this.variableList;
            this.GetUniqueSelectionsList();
            this.CheckIfMandatorySelected();
            let weightOptions = this._configService.leftPanelData.filter(
              (lp: any) => lp.Level1 == 'Weight Metrics'
            );
            this._configService.weights?.forEach((wp: any) => {
              //if (wp.variable_code == "") {
              wp.key = wp.variable_label;
              // }
              let wop = weightOptions.find(
                (w1: any) => w1.data_variable_code == wp.variable_code
              );
              if (wop) {
                wp.key = wop.Level2;
              }
            });
            const variableTab = this.getVariableTabEl();
            if (variableTab) variableTab.classList.remove('DN');
          }

          if (
            this.selectedcompareacrossOption == 'Multiple Markets' ||
            this.selectedcompareacrossOption == 'Multiple Categories'
          )
            this.isMultiMarketOrCateg = true;
          else this.isMultiMarketOrCateg = false;

          if (
            this.selectedcompareacrossOption == 'Audience Snapshot'
          )
            this.isAudienceSnapshot = true;
          else this.isAudienceSnapshot = false;



          if (
            clickFromButton ||
            (!this._configService.saveSelectionLoad &&
              !this._configService.isGlobalDefaultSelectionEnabled)
          ) {
            this._loaderService.hideLoader();
          } //-- removing this
          this._configService.saveSelectionLoad = false;
          // this.isLoader = false;
          this._loaderService.hideLoader();
          this.cdr.markForCheck();
        });

      //disable Study Dropdown click Event
      this.isLoadSubmitted = true;
      this.showCancelBtn = false;
      if (
        !(
          this.selectedcompareacrossOption == 'Multiple Markets' ||
          this.selectedcompareacrossOption == 'Multiple Categories'
        )
      ) {
        this.selectedObjects = [];
        this.variablesSummaryObj = [];
        this.variablesSummaryObjRadio = [];
      }
    }
  }

  private normalizeKey(value: any): string {
    return (value ?? '').toString().trim().toLowerCase();
  }

  private fomRemovedItemKey(row: any): string {
    return `${this.normalizeKey(row?.data_variable_code)}|${this.normalizeKey(row?.response_code)}`;
  }

  private leftPanelItemKey(item: any): string {
    return `${this.normalizeKey(item?.data_variable_code)}|${this.normalizeKey(item?.response_code)}`;
  }

  GetUniqueSelectionsList() {
    this.uniqueSelections = [
      ...new Set(
        this.variableList
          .filter(
            (a: any) =>
              a.isEntryPoint !== true &&
              a.Level0 !== '' &&
              a.Level0 !== 'Custom Group'
          )
          .map((a: any) => a.Level0)
      ),
    ];

    this.GetMandatorySelectionsList();
  }

  GetMandatorySelectionsList() {
    switch (this.selectedcompareacrossOption) {
      case 'Single Brand':
        this.singleorMultiSelectMandatory1 = 'Brands 1';
        this.timeperiodMandatory2 = 'Time Period';
        this.brandMandatory3 = '';
        break;
      case 'Multiple Brands':
        this.singleorMultiSelectMandatory1 = 'Brands 2';
        this.timeperiodMandatory2 = 'Time Period';
        this.brandMandatory3 = '';
        break;
      case 'Multiple Categories':
        this.singleorMultiSelectMandatory1 = 'Category 2';
        this.timeperiodMandatory2 = 'Time Period';
        this.brandMandatory3 = 'Brands 1';
        break;
      case 'Multiple Markets':
        this.singleorMultiSelectMandatory1 = 'Markets 2';
        this.timeperiodMandatory2 = 'Time Period';
        this.brandMandatory3 = 'Brands 1';
        break;
      case 'Audience Snapshot':
        this.singleorMultiSelectMandatory1 = 'Audience Snapshot';
        this.timeperiodMandatory2 = 'Time Period';
        this.brandMandatory3 = '';
        break;
      default:
        // Code for default case
        break;
    }
  }

  GetHeightAboveElement(element: HTMLElement): number {
    let height = 0;
    while (element) {
      height += element.offsetTop;
      element = element.offsetParent as HTMLElement;
    }
    return height;
  }

  OnCancelBtnClick() {
    this.showCancelBtn = false;
    this.cancelEntryPointChange.emit(true);
  }

  toggleMetricOptions(
    Level1: any,
    nestedEntry: any,
    event: MouseEvent,
    entryDetails: string
  ) {
    this.sidePanelblock = true;
    this.variable_expand = '';
    this.entry_nested_items_expand = nestedEntry;
    this.selectedItem = event.currentTarget as HTMLElement;

    this.metricOption = [];
    this.dataArray.forEach((entry) => {
      const metricOptionsList = entry['EntryPoint1']?.MetricOptions || [];

      metricOptionsList.forEach((data: MetricOptions) => {
        this.metricOption.push(data.Name);
      });
    });

    const uniqueMetricOptionsArray =
      entryDetails == 'entry1' ? [] : this.metricOption;

    if (this.entryList.length > 0) {
      const EntryData = _.filter(
        this.entryList,
        (item) =>
          item.Level1 !== null && item.Level1 !== '' && item.Level1 === Level1
      );
      if (uniqueMetricOptionsArray.length > 0) {
        if (EntryData.length > 0) {
          this.filterdEntryList = _.filter(
            EntryData[0].NestedEntryArray,
            (item) => item.Level2 !== null && item.Level2 === nestedEntry
          );

          this.filterdEntryList =
            EntryData[0].NestedEntryArray[0].MetricOptions.filter(
              (option: any) => {
                const optionCodes = option.e2_variable_code
                  .split(',')
                  .map((code: any) => code.trim());
                return optionCodes.some((code: any) =>
                  uniqueMetricOptionsArray.includes(code)
                );
              }
            );
        }
      } else {
        if (EntryData.length > 0) {
          this.filterdEntryList = _.filter(
            EntryData[0].NestedEntryArray,
            (item) => item.Level2 !== null && item.Level2 === nestedEntry
          );
        }
      }
    }
  }
  onSearchLevel(Name: string) {
    this.sidePanelblock = false;
    this.entry_nested_items_expand = '';
  }
  shouldHideItem(item: string): boolean {
    return item.toString().includes(this.searchMetricOption);
  }

  onSearchLevelHiding(Name: string) {
    const variablesSubItemsLev1 = document.querySelector(
      '.variables-sub-itemsLev' + Name
    );
    const selectedTextClick =
      variablesSubItemsLev1?.querySelector('.selectedTextClick');
    selectedTextClick?.classList.remove('selectedTextClick');

    switch (Name) {
      case '1':
        this.variable_expandLev1 = '';
        this.variable_expandLev2 = '';
        this.variable_expandLev3 = '';
        this.variable_expandLev4 = '';
        break;
      case '2':
        this.variable_expandLev2 = '';
        this.variable_expandLev3 = '';
        this.variable_expandLev4 = '';
        break;
      case '3':
        this.variable_expandLev3 = '';
        this.variable_expandLev4 = '';
        break;
      case '4':
        this.variable_expandLev4 = '';
        break;
    }
  }

  checkBoxClick(
    index: number,
    Level: number,
    Header: string,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    variableCode: string,
    responseCode: string,
    mandatory_variable_mapping: any[],
    isSelectAll: boolean,
    e1_variable_code: string,
    e2_variable_code: string,
    e3_variable_code: string,
    dimension: any[]
  ): void {
    // this.ResetClicked();
    if (this.selectedcompareacrossOption == 'Multiple Markets') {
      Level += 1;
    }
    const entryPointKey =
      Level === 0 ? 'EntryPoint1' : Level === 1 ? 'EntryPoint2' : 'EntryPoint3';

    if (Level === 0) {
      const entryPoint2Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint2')
      );
      if (entryPoint2Index !== -1) {
        const entryPoint2 = this.dataArray[entryPoint2Index];

        const level2Index = entryPoint2['EntryPoint2'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === MetricOptions
            )
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint2['EntryPoint2'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e1 === MetricOptions
          );
          if (metricOptionIndex !== -1) {
            entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint2['EntryPoint2'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint2['EntryPoint2'].Level2.length === 0) {
                this.dataArray.splice(entryPoint2Index, 1);

                const entryPoint3Index = this.dataArray.findIndex((entry) =>
                  entry.hasOwnProperty('EntryPoint3')
                );

                if (entryPoint3Index !== -1) {
                  this.dataArray.splice(entryPoint3Index, 1);
                }
              }
            }
          }
        }
      }

      const entryPoint3Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint3')
      );
      if (entryPoint3Index !== -1) {
        const entryPoint3 = this.dataArray[entryPoint3Index];

        const level2Index = entryPoint3['EntryPoint3'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === MetricOptions
            )
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint3['EntryPoint3'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e1 === MetricOptions
          );
          if (metricOptionIndex !== -1) {
            entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint3['EntryPoint3'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint3['EntryPoint3'].Level2.length === 0) {
                this.dataArray.splice(entryPoint3Index, 1);
              }
            }
          }
        }
      }
    } else if (Level === 1) {
      const entryPoint3Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint3')
      );
      if (entryPoint3Index !== -1) {
        const entryPoint3 = this.dataArray[entryPoint3Index];

        const level2Index = entryPoint3['EntryPoint3'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e2 === e2_variable_code
            )
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint3['EntryPoint3'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e2 === e2_variable_code
          );
          if (metricOptionIndex !== -1) {
            entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint3['EntryPoint3'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint3['EntryPoint3'].Level2.length === 0) {
                this.dataArray.splice(entryPoint3Index, 1);
              }
            }
          }
        }
      }
    }
    const existingEntryIndex = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1
    );

    if (existingEntryIndex !== -1) {
      // Entry with the same entryPointKey and Level1 exists
      const existingEntry = this.dataArray[existingEntryIndex];

      // Check if Level2 is different
      const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
        (l2: any) => l2.Parent === Level2
      );

      if (existingLevel2Index !== -1) {
        // Level2 with the same Parent exists
        const existingMetricOptionIndex = existingEntry[entryPointKey].Level2[
          existingLevel2Index
        ].MetricOptions.findIndex((mo: any) => mo.Name === MetricOptions);

        if (existingMetricOptionIndex !== -1) {
          // MetricOptions is the same, remove it
          if (isSelectAll == false) {
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.splice(existingMetricOptionIndex, 1);
          }
        } else {
          // MetricOptions is different, push it to the existing MetricOptions array

          const existingMetricOptionIndex = existingEntry[
            entryPointKey
          ].Level2.findIndex((mo: any) => {
            const existingMetricOptions = mo.MetricOptions;
            return existingMetricOptions.some(
              (existingMo: any) => existingMo.Name === MetricOptions
            );
          });

          if (existingMetricOptionIndex !== -1) {
            if (isSelectAll == false) {
            }
          } else {
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.push({
              Name: MetricOptions,
              responseCode: responseCode,
              isActive: true,
              Dependency_e1: e1_variable_code,
              Dependency_e2: e2_variable_code,
            });
          }
        }
      } else {
        const existingMetricOptionIndex = existingEntry[
          entryPointKey
        ].Level2.findIndex((mo: any) => {
          const existingMetricOptions = mo.MetricOptions;
          return (
            existingMetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions
            ) !== -1
          );
        });

        if (existingMetricOptionIndex !== -1) {
          if (isSelectAll == false) {
            const metricOptionIndex = existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions
            );
            existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.splice(metricOptionIndex, 1);
          }
        } else {
          // Level2 is different, push new Level2 and MetricOptions
          existingEntry[entryPointKey].Level2.push({
            Parent: Level2,
            MetricOptions: [
              {
                Name: MetricOptions,
                responseCode: responseCode,
                isActive: true,
                Dependency_e1: e1_variable_code,
                Dependency_e2: e2_variable_code,
              },
            ],
          });
        }
      }
    } else {
      // Create a new entry
      const tempEntry = {
        [entryPointKey]: {
          Level1: Level1,
          Level2: [
            {
              Parent: Level2,
              MetricOptions: [
                {
                  Name: MetricOptions,
                  responseCode: responseCode,
                  isActive: true,
                  Dependency_e1: e1_variable_code,
                  Dependency_e2: e2_variable_code,
                },
              ],
            },
          ],
          variableCode: variableCode,
        },
        clientName: this.clientDetails.clientDetails.client_code.toString(),
        studyName: this.selected_study,
        mandatory_variable_mapping: mandatory_variable_mapping,
        dimension: dimension,
        isMandatoryLoadClicked:
          this.selectedcompareacrossOption == 'Multiple Markets' ||
            this.selectedcompareacrossOption == 'Multiple Categories'
            ? true
            : false,
        snapshotType: this.selectedcompareacrossOption,
      };
      this.dataArray.push(tempEntry);
    }
    const existingEntryIndex1 = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1
    );

    const existingEntry = this.dataArray[existingEntryIndex1];

    const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
      (l2: any) => l2.Parent === Level2
    );
    if (
      this.entryPanel_Lvl3.filter(
        (a) => a.Level1 === Level1 && a.Level2 === Level2
      ).length ===
      (existingLevel2Index !== -1
        ? existingEntry[entryPointKey].Level2[existingLevel2Index]
          .MetricOptions.length
        : 0) &&
      isSelectAll == false
    ) {
      this.isSelectAll = true;
    } else {
      if (isSelectAll == false) {
        this.isSelectAll = false;
      }
    }
    this.updateSavedSelectionsFromData(this.selectedObjects);
    this._rebuildToggleStatusCache();
    this.cdr.detectChanges();
    // this.ResetClicked();
    this.ClearAll();
  }
  private hasReachedMultiSelectLimit(level0: string): boolean {
    if (this.selectedcompareacrossOption === 'Multiple Markets') {
      return this.isMarketLimitReached();
    }
    return this.variablesSummaryObj.length >= 6;
  }
  isMarketLimitReached(): boolean {
    return (
      this.selectedcompareacrossOption === 'Multiple Markets' &&
      this.getSelectedMarketCount() >= 6
    );
  }

  private getSelectedMarketCount(): number {
    let countByIsSelected = 0;
    const marketGroup = this.variableListMultiMarketAndCateg?.find(
      (v: any) => v.Level0 === 'Markets'
    );
    if (marketGroup && Array.isArray(marketGroup.Level1)) {
      for (const level1 of marketGroup.Level1) {
        if (Array.isArray(level1?.Level2)) {
          for (const level2 of level1.Level2) {
            if (level2?.is_selected) {
              countByIsSelected += 1;
            }
          }
        }
      }
    }
    let countByStore = 0;
    const marketStore = this.selectedObjects?.find(
      (o: any) => Array.isArray(o?.['Markets'])
    );
    if (marketStore) {
      countByStore = marketStore['Markets'].length;
    }

    return Math.max(countByIsSelected, countByStore);
  }

  checkBoxClickMultiple(
    event: any,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    variableCode: string,
    responseCode1: string,
    level1: string,
    level2: string,
    level3: string,
    level4: string,
    level5: string,
    level0: string = '',
    loadSel: boolean = false,
    SelectionFilterData: any = {},
    Level = 0,
    isSelectAll = false
  ): void {
    let numberOfCheckedCheckboxes;
    if (!loadSel) {
      const nearestLevelDiv = (event.target as HTMLElement).closest(
        'div[class*="variables-sub-itemsLev"]'
      );
      const checkedCheckboxes = nearestLevelDiv?.querySelectorAll(
        'input[type="checkbox"]:checked'
      );
      numberOfCheckedCheckboxes = checkedCheckboxes?.length;
    }

    let entryPointKey = this.EPdataFor_Multiple.filter((a: any) =>
      a.variable_code.includes(variableCode)
    )
      .map((a: any) => a.variable_label)[0]
      ?.replaceAll(' ', '');

    //crosstab EP code start

    if (Level === 0) {
      const entryPoint2Index = this.dataArray_Multiple.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint2')
      );
      if (entryPoint2Index !== -1) {
        const entryPoint2 = this.dataArray_Multiple[entryPoint2Index];

        const level2Index = entryPoint2['EntryPoint2'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === MetricOptions
            )
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint2['EntryPoint2'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e1 === MetricOptions
          );
          if (metricOptionIndex !== -1) {
            entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint2['EntryPoint2'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint2['EntryPoint2'].Level2.length === 0) {
                this.dataArray_Multiple.splice(entryPoint2Index, 1);

                const entryPoint3Index = this.dataArray_Multiple.findIndex(
                  (entry) => entry.hasOwnProperty('EntryPoint3')
                );

                if (entryPoint3Index !== -1) {
                  this.dataArray_Multiple.splice(entryPoint3Index, 1);
                }
              }
            }
          }
        }
      }

      const entryPoint3Index = this.dataArray_Multiple.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint3')
      );
      if (entryPoint3Index !== -1) {
        const entryPoint3 = this.dataArray_Multiple[entryPoint3Index];

        const level2Index = entryPoint3['EntryPoint3'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === MetricOptions
            )
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint3['EntryPoint3'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e1 === MetricOptions
          );
          if (metricOptionIndex !== -1) {
            entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint3['EntryPoint3'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint3['EntryPoint3'].Level2.length === 0) {
                this.dataArray_Multiple.splice(entryPoint3Index, 1);
              }
            }
          }
        }
      }
    }
    const existingEntryIndex = this.dataArray_Multiple.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1
    );

    if (existingEntryIndex !== -1) {
      // Entry with the same entryPointKey and Level1 exists
      const existingEntry = this.dataArray_Multiple[existingEntryIndex];

      // Check if Level2 is different
      const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
        (l2: any) => l2.Parent === Level2
      );

      if (existingLevel2Index !== -1) {
        // Level2 with the same Parent exists
        const existingMetricOptionIndex = existingEntry[entryPointKey].Level2[
          existingLevel2Index
        ].MetricOptions.findIndex((mo: any) => mo.Name === MetricOptions);

        if (existingMetricOptionIndex !== -1) {
          // MetricOptions is the same, remove it
          if (isSelectAll == false) {
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.splice(existingMetricOptionIndex, 1);
          }
        } else {
          // MetricOptions is different, push it to the existing MetricOptions array

          const existingMetricOptionIndex = existingEntry[
            entryPointKey
          ].Level2.findIndex((mo: any) => {
            const existingMetricOptions = mo.MetricOptions;
            return existingMetricOptions.some(
              (existingMo: any) => existingMo.Name === MetricOptions
            );
          });

          if (existingMetricOptionIndex !== -1) {
            if (isSelectAll == false) {
            }
          } else {
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.push({
              Name: MetricOptions,
              responseCode: responseCode1,
              isActive: true,
              Dependency_e1: this.e1_forMultiple,
              Dependency_e2: this.e2_forMultiple,
            });
          }
        }
      } else {
        const existingMetricOptionIndex = existingEntry[
          entryPointKey
        ].Level2.findIndex((mo: any) => {
          const existingMetricOptions = mo.MetricOptions;
          return (
            existingMetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions
            ) !== -1
          );
        });

        if (existingMetricOptionIndex !== -1) {
          if (isSelectAll == false) {
            const metricOptionIndex = existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions
            );
            existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.splice(metricOptionIndex, 1);
          }
        } else {
          // Level2 is different, push new Level2 and MetricOptions
          existingEntry[entryPointKey].Level2.push({
            Parent: Level2,
            MetricOptions: [
              {
                Name: MetricOptions,
                responseCode: responseCode1,
                isActive: true,
                Dependency_e1: this.e1_forMultiple,
                Dependency_e2: this.e2_forMultiple,
              },
            ],
          });
        }
      }
    } else {
      // Create a new entry
      const tempEntry = {
        [entryPointKey]: {
          Level1: Level1,
          Level2: [
            {
              Parent: Level2,
              MetricOptions: [
                {
                  Name: MetricOptions,
                  responseCode: responseCode1,
                  isActive: true,
                  Dependency_e1: this.e1_forMultiple,
                  Dependency_e2: this.e2_forMultiple,
                },
              ],
            },
          ],
          variableCode: variableCode,
        },
        clientName: this.clientDetails.clientDetails.client_code.toString(),
        studyName: this.selected_study,
        mandatory_variable_mapping: this.mandatory_variable_mapping_Multiple,
        dimension: this.dimension_Multiple,
        isMandatoryLoadClicked: false,
        snapshotType: this.selectedcompareacrossOption,
      };
      this.dataArray_Multiple.push(tempEntry);
    }

    //crosstab EP code end

    let responseCode,
      variableLabel,
      year_code,
      is_brand_analysis,
      is_derived,
      calc_type,
      hasNextLevel,
      variable_code,
      sort_id,
      is_multi_punch,
      date,
      is_dimension,
      is_CustomGroup,
      kibanaFilterScript,
      customGroupId,
      dataYearCode,
      is_time_Period_Present,
      derived_metric_calculation,
      isSelected;

    if (!loadSel) {
      if (
        (event.target as HTMLElement).classList.contains(
          'sub-items-names-parent'
        )
      ) {
        let elementParent = (event.target as HTMLElement).parentElement;

        responseCode = elementParent?.getAttribute('data_response_code');
        derived_metric_calculation = elementParent?.getAttribute(
          'data_derived_metric_calculation'
        );
        variableLabel = elementParent?.getAttribute('data-variable-name');
        year_code = elementParent?.getAttribute('data_year_code');

        is_brand_analysis = elementParent?.getAttribute(
          'data-is_brand_analysis'
        );
        is_derived = elementParent?.getAttribute('data-is_derived');
        calc_type = elementParent?.getAttribute('data-calc_type');
        hasNextLevel = elementParent?.getAttribute('data-hasNextLevel');
        variable_code = elementParent?.getAttribute('data_variable_code');

        sort_id = elementParent?.getAttribute('data_sort_id');
        is_multi_punch = elementParent?.getAttribute('data_is_multi_punch');
        date = elementParent?.getAttribute('data_date');
        is_dimension = elementParent?.getAttribute('data-is_dimension');
        is_CustomGroup = elementParent?.getAttribute('data-is_CustomGroup');

        kibanaFilterScript = elementParent?.getAttribute(
          'data-kibanaFilterScript'
        );
        customGroupId = elementParent?.getAttribute('data-customGroupId');
        dataYearCode = elementParent?.getAttribute('data-dataYearCode');
        is_time_Period_Present = elementParent?.getAttribute(
          'data-is_time_Period_Present'
        );

        isSelected = elementParent?.getAttribute('data-is_selected');
      } else {
        let elementParent = (event.target as HTMLElement).parentElement
          ?.parentElement;

        responseCode = elementParent?.getAttribute('data_response_code');
        derived_metric_calculation = elementParent?.getAttribute(
          'data_derived_metric_calculation'
        );

        variableLabel = elementParent?.getAttribute('data-variable-name');
        year_code = elementParent?.getAttribute('data_year_code');

        is_brand_analysis = elementParent?.getAttribute(
          'data-is_brand_analysis'
        );
        is_derived = elementParent?.getAttribute('data-is_derived');
        calc_type = elementParent?.getAttribute('data-calc_type');
        hasNextLevel = elementParent?.getAttribute('data-hasNextLevel');
        variable_code = elementParent?.getAttribute('data_variable_code');

        sort_id = elementParent?.getAttribute('data_sort_id');
        is_multi_punch = elementParent?.getAttribute('data_is_multi_punch');
        date = elementParent?.getAttribute('data_date');
        is_dimension = elementParent?.getAttribute('data-is_dimension');
        is_CustomGroup = elementParent?.getAttribute('data-is_CustomGroup');

        kibanaFilterScript = elementParent?.getAttribute(
          'data-kibanaFilterScript'
        );
        customGroupId = elementParent?.getAttribute('data-customGroupId');
        dataYearCode = elementParent?.getAttribute('data-dataYearCode');
        is_time_Period_Present = elementParent?.getAttribute(
          'data-is_time_Period_Present'
        );

        isSelected = elementParent?.getAttribute('data-is_selected');
      }
    } else {
      responseCode = SelectionFilterData.response_code;
      derived_metric_calculation =
        SelectionFilterData.derived_metric_calculation;
      variableLabel = SelectionFilterData.variable_label;
      Level0: level0;
      level1 = SelectionFilterData.Level1;
      level2 = SelectionFilterData.Level2;
      level3 = SelectionFilterData.Level3;
      level4 = SelectionFilterData.Level4;
      level5 = SelectionFilterData.Level5;
      year_code = SelectionFilterData.year_code;
      is_brand_analysis = SelectionFilterData.is_brand_analysis;
      is_derived = SelectionFilterData.is_derived;
      calc_type = SelectionFilterData.calc_type;
      hasNextLevel = SelectionFilterData.hasNextLevel;
      variable_code = SelectionFilterData.variable_code;
      sort_id = SelectionFilterData.sort_id;
      is_multi_punch = SelectionFilterData.is_multi_punch;
      date = SelectionFilterData.date;
      is_dimension = SelectionFilterData.s_dimension;
      is_CustomGroup = SelectionFilterData.is_CustomGroup;
      kibanaFilterScript = SelectionFilterData.kibanaFilterScript;
      customGroupId = SelectionFilterData.customGroupId;
      dataYearCode = SelectionFilterData.dataYearCode;
      is_time_Period_Present = SelectionFilterData.is_time_Period_Present;
      isSelected = false;
    }

    const selectedData = {
      response_code: responseCode,
      derived_metric_calculation: derived_metric_calculation,
      variable_label: variableLabel,
      Level0: level0,
      Level1: level1,
      Level2: level2,
      Level3: level3,
      Level4: level4,
      Level5: level5,
      year_code: year_code,
      is_brand_analysis: is_brand_analysis,
      is_derived: is_derived,
      calc_type: calc_type,
      hasNextLevel: hasNextLevel,
      variable_code: variable_code,
      sort_id: sort_id,
      is_multi_punch: is_multi_punch,
      date: date,
      is_dimension: is_dimension,
      is_CustomGroup: is_CustomGroup,
      kibanaFilterScript: kibanaFilterScript,
      customGroupId: customGroupId,
      dataYearCode: dataYearCode,
      is_time_Period_Present: is_time_Period_Present,
    };

    if (event?.target != null) {
      if (
        (event?.target as HTMLElement).classList.contains(
          'sub-items-names-parent'
        )
      ) {
        let elementParent = (event.target as HTMLElement).parentElement;
        isSelected = elementParent?.getAttribute('data-is_selected');
      } else {
        let elementParent = (event.target as HTMLElement).parentElement
          ?.parentElement;
        isSelected = elementParent?.getAttribute('data-is_selected');
      }
    }

    if (isSelected !== 'true') {
      // Prevent selecting beyond the 6-market limit during user interactions
      if (!loadSel && this.hasReachedMultiSelectLimit(selectedData.Level0)) {
        return;
      }
      if (this.selectedObjects.some((obj) => obj[selectedData.Level0])) {
        const selectedObj = this.selectedObjects.find(
          (obj) => obj[selectedData.Level0]
        );
        // Check if data already exists before pushing
        const dataExists = selectedObj[selectedData.Level0].some((item: any) => {
          return (
            item.response_code == selectedData.response_code &&
            item.variable_label == selectedData.variable_label &&
            item.Level1 == selectedData.Level1 &&
            item.Level2 == selectedData.Level2 &&
            item.Level3 == selectedData.Level3 &&
            item.Level4 == selectedData.Level4 &&
            item.Level5 == selectedData.Level5
          );
        });
        if (!dataExists) {
          selectedObj[selectedData.Level0].push(selectedData);
        }
      } else {
        this.selectedObjects.push({ [selectedData.Level0]: [selectedData] });
      }

      // Create a new entry for 2nd load
      // const tempEntry = {
      //   [entryPointKey]: {
      //     Level1: Level1,
      //     Level2: [
      //       {
      //         Parent: Level2,
      //         MetricOptions: [
      //           {
      //             Name: MetricOptions,
      //             responseCode: responseCode1,
      //             isActive: true,
      //             Dependency_e1: this.e1_forMultiple,
      //             Dependency_e2: this.e2_forMultiple,
      //           },
      //         ],
      //       },
      //     ],
      //     variableCode: variableCode,
      //   },
      //   clientName: this.clientDetails.clientDetails.client_code
      //     .toString()
      //     .toLowerCase(),
      //   studyName: this.selected_study,
      //   mandatory_variable_mapping: this.mandatory_variable_mapping_Multiple,
      //   dimension: this.dimension_Multiple,
      //   isMandatoryLoadClicked: false,
      //   snapshotType: this.selectedcompareacrossOption
      // };
      // this.dataArray_Multiple.push(tempEntry);

      this.SwitchMakeSelectedTrueMultiple(selectedData, 'NOTfilters');

      this.variablesSummaryObj.push(selectedData);

      this.mandatoryMaxLimitReached = this.hasReachedMultiSelectLimit(selectedData.Level0);
      this.cdr.markForCheck();
    } else {
      const selectedObj = this.selectedObjects.find(
        (obj) => obj[selectedData.Level0]
      );
      if (selectedObj) {
        const index = selectedObj[selectedData.Level0].findIndex(
          (item: any) => {
            if (
              item.response_code == selectedData.response_code &&
              item.variable_label == selectedData.variable_label &&
              item.Level0 == selectedData.Level0 &&
              item.Level1 == selectedData.Level1 &&
              item.Level2 == selectedData.Level2 &&
              item.Level3 == selectedData.Level3 &&
              item.Level4 == selectedData.Level4 &&
              item.Level5 == selectedData.Level5
            )
              return item;
          }
        );
        if (index !== -1) {
          selectedObj[selectedData.Level0].splice(index, 1);
        }
      }

      //remove entry from the 2ne load object
      // const index = this.dataArray_Multiple.findIndex(
      //   (item: any) => {
      //     if (item[entryPointKey].variableCode == variableCode && item[entryPointKey].Level2.filter((a: any) => a.MetricOptions.filter((b: any) => b.responseCode == responseCode1)).length > 0)
      //       return item;
      //   }
      // );
      // if (index !== -1) {
      //   this.dataArray_Multiple.splice(index, 1);
      // }

      this.SwitchMakeSelectedFalseMultiple(selectedData, 'NOTfilters');

      this.variablesSummaryObj = this.variablesSummaryObj.filter(
        (item: any) => {
          if (
            !(
              item.response_code == selectedData.response_code &&
              item.variable_label == selectedData.variable_label &&
              item.Level1 == selectedData.Level1 &&
              item.Level2 == selectedData.Level2 &&
              item.Level3 == selectedData.Level3 &&
              item.Level4 == selectedData.Level4 &&
              item.Level5 == selectedData.Level5
            )
          )
            return item;
        }
      );

      this.mandatoryMaxLimitReached = this.hasReachedMultiSelectLimit(selectedData.Level0);
      this.cdr.markForCheck();
    }

    (event as MouseEvent).stopPropagation();
    this.CheckIfMandatorySelected();
  }

  EPRadioClick(
    index: number,
    Level: number,
    Header: string,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    variableCode: string,
    responseCode: string,
    mandatory_variable_mapping: any[],
    isSelectAll: boolean,
    e1_variable_code: string,
    e2_variable_code: string,
    e3_variable_code: string,
    dimension: any[]
  ): void {
    // const entryPointKey =
    //   Level === 0 ? 'EntryPoint1' : Level === 1 ? 'EntryPoint2' : 'EntryPoint3';

    let entryPointKey = this.EPdataFor_Multiple.filter((a: any) =>
      a.variable_code.includes(variableCode)
    )
      .map((a: any) => a.variable_label)[0]
      .replaceAll(' ', '');

    if (Level === 0) {
      if (this.dataArray.length > 0) {
        if (
          this.dataArray[0].EntryPoint1 != undefined &&
          Object.keys(this.dataArray[0].EntryPoint1).length !== 0 &&
          this.dataArray[0].EntryPoint1.Level2[0].MetricOptions[0].Name ==
          MetricOptions
        ) {
          return;
        } else if (
          (this.isSavedScenarioSelected ||
            this._configService.isGlobalDefaultSelectionEnabled) &&
          this.selectedcompareacrossOption == 'Multiple Markets'
        ) {
          if (
            this.dataArray[0].EntryPoint2 != undefined &&
            Object.keys(this.dataArray[0].EntryPoint2).length !== 0 &&
            this.dataArray[0].EntryPoint2.Level2[0].MetricOptions[0].Name ==
            MetricOptions
          ) {
            return;
          }
        }
        if (this.dataArray[0].EntryPoint1 != undefined) {
          this.dataArray[0].EntryPoint1 = {};
        }
      }

      const entryPoint2Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint2')
      );
      if (entryPoint2Index !== -1) {
        const entryPoint2 = this.dataArray[entryPoint2Index];

        const level2Index = entryPoint2['EntryPoint2'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === MetricOptions
            )
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint2['EntryPoint2'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e1 === MetricOptions
          );
          if (metricOptionIndex !== -1) {
            entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint2['EntryPoint2'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint2['EntryPoint2'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint2['EntryPoint2'].Level2.length === 0) {
                this.dataArray.splice(entryPoint2Index, 1);

                const entryPoint3Index = this.dataArray.findIndex((entry) =>
                  entry.hasOwnProperty('EntryPoint3')
                );

                if (entryPoint3Index !== -1) {
                  this.dataArray.splice(entryPoint3Index, 1);
                }
              }
            }
          }
        }
        //const recordIndexToRemove = entryPoint2['EntryPoint2'].Level2.findIndex(
        //  (l2: any) =>
        //    l2.MetricOptions.some(
        //      (mo: any) => mo.Dependency === MetricOptions
        //    )
        //);
        //if (recordIndexToRemove !== -1) {
        //  entryPoint2['EntryPoint2'].Level2.splice(recordIndexToRemove, 1);
        //}
        //if (entryPoint2['EntryPoint2'].Level2.length === 0) {
        //  this.dataArray.splice(entryPoint2Index, 1);
        //}
      }

      const entryPoint3Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint3')
      );
      if (entryPoint3Index !== -1) {
        const entryPoint3 = this.dataArray[entryPoint3Index];

        const level2Index = entryPoint3['EntryPoint3'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e1 === MetricOptions
            )
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint3['EntryPoint3'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e1 === MetricOptions
          );
          if (metricOptionIndex !== -1) {
            entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint3['EntryPoint3'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint3['EntryPoint3'].Level2.length === 0) {
                this.dataArray.splice(entryPoint3Index, 1);
              }
            }
          }
        }
      }
    } else if (Level === 1) {
      if (this.dataArray.length > 1) {
        if (
          this.dataArray[1].EntryPoint2.Level2[0].MetricOptions[0].Name ==
          MetricOptions
        ) {
          return;
        }
        this.dataArray[1].EntryPoint2 = {};
      }

      const entryPoint3Index = this.dataArray.findIndex((entry) =>
        entry.hasOwnProperty('EntryPoint3')
      );
      if (entryPoint3Index !== -1) {
        const entryPoint3 = this.dataArray[entryPoint3Index];

        const level2Index = entryPoint3['EntryPoint3'].Level2.findIndex(
          (l2: any) =>
            l2.MetricOptions.some(
              (mo: any) => mo.Dependency_e2 === e2_variable_code
            )
        );

        if (level2Index !== -1) {
          const metricOptionIndex = entryPoint3['EntryPoint3'].Level2[
            level2Index
          ].MetricOptions.findIndex(
            (mo: any) => mo.Dependency_e2 === e2_variable_code
          );
          if (metricOptionIndex !== -1) {
            entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions.splice(
              metricOptionIndex,
              1
            );

            // Check if Level2 length is 0, then remove the entire entryPoint2
            if (
              entryPoint3['EntryPoint3'].Level2[level2Index].MetricOptions
                .length === 0
            ) {
              entryPoint3['EntryPoint3'].Level2.splice(level2Index, 1);

              // Check if Level2 length is 0, then remove the entire entryPoint2
              if (entryPoint3['EntryPoint3'].Level2.length === 0) {
                this.dataArray.splice(entryPoint3Index, 1);
              }
            }
          }
        }
      }
    } else if (Level === 2) {
      if (this.dataArray.length > 2) {
        if (
          this.dataArray[2].EntryPoint3.Level2[0].MetricOptions[0].Name ==
          MetricOptions
        ) {
          return;
        }
        this.dataArray[2].EntryPoint3 = {};
      }
    }

    if (Level == 0) {
      this.entry_nested_items_expand1 = Level2;
    } else if (Level == 1) {
      this.entry_nested_items_expand2 = Level2;
    } else if (Level == 2) {
      this.entry_nested_items_expand3 = Level2;
    }

    const existingEntryIndex = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1
    );

    if (existingEntryIndex !== -1) {
      // Entry with the same entryPointKey and Level1 exists
      const existingEntry = this.dataArray[existingEntryIndex];

      // Check if Level2 is different
      const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
        (l2: any) => l2.Parent === Level2
      );

      if (existingLevel2Index !== -1) {
        // Level2 with the same Parent exists
        const existingMetricOptionIndex = existingEntry[entryPointKey].Level2[
          existingLevel2Index
        ].MetricOptions.findIndex((mo: any) => mo.Name === MetricOptions);

        if (existingMetricOptionIndex !== -1) {
          // MetricOptions is the same, remove it
          if (isSelectAll == false) {
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.splice(existingMetricOptionIndex, 1);
          }
        } else {
          // MetricOptions is different, push it to the existing MetricOptions array

          const existingMetricOptionIndex = existingEntry[
            entryPointKey
          ].Level2.findIndex((mo: any) => {
            const existingMetricOptions = mo.MetricOptions;
            return existingMetricOptions.some(
              (existingMo: any) => existingMo.Name === MetricOptions
            );
          });

          if (existingMetricOptionIndex !== -1) {
            if (isSelectAll == false) {
            }
          } else {
            //since single select
            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions = [];

            existingEntry[entryPointKey].Level2[
              existingLevel2Index
            ].MetricOptions.push({
              Name: MetricOptions,
              responseCode: responseCode,
              isActive: true,
              Dependency_e1: e1_variable_code,
              Dependency_e2: e2_variable_code,
            });

            if (entryPointKey == 'EntryPoint1')
              this.selectedEP1 = MetricOptions;
            else if (entryPointKey == 'EntryPoint2')
              this.selectedEP2 = MetricOptions;
            else if (entryPointKey == 'EntryPoint3')
              this.selectedEP3 = MetricOptions;
          }
        }
      } else {
        const existingMetricOptionIndex = existingEntry[
          entryPointKey
        ].Level2.findIndex((mo: any) => {
          const existingMetricOptions = mo.MetricOptions;
          return (
            existingMetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions
            ) !== -1
          );
        });

        if (existingMetricOptionIndex !== -1) {
          if (isSelectAll == false) {
            const metricOptionIndex = existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.findIndex(
              (existingMo: any) => existingMo.Name === MetricOptions
            );
            existingEntry[entryPointKey].Level2[
              existingMetricOptionIndex
            ].MetricOptions.splice(metricOptionIndex, 1);
          }
        } else {
          //since single select
          existingEntry[entryPointKey].Level2 = [];

          // Level2 is different, push new Level2 and MetricOptions
          existingEntry[entryPointKey].Level2.push({
            Parent: Level2,
            MetricOptions: [
              {
                Name: MetricOptions,
                responseCode: responseCode,
                isActive: true,
                Dependency_e1: e1_variable_code,
                Dependency_e2: e2_variable_code,
              },
            ],
          });

          if (entryPointKey == 'EntryPoint1') this.selectedEP1 = MetricOptions;
          else if (entryPointKey == 'EntryPoint2')
            this.selectedEP2 = MetricOptions;
          else if (entryPointKey == 'EntryPoint3')
            this.selectedEP3 = MetricOptions;
        }
      }
    } else {
      // Create a new entry
      if (this.dataArray.some((entry) => entry.hasOwnProperty(entryPointKey))) {
        const existingEntryIndex = this.dataArray.findIndex((entry) =>
          entry.hasOwnProperty(entryPointKey)
        );
        if (existingEntryIndex !== -1) {
          const existingEntry = this.dataArray[existingEntryIndex];
          existingEntry[entryPointKey] = Object.assign(
            {},
            existingEntry[entryPointKey]
          );
          existingEntry[entryPointKey].Level1 = Level1;
          existingEntry[entryPointKey].Level2 = [];
          existingEntry[entryPointKey].Level2.push({
            Parent: Level2,
            MetricOptions: [
              {
                Name: MetricOptions,
                responseCode: responseCode,
                isActive: true,
                Dependency_e1: e1_variable_code,
                Dependency_e2: e2_variable_code,
              },
            ],
          });
          existingEntry[entryPointKey].variableCode = variableCode;
        }
      } else {
        const tempEntry = {
          [entryPointKey]: {
            Level1: Level1,
            Level2: [
              {
                Parent: Level2,
                MetricOptions: [
                  {
                    Name: MetricOptions,
                    responseCode: responseCode,
                    isActive: true,
                    Dependency_e1: e1_variable_code,
                    Dependency_e2: e2_variable_code,
                  },
                ],
              },
            ],
            variableCode: variableCode,
          },
          clientName: this.clientDetails.clientDetails.client_code.toString(),
          studyName: this.selected_study,
          mandatory_variable_mapping: mandatory_variable_mapping,
          dimension: dimension,
          isMandatoryLoadClicked:
            this.selectedcompareacrossOption == 'Multiple Markets' ||
              this.selectedcompareacrossOption == 'Multiple Categories'
              ? true
              : false,
          snapshotType: this.selectedcompareacrossOption,
        };
        this.dataArray.push(tempEntry);
        this.e1_forMultiple = e1_variable_code;
        this.e2_forMultiple = e2_variable_code;
        this.mandatory_variable_mapping_Multiple = mandatory_variable_mapping;
        this.dimension_Multiple = dimension;

        if (entryPointKey == 'EntryPoint1') this.selectedEP1 = MetricOptions;
        else if (entryPointKey == 'EntryPoint2')
          this.selectedEP2 = MetricOptions;
        else if (entryPointKey == 'EntryPoint3')
          this.selectedEP3 = MetricOptions;
      }
    }
    const existingEntryIndex1 = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === Level1
    );

    const existingEntry = this.dataArray[existingEntryIndex1];

    const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
      (l2: any) => l2.Parent === Level2
    );
    if (
      this.entryPanel_Lvl3.filter(
        (a) => a.Level1 === Level1 && a.Level2 === Level2
      ).length ===
      (existingLevel2Index !== -1
        ? existingEntry[entryPointKey].Level2[existingLevel2Index]
          .MetricOptions.length
        : 0) &&
      isSelectAll == false
    ) {
      this.isSelectAll = true;
    } else {
      if (isSelectAll == false) {
        this.isSelectAll = false;
      }
    }

    const variableTab = this.getVariableTabEl();
    if (variableTab) variableTab.classList.add('DN');
    this._rebuildToggleStatusCache();
    this.cdr.detectChanges();
    this.ClearAll();
  }

  @Input() onItemClick: ((event: MouseEvent) => void) | undefined;

  checkBoxClickNotEP(
    filters: string,
    event: Event,
    level1: string,
    level2: string,
    level3: string,
    level4: string,
    level5: string,
    level6: string,
    level7: string,
    level8: string,
    level9: string,
    level0: string = '',
    loadSel: boolean = false,
    SelectionFilterData: any = {},
    isFromGlobalSlection = false
  ) {
    let numberOfCheckedCheckboxes;
    if (!loadSel) {
      const nearestLevelDiv = (event.target as HTMLElement).closest(
        'div[class*="variables-sub-itemsLev"]'
      );
      const checkedCheckboxes =
        this.isAggregatedData && filters == 'filters'
          ? nearestLevelDiv?.querySelectorAll('input[type="radio"]:checked')
          : nearestLevelDiv?.querySelectorAll('input[type="checkbox"]:checked');
      numberOfCheckedCheckboxes = checkedCheckboxes?.length;
    }

    let responseCode,
      variableLabel,
      year_code,
      is_brand_analysis,
      is_derived,
      calc_type,
      hasNextLevel,
      variable_code,
      sort_id,
      is_multi_punch,
      date,
      is_dimension,
      is_CustomGroup,
      kibanaFilterScript,
      customGroupId,
      dataYearCode,
      is_time_Period_Present,
      derived_metric_calculation,
      isSelected,
      Weekno_forSigcalculation;
      
    if (!loadSel) {
      if (
        (event.target as HTMLElement).classList.contains(
          'sub-items-names-parent'
        )
      ) {
        let elementParent = (event.target as HTMLElement).parentElement;

        responseCode = elementParent?.getAttribute('data_response_code');
        derived_metric_calculation = elementParent?.getAttribute(
          'data_derived_metric_calculation'
        );
        variableLabel = elementParent?.getAttribute('data-variable-name');
        year_code = elementParent?.getAttribute('data_year_code');

        is_brand_analysis = elementParent?.getAttribute(
          'data-is_brand_analysis'
        );
        is_derived = elementParent?.getAttribute('data-is_derived');
        calc_type = elementParent?.getAttribute('data-calc_type');
        hasNextLevel = elementParent?.getAttribute('data-hasNextLevel');
        variable_code = elementParent?.getAttribute('data_variable_code');

        sort_id = elementParent?.getAttribute('data_sort_id');
        is_multi_punch = elementParent?.getAttribute('data_is_multi_punch');
        date = elementParent?.getAttribute('data_date');
        is_dimension = elementParent?.getAttribute('data-is_dimension');
        is_CustomGroup = elementParent?.getAttribute('data-is_CustomGroup');

        kibanaFilterScript = elementParent?.getAttribute(
          'data-kibanaFilterScript'
        );
        customGroupId = elementParent?.getAttribute('data-customGroupId');
        dataYearCode = elementParent?.getAttribute('data-dataYearCode');
        is_time_Period_Present = elementParent?.getAttribute(
          'data-is_time_Period_Present'
        );
        Weekno_forSigcalculation = elementParent?.getAttribute('data-Weekno_forSigcalculation');

        isSelected = elementParent?.getAttribute('data-is_selected');
      } else {
        let elementParent = (event.target as HTMLElement).parentElement
          ?.parentElement;

        responseCode = elementParent?.getAttribute('data_response_code');
        derived_metric_calculation = elementParent?.getAttribute(
          'data_derived_metric_calculation'
        );

        variableLabel = elementParent?.getAttribute('data-variable-name');
        year_code = elementParent?.getAttribute('data_year_code');

        is_brand_analysis = elementParent?.getAttribute(
          'data-is_brand_analysis'
        );
        is_derived = elementParent?.getAttribute('data-is_derived');
        calc_type = elementParent?.getAttribute('data-calc_type');
        hasNextLevel = elementParent?.getAttribute('data-hasNextLevel');
        variable_code = elementParent?.getAttribute('data_variable_code');

        sort_id = elementParent?.getAttribute('data_sort_id');
        is_multi_punch = elementParent?.getAttribute('data_is_multi_punch');
        date = elementParent?.getAttribute('data_date');
        is_dimension = elementParent?.getAttribute('data-is_dimension');
        is_CustomGroup = elementParent?.getAttribute('data-is_CustomGroup');

        kibanaFilterScript = elementParent?.getAttribute(
          'data-kibanaFilterScript'
        );
        customGroupId = elementParent?.getAttribute('data-customGroupId');
        dataYearCode = elementParent?.getAttribute('data-dataYearCode');
        is_time_Period_Present = elementParent?.getAttribute(
          'data-is_time_Period_Present'
        );
        Weekno_forSigcalculation = elementParent?.getAttribute('data-Weekno_forSigcalculation');

        isSelected = elementParent?.getAttribute('data-is_selected');
      }
    } else {
      responseCode = SelectionFilterData.response_code;
      derived_metric_calculation =
        SelectionFilterData.derived_metric_calculation;
      variableLabel = SelectionFilterData.variable_label;
      Level0: level0;
      level1 = SelectionFilterData.Level1;
      level2 = SelectionFilterData.Level2;
      level3 = SelectionFilterData.Level3;
      level4 = SelectionFilterData.Level4;
      level5 = SelectionFilterData.Level5;
      level6 = SelectionFilterData.Level6;
      level7 = SelectionFilterData.Level7;
      level8 = SelectionFilterData.Level8;
      level9 = SelectionFilterData.Level9;
      year_code = SelectionFilterData.year_code;
      is_brand_analysis = SelectionFilterData.is_brand_analysis;
      is_derived = SelectionFilterData.is_derived;
      calc_type = SelectionFilterData.calc_type;
      hasNextLevel = SelectionFilterData.hasNextLevel;
      variable_code = SelectionFilterData.variable_code;
      sort_id = SelectionFilterData.sort_id;
      is_multi_punch = SelectionFilterData.is_multi_punch;
      date = SelectionFilterData.date;
      is_dimension = SelectionFilterData.s_dimension;
      is_CustomGroup = SelectionFilterData.is_CustomGroup;
      kibanaFilterScript = SelectionFilterData.kibanaFilterScript;
      customGroupId = SelectionFilterData.customGroupId;
      dataYearCode = SelectionFilterData.dataYearCode;
      is_time_Period_Present = SelectionFilterData.is_time_Period_Present;
      isSelected = SelectionFilterData.is_selected ?? false;
      Weekno_forSigcalculation = SelectionFilterData.Weekno_forSigcalculation;
    }

    const selectedData = {
      response_code: responseCode,
      derived_metric_calculation: derived_metric_calculation,
      variable_label: variableLabel,
      Level0: level0,
      Level1: level1,
      Level2: level2,
      Level3: level3,
      Level4: level4,
      Level5: level5,
      Level6: level6,
      Level7: level7,
      Level8: level8,
      Level9: level9,
      year_code: year_code,
      is_brand_analysis: is_brand_analysis,
      is_derived: is_derived,
      calc_type: calc_type,
      hasNextLevel: hasNextLevel,
      variable_code: variable_code,
      sort_id: sort_id,
      is_multi_punch: is_multi_punch,
      date: date,
      is_dimension: is_dimension,
      is_CustomGroup: is_CustomGroup,
      kibanaFilterScript: kibanaFilterScript,
      customGroupId: customGroupId,
      dataYearCode: dataYearCode,
      is_time_Period_Present: is_time_Period_Present,
      Weekno_forSigcalculation: Weekno_forSigcalculation,
    };
    const objKey = selectedData.Level0 === 'Audience' ? selectedData.Level0 : selectedData.Level0;
    
    // PREVENT SELECTION OF ITEMS WITH NEXT LEVEL - They should only be expandable, not selectable
    if (hasNextLevel === 'true') {
      return; // Don't allow selection of intermediate items with hasNextLevel
    }
    
    if (isSelected !== 'true') {
      // Hard block: prevent more than 6 Default brands from being selected (interactive or loaded)
      // Allow mirror calls through (they keep the paired Level1 group in sync)
      if (!this._isMirroringBrandSelection && level0 === 'Brands' && this.defaultBrandList?.length > 0) {
        const brandsVar = this.variableList?.find((item: any) => item.Level0 === 'Brands');
      const guardCount = brandsVar
          ? (brandsVar.Level1 || [])
              .filter((l1: any) => l1.Level1_value === level1)
              .flatMap((l1: any) =>
                (l1.Level2 || [])
                  .filter((l2: any) => l2.is_selected)
                  .map((l2: any) => l2.Level2_value)
              ).length
          : 0; 
        if (guardCount >= 6) {
          return;
        }
      }
      if (this.selectedObjects.some((obj) => obj[objKey])) {
        const selectedObj = this.selectedObjects.find(
          (obj) => obj[objKey]
        );
        if (
          this.isAggregatedData &&
          filters == 'filters' &&
          selectedData.Level1 != 'KPI' &&
          !isFromGlobalSlection
        ) {
          selectedObj[selectedData.Level1].forEach((element: any) => {
            this.SwitchMakeSelectedFalse(element, filters);
          });
          selectedObj[selectedData.Level1] = [];

          this.variablesSummaryObj = this.variablesSummaryObj.map(
            (item: any) => {
              if (item.Level1 === selectedData.Level1) {
                return selectedData;
              }
              return item;
            }
          );
        } else {
          this.variablesSummaryObj.push(selectedData);
        }
        if (!isFromGlobalSlection) {
          // Check if data already exists before pushing
          const dataExists = selectedObj[objKey].some((item: any) => {
            return (
              item.response_code == selectedData.response_code &&
              item.variable_label == selectedData.variable_label &&
              item.Level1 == selectedData.Level1 &&
              item.Level2 == selectedData.Level2 &&
              (item.Level3 ?? '') == (selectedData.Level3 ?? '') &&
              (item.Level4 ?? '') == (selectedData.Level4 ?? '') &&
              (item.Level5 ?? '') == (selectedData.Level5 ?? '')
            ); 
          });
          if (!dataExists) {
            selectedObj[objKey].push(selectedData);
          }
        }
      } else {
        this.selectedObjects.push({ [objKey]: [selectedData] });
        this.variablesSummaryObj.push(selectedData);
      }
      this.SwitchMakeSelectedTrue(selectedData, filters);
      //this.variablesSummaryObj.push(selectedData);

      const target = event?.target as HTMLElement;
      // Count unique Default brand names from variableList (works regardless of isFromGlobalSlection flag)
      const brandsVar1 = this.variableList?.find((item: any) => item.Level0 === 'Brands');
      
        let brandselectedlengh = brandsVar1
          ? (brandsVar1.Level1 || [])
            .filter((l1: any) => l1.Level1_value === level1)
            .flatMap((l1: any) =>
              (l1.Level2 || [])
                .filter((l2: any) => l2.is_selected)
                .map((l2: any) => l2.Level2_value)
            ).length
        : 0;   
      const customLength = this.selectedObjects.reduce((sum: number, obj: any) => {
        const arr: any[] = obj[Object.keys(obj)[0]] ?? [];
        return arr.length > 0 && arr[0].Level0 === 'Audience' ? sum + arr.length : sum;
      }, 0);

      this.audienceLimit =  customLength >= 3 ? true : false;
      if (
        (brandselectedlengh !== undefined &&
          brandselectedlengh >= 6) || (customLength >= 3)
      ) {
        this.mandatoryMaxLimitReached = true;
      } else {
        this.mandatoryMaxLimitReached = false;
      }
      this.cdr.detectChanges();
    }
    else {
      const selectedObj = this.selectedObjects.find(
        (obj) => obj[objKey]
      );
      if (selectedObj) {
        const index = selectedObj[objKey].findIndex(
          (item: any) => {
            if (
              item.response_code == selectedData.response_code &&
              item.variable_label == selectedData.variable_label &&
              item.Level1 == selectedData.Level1 &&
              item.Level2 == selectedData.Level2 &&
              (item.Level3 ?? '') == (selectedData.Level3 ?? '') &&
              (item.Level4 ?? '') == (selectedData.Level4 ?? '') &&
              (item.Level5 ?? '') == (selectedData.Level5 ?? '') &&
              (item.Level6 ?? '') == (selectedData.Level6 ?? '') &&
              (item.Level7 ?? '') == (selectedData.Level7 ?? '') &&
              (item.Level8 ?? '') == (selectedData.Level8 ?? '') &&
              (item.Level9 ?? '') == (selectedData.Level9 ?? '')
            )
              return item;
          }
        );
        if (index !== -1) {
          selectedObj[objKey].splice(index, 1);
        }
      }

      this.SwitchMakeSelectedFalse(selectedData, filters);

      this.variablesSummaryObj = this.variablesSummaryObj.filter(
        (item: any) => {
          if (
            !(
              item.response_code == selectedData.response_code &&
              item.variable_label == selectedData.variable_label &&
              item.Level1 == selectedData.Level1 &&
              item.Level2 == selectedData.Level2 &&
              (item.Level3 ?? '') == (selectedData.Level3 ?? '') &&
              (item.Level4 ?? '') == (selectedData.Level4 ?? '') &&
              (item.Level5 ?? '') == (selectedData.Level5 ?? '') &&
              (item.Level6 ?? '') == (selectedData.Level6 ?? '') &&
              (item.Level7 ?? '') == (selectedData.Level7 ?? '') &&
              (item.Level8 ?? '') == (selectedData.Level8 ?? '') &&
              (item.Level9 ?? '') == (selectedData.Level9 ?? '')
            )
          )
            return item;
        }
      );

      // Count unique Default brands from variableList after deselection (SwitchMakeSelectedFalse already ran)
      const brandsVar2 = this.variableList?.find((item: any) => item.Level0 === 'Brands');
      const count = brandsVar2
        ? new Set(
            (brandsVar2.Level1 || []).flatMap((l1: any) =>
              (l1.Level2 || [])
                .filter((l2: any) => l2.is_selected && this.defaultBrandList?.includes(l2.Level2_value))
                .map((l2: any) => l2.Level2_value)
            )
          ).size
        : 0;
      const customLength = this.selectedObjects.reduce((sum: number, obj: any) => {
        const arr: any[] = obj[Object.keys(obj)[0]] ?? [];
        return arr.length > 0 && arr[0].Level0 === 'Audience' ? sum + arr.length : sum;
      }, 0);

      this.audienceLimit = customLength >= 3 ? true : false;
      if (count >= 6 || customLength >= 3) {
        this.mandatoryMaxLimitReached = true;
      } else {
        this.mandatoryMaxLimitReached = false;
      }
      this.cdr.detectChanges();
    }

    // STEP 1: Update saved selection list
    this.handleTotalSampleAudienceSelection(level0, level1, isSelected === 'true');
    this.updateSavedSelectionsFromData(this.selectedObjects);

   // Mirror between "Default" ↔ "Brands"
   if(this.defaultBrandList.length>0){
    if (!this._isMirroringBrandSelection && level0 === 'Brands') {
      const brandsVariableItem = this.variableList.find(
        (item: any) => item.Level0 === 'Brands'
      );
      if (brandsVariableItem) {
        const targetLevel1 = level1 === 'Default'
          ? brandsVariableItem.Level1?.find((l1: any) => l1.Level1_value !== 'Default')
          : brandsVariableItem.Level1?.find((l1: any) => l1.Level1_value === 'Default');

        if (targetLevel1) {
          const matchingLevel2 = (targetLevel1.Level2 || []).find(
            (l2: any) => l2.Level2_value === level2
          );
          if (matchingLevel2) {
            // Mirror the same action (select/deselect) from source to target
            const selection = this.buildSelectedObject('Brands', targetLevel1, matchingLevel2, '');
            // isSelected === 'true' means the source item was selected and user is deselecting it
            selection.is_selected = isSelected === 'true' ? 'true' : false;
            matchingLevel2.is_selected = isSelected !== 'true';

            this._isMirroringBrandSelection = true;
            try {
              this.checkBoxClickNotEP(
                filters, event,
                selection.Level1, selection.Level2, selection.Level3,
                selection.Level4, selection.Level5,
                selection.Level6 || '', selection.Level7 || '',
                selection.Level8 || '', selection.Level9 || '',
                'Brands', true, selection
              );
            } finally {
              this._isMirroringBrandSelection = false;
            }
          }
        }
      }
    }
  }

    (event as MouseEvent).stopPropagation();

  }

  checkBoxClickNotEPRadio(
    filters: string,
    event: Event,
    level1: string,
    level2: string,
    level3: string,
    level4: string,
    level5: string,
    thisLevelDataChildren: any,
    level: string,
    thisLevelData: any,
    level0: string,
    loadSel: boolean
  ) {
    let responseCode,
      variableLabel,
      year_code,
      is_brand_analysis,
      is_derived,
      calc_type,
      hasNextLevel,
      variable_code,
      sort_id,
      is_multi_punch,
      date,
      is_dimension,
      is_CustomGroup,
      kibanaFilterScript,
      customGroupId,
      dataYearCode,
      is_time_Period_Present,
      derived_metric_calculation,
      Weekno_forSigcalculation;
    if (!loadSel) {
      if (
        (event.target as HTMLElement).classList.contains(
          'sub-items-names-parent'
        )
      ) {
        let elementParent = (event.target as HTMLElement).parentElement;

        responseCode = elementParent?.getAttribute('data_response_code');
        derived_metric_calculation = elementParent?.getAttribute(
          'data_derived_metric_calculation'
        );
        variableLabel = elementParent?.getAttribute('data-variable-name');
        year_code = elementParent?.getAttribute('data_year_code');

        is_brand_analysis = elementParent?.getAttribute(
          'data-is_brand_analysis'
        );
        is_derived = elementParent?.getAttribute('data-is_derived');
        calc_type = elementParent?.getAttribute('data-calc_type');
        hasNextLevel = elementParent?.getAttribute('data-hasNextLevel');
        variable_code = elementParent?.getAttribute('data_variable_code');

        sort_id = elementParent?.getAttribute('data_sort_id');
        is_multi_punch = elementParent?.getAttribute('data_is_multi_punch');
        date = elementParent?.getAttribute('data_date');
        is_dimension = elementParent?.getAttribute('data-is_dimension');
        is_CustomGroup = elementParent?.getAttribute('data-is_CustomGroup');

        kibanaFilterScript = elementParent?.getAttribute(
          'data-kibanaFilterScript'
        );
        customGroupId = elementParent?.getAttribute('data-customGroupId');
        dataYearCode = elementParent?.getAttribute('data-dataYearCode');
        is_time_Period_Present = elementParent?.getAttribute(
          'data-is_time_Period_Present'
        );
        Weekno_forSigcalculation = elementParent?.getAttribute('data-Weekno_forSigcalculation');
      } else {
        let elementParent = (event.target as HTMLElement).parentElement
          ?.parentElement;

        responseCode = elementParent?.getAttribute('data_response_code');
        derived_metric_calculation = elementParent?.getAttribute(
          'data_derived_metric_calculation'
        );

        variableLabel = elementParent?.getAttribute('data-variable-name');
        year_code = elementParent?.getAttribute('data_year_code');

        is_brand_analysis = elementParent?.getAttribute(
          'data-is_brand_analysis'
        );
        is_derived = elementParent?.getAttribute('data-is_derived');
        calc_type = elementParent?.getAttribute('data-calc_type');
        hasNextLevel = elementParent?.getAttribute('data-hasNextLevel');
        variable_code = elementParent?.getAttribute('data_variable_code');

        sort_id = elementParent?.getAttribute('data_sort_id');
        is_multi_punch = elementParent?.getAttribute('data_is_multi_punch');
        date = elementParent?.getAttribute('data_date');
        is_dimension = elementParent?.getAttribute('data-is_dimension');
        is_CustomGroup = elementParent?.getAttribute('data-is_CustomGroup');

        kibanaFilterScript = elementParent?.getAttribute(
          'data-kibanaFilterScript'
        );
        customGroupId = elementParent?.getAttribute('data-customGroupId');
        dataYearCode = elementParent?.getAttribute('data-dataYearCode');
        is_time_Period_Present = elementParent?.getAttribute(
          'data-is_time_Period_Present'
        );
        Weekno_forSigcalculation = elementParent?.getAttribute('data-Weekno_forSigcalculation');
      }
    } else {
      let loadselectionData = thisLevelDataChildren?.find(
        (item: any) => item.Level2_value === level2
      );

      if (
        this._configService.isGlobalDefaultSelectionEnabled &&
        !loadselectionData &&
        level3
      ) {
        loadselectionData = thisLevelDataChildren?.find(
          (item: any) => item.Level3_value === level3
        );
      }
      responseCode = loadselectionData?.response_code;
      derived_metric_calculation =
        loadselectionData?.derived_metric_calculation;
      variableLabel =
        this._configService.isGlobalDefaultSelectionEnabled && level3
          ? loadselectionData?.Level3_value
          : loadselectionData?.Level2_value;
      level0 = level0;
      level1 = level1;
      level2 = level2;
      level3 = level3;
      level4 = level4;
      level5 = level5;
      year_code = loadselectionData?.year_code;
      is_brand_analysis = loadselectionData.is_brand_analysis;
      is_derived = loadselectionData.is_derived;
      calc_type = loadselectionData.calc_type;
      hasNextLevel = loadselectionData.hasNextLevel;
      variable_code = loadselectionData.data_variable_code;
      sort_id = loadselectionData.sort_id;
      is_multi_punch = loadselectionData.is_multi_punch;
      date = loadselectionData.date;
      is_dimension = loadselectionData.is_dimension;
      is_CustomGroup = loadselectionData.isCustomGrpPresent;
      kibanaFilterScript = loadselectionData.kibanaFilterScript;
      customGroupId = loadselectionData.customGroupId;
      dataYearCode = loadselectionData.dataYearCode;
      is_time_Period_Present = loadselectionData.is_time_Period_Present;
      Weekno_forSigcalculation = loadselectionData.Weekno_forSigcalculation;
    }

    let selectedData = {
      response_code: responseCode,
      derived_metric_calculation: derived_metric_calculation,
      variable_label: variableLabel,
      Level0: level0,
      Level1: level1,
      Level2: level2,
      Level3: level3,
      Level4: level4,
      Level5: level5,
      year_code: year_code,
      is_brand_analysis: is_brand_analysis,
      is_derived: is_derived,
      calc_type: calc_type,
      hasNextLevel: hasNextLevel,
      variable_code: variable_code,
      sort_id: sort_id,
      is_multi_punch: is_multi_punch,
      date: date,
      is_dimension: is_dimension,
      is_CustomGroup: is_CustomGroup,
      kibanaFilterScript: kibanaFilterScript,
      customGroupId: customGroupId,
      dataYearCode: dataYearCode,
      is_time_Period_Present: is_time_Period_Present,
      Weekno_forSigcalculation: Weekno_forSigcalculation,
    };

    // PREVENT SELECTION OF ITEMS WITH NEXT LEVEL - They should only be expandable, not selectable
    if (hasNextLevel === 'true') {
      return; // Don't allow selection of intermediate items with hasNextLevel
    }

    if (selectedData.Level0 == 'Time Period')
      this._configService.selectedTPforNonTrendView =
        selectedData.Level1 + '|' + selectedData.Level2;

    if (
      !this.variablesSummaryObjRadio.some(
        (obj: any) => obj.Level1 === selectedData.Level1
      ) &&
      !this.variablesSummaryObjRadio.some(
        (obj: any) => obj.Level0 === selectedData.Level0
      )
    )
      this.variablesSummaryObjRadio.push(selectedData);
    else {
      const index = this.variablesSummaryObjRadio.findIndex(
        (item: any) => item.Level0 === selectedData.Level0
      );
      this.variablesSummaryObjRadio.splice(index, 1);
      this.variablesSummaryObjRadio.push(selectedData);
    }

    //this.selectedObjects[selectedData.Level1] = [selectedData];

    switch (filters) {
      case 'NOTfilters':
        this.variableList.forEach((item) => {
          if (item.Level0 === selectedData.Level0) {
            item?.Level1?.forEach((level1Item) => {
              level1Item.is_selected = false;
              level1Item?.Level2?.forEach((level2Item: any) => {
                level2Item.is_selected = false;
                level2Item?.Level3?.forEach((level3Item: any) => {
                  level3Item.is_selected = false;
                  level3Item?.Level4?.forEach((level4Item: any) => {
                    level4Item.is_selected = false;
                    level4Item?.Level5?.forEach((level5Item: any) => {
                      level5Item.is_selected = false;
                    });
                  });
                });
              });
            });
          }
        });

                thisLevelDataChildren = Array.isArray(thisLevelDataChildren) ? thisLevelDataChildren
                               : thisLevelDataChildren ? [thisLevelDataChildren] : [];

        thisLevelDataChildren.forEach((a: any) => {
          //
          if (
            a[(level + '_value') as keyof typeof a] ===
            selectedData[level as keyof typeof selectedData]
          ) {
            a.is_selected = true;
          }
        });
        thisLevelData.is_selected = true;

        let condition = false;
        this.selectedObjects.forEach((obj: any) => {
          if (obj[selectedData.Level0]?.length > 0) {
            condition = true;
          }
        });
        if (!condition)
        {
          this.selectedObjects.push({ [selectedData.Level0]: [selectedData] });
        }
        else
          this.selectedObjects.forEach((obj: any) => {
            if (obj.hasOwnProperty(selectedData.Level0))
              obj[selectedData.Level0] = [selectedData];
          });

        break;

      case 'filters':
        this.variableListFilter.forEach((item) => {
          if (item.LevelMinus === selectedData.Level0) {
            item.Level1.forEach((level1Item) => {
              if (level1Item.Level0 === selectedData.Level1) {
                level1Item.is_selected = false;
                level1Item.Level1.forEach((level2Item: any) => {
                  level2Item.is_selected = false;
                  level2Item.Level2.forEach((level3Item: any) => {
                    level3Item.is_selected = false;
                    level3Item.Level3.forEach((level4Item: any) => {
                      level4Item.is_selected = false;
                      level4Item.Level4.forEach((level5Item: any) => {
                        level5Item.is_selected = false;
                      });
                    });
                  });
                });
              }
            });
          }
        });


        thisLevelDataChildren.forEach((a: any) => {
          if (
            a[(level + '_value') as keyof typeof a] ===
            selectedData[level as keyof typeof selectedData]
          ) {
            a.is_selected = true;
          }
        });
        thisLevelData.is_selected = true;

        let condition1 = false;
        this.selectedObjects.forEach((obj: any) => {
          if (obj[selectedData.Level1].length > 0) {
            condition1 = true;
          }
        });
        if (!condition1)
        {
          this.selectedObjects.push({ [selectedData.Level1]: [selectedData] });
        }
        else
          this.selectedObjects.forEach((obj: any) => {
            if (obj.hasOwnProperty(selectedData.Level1))
              obj[selectedData.Level1] = [selectedData];
          });

        break;
    }

    this.handleTotalSampleAudienceSelection(level0, level1, false);

    this.CheckIfMandatorySelected();
    this.updateSavedSelectionsFromData(this.selectedObjects, 'radio');

    (event as MouseEvent).stopPropagation();
  }

  savedSelections: any[] = [];
   getEPGroupName(variableCode: string): string {
    return this._varCodeToEntryKeyCache.get(variableCode) ?? 'ep_group_default';
  }
  updateSavedSelectionsFromData(data: any, type: string = '') {
    this.savedSelections = [];

    // if (this.isTotalSampleAudienceActive) {
    //   this.savedSelections = [{ hierarchy: ['Total Sample'], lastLevelValues: [] }];
    //   this.audienceTooltip = '<b>Total Sample</b>';
    //   return;
    // }

    if (Array.isArray(data)) {
      const merged: any = {};
      data.forEach((item: any) => {
        Object.keys(item).forEach(key => {
          if (merged[key] && Array.isArray(merged[key]) && Array.isArray(item[key])) {
            merged[key] = [...merged[key], ...item[key]];
          } else {
            merged[key] = item[key];
          }
        });
      });
      data = merged;
    }


    Object.keys(data).forEach(bucketKey => {
      const arr = data[bucketKey];
      if (!Array.isArray(arr)) return;

      const audienceItems = arr.filter(x => x.Level0 === "Audience");
      if (!audienceItems.length) return;

      const grouped: any = {};

      audienceItems.forEach(item => {

        const levels: string[] = [];
        for (let i = 1; i <= 10; i++) {
          if (item[`Level${i}`]) levels.push(item[`Level${i}`]);
        }

        if (levels.length < 1) return;


        const last3 = levels.slice(-3);

        const level2 = last3.length >= 2 ? last3[last3.length - 2] : last3[0];
        const level3 = last3[last3.length - 1];

        if (!grouped[level2]) grouped[level2] = { last3Hierarchy: [], lastLevelValues: [] };

        grouped[level2].last3Hierarchy = last3.slice(0, -1);
        grouped[level2].lastLevelValues.push(level3);
      });


      Object.keys(grouped).forEach(level2 => {
        const grp = grouped[level2];

        this.savedSelections.push({
          hierarchy: grp.last3Hierarchy,
          lastLevelValues: [...new Set(grp.lastLevelValues)]
        });
      });
    });

    this.audienceTooltip = this.buildAudienceTooltip(this.savedSelections);
  }

  buildAudienceTooltip(data: any[]) {
    if (!data || data.length === 0) return "No selections";

    return data
  .sort((a, b) => {
    const hA = a.hierarchy.join(" : ");
    const hB = b.hierarchy.join(" : ");

    // items with empty h appear FIRST
    if (hA === "" && hB !== "") return -1;
    if (hA !== "" && hB === "") return 1;
    return 0;
  })
  .map(item => {
    const h = item.hierarchy.join(" : ");
    const boldValues = item.lastLevelValues
      .map((v: any) => `<b>${v}</b>`)
      .join(", ");

    return h !== "" ? `${h} : ${boldValues}` : `${boldValues}`;
  })
  .join("<br>");

  }

  SwitchMakeSelectedTrue(selectedData: any, filters: string) {
    switch (filters) {
      case 'NOTfilters':
        for (const levelMinus of this.variableList) {
          const level1 = levelMinus.Level1.find((l: any) => l.Level1_value === selectedData.Level1);
          if (!level1) continue;
          // Only mark Level1 as selected if it doesn't have next level (leaf node)
          if (!level1.hasNextLevel) {
            level1.is_selected = true;
          }
          const level2 = level1.Level2?.find((l: any) => l.Level2_value === selectedData.Level2);
          if (!level2) continue;
          // Only mark Level2 as selected if it doesn't have next level (leaf node)
          if (!level2.hasNextLevel) {
            level2.is_selected = true;
          }
          const level3 = level2.Level3?.find((l: any) => l.Level3_value === selectedData.Level3);
          if (!level3) continue;
          // Only mark Level3 as selected if it doesn't have next level (leaf node)
          if (!level3.hasNextLevel) {
            level3.is_selected = true;
          }
          const level4 = level3.Level4?.find((l: any) => l.Level4_value === selectedData.Level4);
          if (!level4) continue;
          // Only mark Level4 as selected if it doesn't have next level (leaf node)
          if (!level4.hasNextLevel) {
            level4.is_selected = true;
          }
          const level5 = level4.Level5?.find((l: any) => l.Level5_value === selectedData.Level5);
          if (!level5) continue;
          // Only mark Level5 as selected if it doesn't have next level (leaf node)
          if (!level5.hasNextLevel) {
            level5.is_selected = true;
          }
          const level6 = level5.Level6?.find((l: any) => l.Level6_value === selectedData.Level6);
          if (!level6) continue;
          // Only mark Level6 as selected if it doesn't have next level (leaf node)
          if (!level6.hasNextLevel) {
            level6.is_selected = true;
          }
          const level7 = level6.Level7?.find((l: any) => l.Level7_value === selectedData.Level7);
          if (!level7) continue;
          // Only mark Level7 as selected if it doesn't have next level (leaf node)
          if (!level7.hasNextLevel) {
            level7.is_selected = true;
          }
          const level8 = level7.Level8?.find((l: any) => l.Level8_value === selectedData.Level8);
          if (!level8) continue;
          // Only mark Level8 as selected if it doesn't have next level (leaf node)
          if (!level8.hasNextLevel) {
            level8.is_selected = true;
          }
          const level9 = level8.Level9?.find((l: any) => l.Level9_value === selectedData.Level9);
          if (level9 && !level9.hasNextLevel) level9.is_selected = true;
        }
        break;
      case 'filters':
        for (const levelMinus of this.variableListFilter) {
          const level1 = levelMinus.Level1.find((l: any) => l.Level0 === selectedData.Level1);
          if (!level1) continue;
          // Only mark Level1 as selected if it doesn't have next level (leaf node)
          if (!level1.hasNextLevel) {
            level1.is_selected = true;
          }
          const level2 = level1.Level1?.find((l: any) => l.Level1_value === selectedData.Level2);
          if (!level2) continue;
          // Only mark Level2 as selected if it doesn't have next level (leaf node)
          if (!level2.hasNextLevel) {
            level2.is_selected = true;
          }
          const level3 = level2.Level2?.find((l: any) => l.Level2_value === selectedData.Level3);
          if (!level3) continue;
          // Only mark Level3 as selected if it doesn't have next level (leaf node)
          if (!level3.hasNextLevel) {
            level3.is_selected = true;
          }
          const level4 = level3.Level3?.find((l: any) => l.Level3_value === selectedData.Level4);
          if (!level4) continue;
          // Only mark Level4 as selected if it doesn't have next level (leaf node)
          if (!level4.hasNextLevel) {
            level4.is_selected = true;
          }
          const level5 = level4.Level4?.find((l: any) => l.Level4_value === selectedData.Level5);
          if (!level5) continue;
          // Only mark Level5 as selected if it doesn't have next level (leaf node)
          if (!level5.hasNextLevel) {
            level5.is_selected = true;
          }
          const level6 = level5.Level5?.find((l: any) => l.Level5_value === selectedData.Level6);
          if (!level6) continue;
          // Only mark Level6 as selected if it doesn't have next level (leaf node)
          if (!level6.hasNextLevel) {
            level6.is_selected = true;
          }
          const level7 = level6.Level6?.find((l: any) => l.Level6_value === selectedData.Level7);
          if (!level7) continue;
          // Only mark Level7 as selected if it doesn't have next level (leaf node)
          if (!level7.hasNextLevel) {
            level7.is_selected = true;
          }
          const level8 = level7.Level7?.find((l: any) => l.Level7_value === selectedData.Level8);
          if (!level8) continue;
          // Only mark Level8 as selected if it doesn't have next level (leaf node)
          if (!level8.hasNextLevel) {
            level8.is_selected = true;
          }
          const level9 = level8.Level8?.find((l: any) => l.Level8_value === selectedData.Level9);
          if (level9 && !level9.hasNextLevel) level9.is_selected = true;
        }
        break;
      default:
        break;
    }
    this.CheckIfMandatorySelected();
  }

  SwitchMakeSelectedFalse(selectedData: any, filters: string) {
    let values = Object.values(this.selectedObjects);
    switch (filters) {
      case 'NOTfilters':
        for (let i = 0; i < Object.keys(this.selectedObjects).length; i++) {
          // Skip buckets that don't match the deselected item's group.
          if (Object.keys(values[i] as any)[0] !== selectedData.Level0) continue;
          let value1 = Object.values(values[i]);
          let value = value1[0] as any[];

          for (const levelMinus of this.variableList) {
            const level1 = levelMinus.Level1.find((l: any) => l.Level1_value === selectedData.Level1);
            if (!level1) continue;
            const level2 = level1.Level2?.find((l: any) => l.Level2_value === selectedData.Level2);
            if (level2) {
              const level3 = level2.Level3?.find((l: any) => l.Level3_value === selectedData.Level3);
              if (level3) {
                const level4 = level3.Level4?.find((l: any) => l.Level4_value === selectedData.Level4);
                if (level4) {
                  const level5 = level4.Level5?.find((l: any) => l.Level5_value === selectedData.Level5);
                  if (level5) level5.is_selected = false;
                  if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3 && a.Level4 === selectedData.Level4).length === 0)
                    level4.is_selected = false;
                }
                if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3).length === 0)
                  level3.is_selected = false;
              }
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2).length === 0)
                level2.is_selected = false;
            }
            if (value.filter((a: any) => a.Level1 === selectedData.Level1).length === 0)
              level1.is_selected = false;
          }
        }
        break;
      case 'filters':
        for (let i = 0; i < Object.keys(this.selectedObjects).length; i++) {
          const bucketKey = Object.keys(values[i] as any)[0];
          if (bucketKey !== selectedData.Level1 && bucketKey !== '') continue;
          let value1 = Object.values(values[i]);
          let allValues = value1[0] as any[];
          // When items are stored under '' key (level0 empty), filter to the matching Level1 group
          let value = bucketKey === ''
            ? allValues.filter((a: any) => a.Level1 === selectedData.Level1)
            : allValues;

          const noChildren = (arr: any[]) => !arr?.length || arr.every((a: any) => !a.is_selected);

          for (const levelMinus of this.variableListFilter) {
            const level1 = levelMinus.Level1.find((l: any) => l.Level0 === selectedData.Level1);
            if (!level1) continue;

            const level2 = level1.Level1?.find((l: any) => l.Level1_value === selectedData.Level2);
            if (!level2) {
              if (value.filter((a: any) => a.Level1 === selectedData.Level1).length === 0 && noChildren(level1.Level1))
                level1.is_selected = false;
              continue;
            }

            const level3 = selectedData.Level3 ? level2.Level2?.find((l: any) => l.Level2_value === selectedData.Level3) : undefined;
            if (!level3) {
              // Leaf at level2
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2).length === 0)
                level2.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1).length === 0 && noChildren(level1.Level1))
                level1.is_selected = false;
              continue;
            }

            const level4 = selectedData.Level4 ? level3.Level3?.find((l: any) => l.Level3_value === selectedData.Level4) : undefined;
            if (!level4) {
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3).length === 0)
                level3.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2).length === 0 && noChildren(level2.Level2))
                level2.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1).length === 0 && noChildren(level1.Level1))
                level1.is_selected = false;
              continue;
            }

            const level5 = selectedData.Level5 ? level4.Level4?.find((l: any) => l.Level4_value === selectedData.Level5) : undefined;
            if (!level5) {
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3 && a.Level4 === selectedData.Level4).length === 0)
                level4.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3).length === 0 && noChildren(level3.Level3))
                level3.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2).length === 0 && noChildren(level2.Level2))
                level2.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1).length === 0 && noChildren(level1.Level1))
                level1.is_selected = false;
              continue;
            }

            const level6 = selectedData.Level6 ? level5.Level5?.find((l: any) => l.Level5_value === selectedData.Level6) : undefined;
            if (!level6) {
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3 && a.Level4 === selectedData.Level4 && a.Level5 === selectedData.Level5).length === 0)
                level5.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3 && a.Level4 === selectedData.Level4).length === 0 && noChildren(level4.Level4))
                level4.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3).length === 0 && noChildren(level3.Level3))
                level3.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2).length === 0 && noChildren(level2.Level2))
                level2.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1).length === 0 && noChildren(level1.Level1))
                level1.is_selected = false;
              continue;
            }

            const level7 = selectedData.Level7 ? level6.Level6?.find((l: any) => l.Level6_value === selectedData.Level7) : undefined;
            if (!level7) {
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3 && a.Level4 === selectedData.Level4 && a.Level5 === selectedData.Level5 && a.Level6 === selectedData.Level6).length === 0)
                level6.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3 && a.Level4 === selectedData.Level4 && a.Level5 === selectedData.Level5).length === 0 && noChildren(level5.Level5))
                level5.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3 && a.Level4 === selectedData.Level4).length === 0 && noChildren(level4.Level4))
                level4.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3).length === 0 && noChildren(level3.Level3))
                level3.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2).length === 0 && noChildren(level2.Level2))
                level2.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1).length === 0 && noChildren(level1.Level1))
                level1.is_selected = false;
              continue;
            }

            const level8 = selectedData.Level8 ? level7.Level7?.find((l: any) => l.Level7_value === selectedData.Level8) : undefined;
            if (level8) {
              const level9 = level8.Level8?.find((l: any) => l.Level8_value === selectedData.Level9);
              if (level9) level9.is_selected = false;
              if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3 && a.Level4 === selectedData.Level4 && a.Level5 === selectedData.Level5 && a.Level6 === selectedData.Level6 && a.Level7 === selectedData.Level7 && a.Level8 === selectedData.Level8).length === 0 && noChildren(level8.Level8))
                level8.is_selected = false;
            } else {
              level7.is_selected = false;
            }
            if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3 && a.Level4 === selectedData.Level4 && a.Level5 === selectedData.Level5 && a.Level6 === selectedData.Level6 && a.Level7 === selectedData.Level7).length === 0 && noChildren(level7.Level7))
              level7.is_selected = false;
            if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3 && a.Level4 === selectedData.Level4 && a.Level5 === selectedData.Level5 && a.Level6 === selectedData.Level6).length === 0 && noChildren(level6.Level6))
              level6.is_selected = false;
            if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3 && a.Level4 === selectedData.Level4 && a.Level5 === selectedData.Level5).length === 0 && noChildren(level5.Level5))
              level5.is_selected = false;
            if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3 && a.Level4 === selectedData.Level4).length === 0 && noChildren(level4.Level4))
              level4.is_selected = false;
            if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2 && a.Level3 === selectedData.Level3).length === 0 && noChildren(level3.Level3))
              level3.is_selected = false;
            if (value.filter((a: any) => a.Level1 === selectedData.Level1 && a.Level2 === selectedData.Level2).length === 0 && noChildren(level2.Level2))
              level2.is_selected = false;
            if (value.filter((a: any) => a.Level1 === selectedData.Level1).length === 0 && noChildren(level1.Level1))
              level1.is_selected = false;
          }
        }
        break;
      default:
        break;
    }

    this.CheckIfMandatorySelected();
  }

  SwitchMakeSelectedTrueMultiple(selectedData: any, filters: string) {
    switch (filters) {
      case 'NOTfilters':
        this.variableListMultiMarketAndCateg.forEach((levelMinus) => {
          levelMinus.Level1.forEach((level1) => {
            if (level1.Level1_value === selectedData.Level1) {
              level1.is_selected = true;
              level1.Level2.forEach((level2: any) => {
                if (level2.Level2_value === selectedData.Level2) {
                  level2.is_selected = true;
                  level2.Level3.forEach((level3: any) => {
                    if (level3.Level3_value === selectedData.Level3) {
                      level3.is_selected = true;
                      level3.Level4.forEach((level4: any) => {
                        if (level4.Level4_value === selectedData.Level4) {
                          level4.is_selected = true;
                          level4.Level5.forEach((level5: any) => {
                            if (level5.Level5_value === selectedData.Level5) {
                              level5.is_selected = true;
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        });
        break;

      default:
        break;
    }
    this.CheckIfMandatorySelected();
  }

  SwitchMakeSelectedFalseMultiple(selectedData: any, filters: string) {
    let values = Object.values(this.selectedObjects);
    switch (filters) {
      case 'NOTfilters':
        for (let i = 0; i < Object.keys(this.selectedObjects).length; i++) {
          if (Object.keys(values[i] as any)[0] !== selectedData.Level0) continue;
          let value1 = Object.values(values[i]);
          let value = value1[0] as any[];

          this.variableListMultiMarketAndCateg.forEach((levelMinus) => {
            levelMinus.Level1.forEach((level1) => {
              if (level1.Level1_value === selectedData.Level1) {
                level1.Level2.forEach((level2: any) => {
                  if (level2.Level2_value === selectedData.Level2) {
                    level2.Level3.forEach((level3: any) => {
                      if (level3.Level3_value === selectedData.Level3) {
                        level3.Level4.forEach((level4: any) => {
                          if (level4.Level4_value === selectedData.Level4) {
                            level4.Level5.forEach((level5: any) => {
                              if (level5.Level5_value === selectedData.Level5) {
                                level5.is_selected = false;
                              }
                            });

                            if (
                              value.filter(
                                (a: any) =>
                                  a.Level1 === selectedData.Level1 &&
                                  a.Level2 === selectedData.Level2 &&
                                  a.Level3 === selectedData.Level3 &&
                                  a.Level4 === selectedData.Level4
                              ).length == 0
                            )
                              level4.is_selected = false;
                          }
                        });

                        if (
                          value.filter(
                            (a: any) =>
                              a.Level1 === selectedData.Level1 &&
                              a.Level2 === selectedData.Level2 &&
                              a.Level3 === selectedData.Level3
                          ).length == 0
                        )
                          level3.is_selected = false;
                      }
                    });

                    if (
                      value.filter(
                        (a: any) =>
                          a.Level1 === selectedData.Level1 &&
                          a.Level2 === selectedData.Level2
                      ).length == 0
                    )
                      level2.is_selected = false;
                  }
                });

                if (
                  value.filter((a: any) => a.Level1 === selectedData.Level1)
                    .length == 0
                )
                  level1.is_selected = false;
              }
            });
          });
        }

        break;

      default:
        break;
    }

    this.CheckIfMandatorySelected();
  }

  CheckIfMandatorySelected(): boolean {
    //event?.stopPropagation();
    const selectedObjects: { [key: string]: any } = this.selectedObjects;
    // let allLevel1Selected = this.variableListFilter.every((levelMinus) =>
    //   levelMinus.Level1.every((level1) => level1.is_selected)
    // );
    let allLevel1Selected = this.variableListFilter.every((levelMinus: any) =>
      levelMinus.Level1.every(
        (level1: any) => level1.Level0 === 'KPI' || level1.is_selected
      )
    );
    const timePeriodData = selectedObjects['find'](
      (obj: any) => obj['Time Period']
    )?.['Time Period'];
 
    let mandatory1Data: any = [];
 
    switch (this.singleorMultiSelectMandatory1) {
      case 'Brands 1':
        mandatory1Data = selectedObjects['find']((obj: any) => obj['Brands'])?.[
          'Brands'
        ];
        if (mandatory1Data == undefined || mandatory1Data.length == 0) {
          mandatory1Data = selectedObjects['find'](
            (obj: any) => obj['Brand']
          )?.['Brand'];
        }
        break;
      case 'Brands 2':
        mandatory1Data = selectedObjects['find']((obj: any) => obj['Brands'])?.[
          'Brands'
        ];
        if (mandatory1Data == undefined || mandatory1Data.length == 0) {
          mandatory1Data = selectedObjects['find'](
            (obj: any) => obj['Brand']
          )?.['Brand'];
        }
        break;
      case 'Category 2':
        mandatory1Data = selectedObjects['find'](
          (obj: any) => obj['Category']
        )?.['Category'];
        break;
      case 'Markets 2':
        mandatory1Data = selectedObjects['find'](
          (obj: any) => obj['Markets']
        )?.['Markets'];
        break;
      case 'Audience Snapshot':
        mandatory1Data =  selectedObjects['flatMap']((obj: any) => Object.values(obj))
  .flat()
  .find((x: any) => x.Level0 === "Audience");
        break;
      default:
        break;
    }
 
    let mandatory3Data: any = [];
    if (this.brandMandatory3 != '') {
      mandatory3Data = selectedObjects['find']((obj: any) => obj['Brands'])?.[
        'Brands'
      ];
    }
 
    // Submit stays disabled until every mandatory row that is on screen has a selection.
    // A missing variable (no Dimension row, static time frame, Audience with no audience row)
    // must not block Submit.
    const timePeriodExists = this.variableList?.some(
      (v: any) => v.Level0 === 'Time Period'
    );
    const hasTimePeriod =
      this._configService.isStaticTimeFrame ||
      !timePeriodExists ||
      (timePeriodData?.length > 0);

    const dimensionData = selectedObjects['find'](
      (obj: any) => obj['Dimension']
    )?.['Dimension'];
    const dimensionExists = this.variableList?.some(
      (v: any) => v.Level0 === 'Dimension'
    );
    const hasDimension = !dimensionExists || dimensionData?.length > 0;

    const brandData =
      selectedObjects['find']((obj: any) => obj['Brands'])?.['Brands'] ??
      selectedObjects['find']((obj: any) => obj['Brand'])?.['Brand'];
    // Audience Snapshot hides the Brands row, so do not require a brand pick there.
    const brandsExist =
      this.selectedcompareacrossOption !== 'Audience Snapshot' &&
      this.variableList?.some(
        (v: any) => v.Level0 === 'Brands' || v.Level0 === 'Brand'
      );
    const hasBrands = !brandsExist || brandData?.length > 0;

    const audienceRowExists = this.variableList?.some(
      (v: any) => v.Level0 === 'Audience'
    );
    const hasMandatory1 =
      this.singleorMultiSelectMandatory1 === 'Audience Snapshot' && !audienceRowExists
        ? true
        : (mandatory1Data?.length > 0 || mandatory1Data?.Level0 === 'Audience');

    const hasMandatory3 = this.brandMandatory3 === '' || (this.brandMandatory3 !== '' && mandatory3Data?.length > 0);
    const shouldEnable =
      hasDimension &&
      hasTimePeriod &&
      hasBrands &&
      hasMandatory1 &&
      hasMandatory3 &&
      (!this.isAggregatedData || allLevel1Selected);

    // Cache the submitButton reference to avoid repeated getElementById calls
    if (!this._submitButtonEl) {
      this._submitButtonEl = document.getElementById('submitButton');
    }
    const submitButton = this._submitButtonEl;

    if (shouldEnable) {
      if (submitButton?.classList.contains('disabled')) {
        submitButton.classList.remove('disabled');
      }
      this.issubmitReset.emit(true);
    } else {
      if (submitButton && !submitButton.classList.contains('disabled')) {
        submitButton.classList.add('disabled');
      }
      this.issubmitReset.emit(false);
    }
    return shouldEnable;
  }

  // O(1) — uses a pre-built cache; cache is rebuilt when dataArray or
  // EPdataFor_Multiple changes via _rebuildToggleStatusCache().
  toggleStatus(
    Level: number,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    variableCode: string
  ): boolean {
    const entryKey = this._varCodeToEntryKeyCache.get(variableCode) ?? '';
    return this._toggleStatusCache.get(`${entryKey}|${Level1}|${MetricOptions}`) === true;
  }

  toggleStatusRadio(
    Level: number,
    Level1: string,
    Level2: string,
    MetricOptions: string,
    variableCode: string
  ): boolean {
    const entryKey = this._varCodeToEntryKeyCache.get(variableCode) ?? '';
    return this._toggleStatusCache.get(`${entryKey}|${Level1}|${MetricOptions}`) === true;
  }

  // Returns true when the given filter node (or any of its descendants) is selected.
  // Used to keep a parent category/group highlighted in the filter pane even when it
  // is not the currently-expanded column, so the highlight persists across all
  // selected options instead of only the most recently expanded one.
  filterHasSelectedDescendant(node: any): boolean {
    if (!node) return false;
    if (node.is_selected === true) return true;
    for (let i = 1; i <= 9; i++) {
      const children = node['Level' + i];
      if (Array.isArray(children)) {
        for (const child of children) {
          if (this.filterHasSelectedDescendant(child)) return true;
        }
      }
    }
    return false;
  }

  getValidation(Name: string) {
    if (Name == 'Duplicate') {
      this.errorPopup('Already Exist');
    } else if (Name == 'EntryPoint') {
      this.errorPopup(
        'At least one option has to be selected from each Entry Point.'
      );
    } else if (Name == '2ndLoadClick')
      this.errorPopup('Please select at least one option from above.');
    this._loaderService.hideLoader();
    //return false;
  }

  configChanges(data: any, study: any) {
    let comparisionpoint;
    let confidenceLevel;
    let weights;
    data = data.filter((a: any) => a.study == study);
    if (data.length > 0) {
      if (data[0].comparison_point.length > 0) {
        // Check if "None" key is already present
        const isNoneKeyPresent = data[0].comparison_point.some(
          (itemConst: any) => itemConst.key === 'None'
        );
        // If the key is not present, add it
        if (!isNoneKeyPresent) {
          data[0].comparison_point.unshift({ key: 'None', value: true });
        }
        comparisionpoint = data[0].comparison_point.filter(
          (a: Config) => a.value == true
        );
        // Push other objects where value is true to comparison_point array
      }

      if (data[0].confidence_level.length > 0) {
        confidenceLevel = data[0].confidence_level.filter(
          (a: Config) => a.value == true
        );
      }

      if (data[0].weight.length > 0) {
        weights = data[0].weight.filter((a: any) => a.is_selected == true);
      }

      this.selectedConfig.emit({
        RowNestSelection: data[0].nesting[0].is_selected,
        ColNestSelection: data[0].nesting[1].is_selected,
        is_brand_analysis: data[0].is_brand_analysis,
        is_chart_visualization: data[0].is_chart_visualization,
        is_sticky_selection: data[0].is_sticky_selection,
        is_reset_selection: data[0].is_reset_selection,
        is_Transpose: data[0].output_page[0].value,
        is_indexing: data[0].output_page[1].value,
        is_sigtesting: data[0].output_page[2].value,
        is_ranking: data[0].output_page[3].value,
        isFilterToggle: data[0].filter_function[0].value,
        isAnswerToggle: data[0].filter_function[1].value,
        comparisionpoint: comparisionpoint,
        confidenceLevel: confidenceLevel,
        excelExport: data[0].export_download[0].value,
        pptExport: data[0].export_download[1].value,
        repository: data[0].export_download[2].value,
        lowBaseIdentifier: data[0].export_download[3].value,
        is_AI_Integration: data[0].is_AI_Integration,
        is_StoryBoard: data[0].is_StoryBoard,
        is_Column_Row_Percentage: data[0].is_Column_Row_Percentage,
        insufficentBase: data[0].low_base_identifier[0].data_value,
        lowBase: data[0].low_base_identifier[1].data_value,
        threshold: data[0].threshold_identifier[0].data_value,
        configweights: weights,
        iscustomgrp: data[0].custom_content[0].value,
        iscustomCalc: data[0].custom_content[1].value,
        iscustomreport: data[0].custom_content[2].value,
        changeEntryPoint: data[0].save_selection[1].value,
      });
      this.sendHelpGuide.emit(data[0].help_guide);
      this.custom_calculation = data[0].custom_calculation;
      this.custom_group = data[0].custom_group;
      this.custom_report = data[0].custom_report;
      this.export_download = data[0].export_download;
      this.isconfigCustomGrpPresent =
        data[0].custom_content[0].value == true ? true : false;
    }
  }


  onOtherOptionSelected() {
    this.totalSample = false;
  }


  BindEntryData(
    data: any,
    selectedStudy: string,
    ClientCode: string,
    ZeroEntryPoint: boolean
  ) {
    this.studyname = selectedStudy;
    this.entryPanel = [];
    this.variableList = [];
    this.filteredStudies = _.uniq(
      _.map(
        _.filter(
          data,
          (item) =>
            item.study !== null &&
            item.study !== '' &&
            item.client_name == ClientCode
        ),
        'study'
      )
    );
    const Leve1 = _.uniq(
      _.map(
        _.filter(
          data,
          (item) =>
            item.Level1 !== null &&
            item.Level2 !== '' &&
            item.study == selectedStudy
        ),
        'Level1'
      )
    );

    // if (ZeroEntryPoint && this.entryPanel.length == 0) {
    //   this.dataArray = [];
    //   const clientStudyInfo = {
    //     clientName: this.clientDetails.clientDetails.client_code.toString(),
    //     studyName: this.selected_study,
    //   };
    //   this.dataArray.push(clientStudyInfo);
    //   this.loadBtnClick(false);
    // }
    // else {
    //   for (const element of Leve1) {
    //     this.entryPanel.push({
    //       Level1: element,
    //     });

    //     this.level0EP.push(element);
    //   }
    // }

    // if (!(ZeroEntryPoint && this.entryPanel.length == 0)) {
    //   for (const element of Leve1) {
    //     this.entryPanel.push({
    //       Level1: element,
    //     });

    //     this.level0EP.push(element);
    //   }
    // }
  }
  entryExpand(lvl1: string) {
    this.searchTextLevel2 = '';
    this.searchMetricOption = '';
    this.variable_expand = '';
    this.iscompareacrossDropdownOpen = false;
    this.entry_nested_items_expand = '';
    if (this.entry_items_expand == '') {
      this.entry_items_expand = lvl1;
      this.entryFlag = true;
    } else if (this.entry_items_expand == lvl1) {
      this.entry_items_expand = '';
      this.entryFlag = false;
    } else {
      this.entry_items_expand = lvl1;
      this.entryFlag = true;
    }

    this.LeftPanelClick.emit({
      entry_items_expand: this.entry_items_expand,
      entryFlag: this.entryFlag,
    });

    this.entryPanel_Lvl2 = [];
    this.sidePanelblock = false;
    let lvl2Update = this.entryPointsData.EntryPoints.filter(
      (a: any) => a.Level1 === lvl1 && a.study == this.selected_study
    );
    lvl2Update = _.sortBy(lvl2Update, 'sortid');
    const Leve2 = _.uniq(
      _.map(
        _.filter(
          lvl2Update,
          (item) =>
            item.Level2 !== null && item.Level2 !== '' && item.Level1 == lvl1
        ),
        'Level2'
      )
    );
    for (const lvl2 of Leve2) {
      this.entryPanel_Lvl2.push({
        Level1: lvl1,
        Level2: lvl2,
      });
    }

    // Add "Default" as a replica of "Brands" in Level2
    const brandsEntry = this.entryPanel_Lvl2.find(
      (item) => item.Level2.toLowerCase() === 'brands' && item.Level1 === lvl1
    );
    if (brandsEntry) {
      this.entryPanel_Lvl2.unshift({
        Level1: lvl1,
        Level2: 'Default',
      });
    }
    //  ;

    const divElement = this.getEntryHeaderEl();
    if (divElement) {
      let height = this.GetHeightAboveElement(divElement);
      const bodyHeight = document.body.offsetHeight;
      const containerHeight = height;
      const heightPercentage = (containerHeight / bodyHeight) * 100;
      this.topEP = heightPercentage + '%';
    }

    // Auto-open Level2 and Level3 if selections exist for this Level1
    if (this.dataArray.length > 0) {
      
      const selectedEntry = this.dataArray.find((entry) => {
     
        return Object.keys(entry).some((key) => 
          key.startsWith('EntryPoint') && entry[key].Level1 === lvl1
        );
      });

      if (selectedEntry) {
       
        let selectedLevel2 = '';
        let entryPointIndex = 0;

        
        for (let i = 1; i <= 3; i++) {
          const epKey = `EntryPoint${i}`;
          if (selectedEntry.hasOwnProperty(epKey) && selectedEntry[epKey].Level1 === lvl1) {
            selectedLevel2 = selectedEntry[epKey].Level2[0]?.Parent;
            entryPointIndex = i - 1; 
            break;
          }
        }

        if (selectedLevel2) {
          this.BindSidePanel(entryPointIndex, lvl1, selectedLevel2);
        }
      }
    }

    // Auto-open side panel if there is only one Level2 option and no prior selection handled it
    if (this.entry_items_expand === lvl1) {
      const realLevel2Items = this.entryPanel_Lvl2.filter(item => item.Level2 !== 'Default');
      if (realLevel2Items.length === 1) {
        const alreadyHandled = this.dataArray.some(entry =>
          Object.keys(entry).some(key =>
            key.startsWith('EntryPoint') && entry[key].Level1 === lvl1
          )
        );
        if (!alreadyHandled) {
          const entryPointIndex = this.entryPanel.findIndex(ep => ep.Level1 === lvl1);
          this.BindSidePanel(entryPointIndex !== -1 ? entryPointIndex : 0, lvl1, realLevel2Items[0].Level2);
        }
      }
    }
  }

  BindSidePanel(EntryDetails: number, lvl1: string, lvl2: string) {
    // ;
    this.searchTextLevel2 = '';
    this.searchMetricOption = '';
    this.entryPanel_Lvl3 = [];
    this.sidePanelblock = true;
    this.selectAllCheck = 0;
    if (
      this.selectedcompareacrossOption == 'Multiple Markets' &&
      EntryDetails != 0
    ) {
      EntryDetails += 1;
    }
    // Map "Default" to "Brands" so it uses the same variable list
    const lvl2ForData = lvl2 === 'Default' ? 'Brands' : lvl2;
    let lvl2Update = this.entryPointsData.EntryPoints.filter(
      (a: any) =>
        a.Level1 === lvl1 && a.Level2 === lvl2ForData && a.study == this.selected_study
    );
    lvl2Update = _.sortBy(lvl2Update, 'sortid');

    // if (EntryDetails == 0) {
    //   this.entry_nested_items_expand1 = lvl2Update[0].Level2;
    //   this.entry_nested_items_expandParent1 = lvl2Update[0].Level1;
    // }
    // else if (EntryDetails == 1) {
    //   this.entry_nested_items_expand2 = lvl2Update[0].Level2;
    //   this.entry_nested_items_expandParent2 = lvl2Update[0].Level1;
    // }
    // else if (EntryDetails == 2) {
    //   this.entry_nested_items_expand3 = lvl2Update[0].Level2;
    //   this.entry_nested_items_expandParent3 = lvl2Update[0].Level1;
    // }

    this.entry_nested_items_expand = lvl2;
    this.metricOption = [];
    let uniqueMarket: any = [];
    let uniqueCate: any = [];
    this.dataArray.forEach((entry) => {
      const metricOptionsList1 = entry['EntryPoint1']?.Level2 || [];

      metricOptionsList1.forEach((data: any) => {
        data.MetricOptions.forEach((metricOption: any) => {
          this.metricOption.push(metricOption.responseCode);
          uniqueMarket.push(metricOption.responseCode);
        });
        //this.metricOption.push(data.responseCode);
      });

      const metricOptionsList2 = entry['EntryPoint2']?.Level2 || [];

      metricOptionsList2.forEach((data: any) => {
        data.MetricOptions.forEach((metricOption: any) => {
          this.metricOption.push(metricOption.responseCode);
          uniqueCate.push(metricOption.responseCode);
        });
      });

      const metricOptionsList3 = entry['EntryPoint3']?.Level2 || [];

      metricOptionsList3.forEach((data: any) => {
        data.MetricOptions.forEach((metricOption: any) => {
          this.metricOption.push(metricOption.responseCode);
        });
      });
    });

    const uniqueMetricOptionsArray = this.metricOption;
    const Leve2 = _.uniq(
      _.map(
        _.filter(
          lvl2Update,
          (item) =>
            item.Level1 === lvl1 &&
            item.Level2 === lvl2ForData &&
            item.MetricOption != ''
        ),
        'MetricOption'
      )
    );

    for (const lvl of Leve2) {
      let MetricOptions = this.entryPointsData.EntryPoints.filter(
        (a: any) =>
          a.Level1 === lvl1 &&
          a.Level2 === lvl2ForData &&
          a.MetricOption == lvl &&
          a.study == this.selected_study
      );

      if (EntryDetails == 1) {
        MetricOptions = MetricOptions.filter((a: any) => {
          const optionCodes = a.e1_variable_code
            .split(',')
            .map((code: any) => code.trim());
          return optionCodes.some((code: any) =>
            uniqueMetricOptionsArray.includes(code)
          );
        });
        MetricOptions = MetricOptions.filter((x: any) => {
          return uniqueMarket.indexOf(x.e1_variable_code) > -1;
        });
      } else if (EntryDetails == 2) {
        MetricOptions = MetricOptions.filter((a: any) => {
          const optionCodes = a.e1_variable_code
            .split(',')
            .map((code: any) => code.trim());
          const optionCodes2 = a.e2_variable_code
            .split(',')
            .map((code: any) => code.trim());

          return (
            optionCodes.some((code: any) =>
              uniqueMetricOptionsArray.includes(code)
            ) ||
            optionCodes2.some((code: any) =>
              uniqueMetricOptionsArray.includes(code)
            )
          );
        });

        if (this.selectedcompareacrossOption == 'Multiple Markets') {
          MetricOptions = MetricOptions.filter((x: any) => {
            return uniqueCate.indexOf(x.e2_variable_code) > -1;
          });
        } else {
          MetricOptions = MetricOptions.filter((x: any) => {
            return (
              uniqueMarket.indexOf(x.e1_variable_code) > -1 &&
              uniqueCate.indexOf(x.e2_variable_code) > -1
            );
          });
        }
      }
      if (MetricOptions.length > 1) {
        MetricOptions = [MetricOptions[0]];
      }
      // Build EP-filtered brand list for 'Default' brands panel
      let epFilteredBrandList = this.defaultBrandList;
      if (lvl2 === 'Default' && this._configService.topicsConfigurationBySnapshot?.rows?.length > 0) {
        const epKey = EntryDetails === 0 ? 'EntryPoint1' : EntryDetails === 1 ? 'EntryPoint2' : 'EntryPoint3';
        const epFieldName = `entryPoint${EntryDetails + 1}`;
        const selectedEntry = this.dataArray.find((e: any) => e.hasOwnProperty(epKey) && e[epKey]?.Level1 === lvl1);
        if (selectedEntry) {
          const selectedEPCodes: string[] = selectedEntry[epKey]?.Level2?.[0]?.MetricOptions
            ?.map((mo: any) => mo.responseCode).filter(Boolean) || [];
          if (selectedEPCodes.length > 0) {
            const filteredRows = this._configService.topicsConfigurationBySnapshot.rows.filter((row: any) =>
              !row[epFieldName]?.length || row[epFieldName].some((c: string) => selectedEPCodes.includes(c))
            );
            epFilteredBrandList = [...new Set(filteredRows.flatMap((row: any) => row.brandList || []))];
          }
        }
      }

      for (const metric of MetricOptions) {
        if (lvl2 === 'Default' && epFilteredBrandList?.length > 0 && !epFilteredBrandList.includes(metric.MetricOption)) {
          continue;
        }
        this.entryPanel_Lvl3.push({
          Level: EntryDetails,
          Level1: lvl1,
          Level2: lvl2,
          MetricOptions: metric.MetricOption,
          responseCode: metric.ResponseCode,
          isActive: false,
          variableCode: metric.VariableCode,
          e1_variable_code: metric.e1_variable_code,
          e2_variable_code: metric.e2_variable_code,
          e3_variable_code: metric.e3_variable_code,
          mandatory_variable_mapping: metric.mandatory_variable_mapping,
          dimension: metric.dimension,
        });
      }
    }

    const entryPointKey =
      EntryDetails === 0
        ? 'EntryPoint1'
        : EntryDetails === 1
          ? 'EntryPoint2'
          : 'EntryPoint3';
    const existingEntryIndex1 = this.dataArray.findIndex(
      (entry) =>
        entry.hasOwnProperty(entryPointKey) &&
        entry[entryPointKey].Level1 === lvl1
    );

    if (existingEntryIndex1 == -1) {
      this.isSelectAll = false;
    } else {
      const existingEntry = this.dataArray[existingEntryIndex1];

      const existingLevel2Index = existingEntry[entryPointKey].Level2.findIndex(
        (l2: any) => l2.Parent === lvl2
      );
      if (
        this.entryPanel_Lvl3.filter(
          (a) => a.Level1 === lvl1 && a.Level2 === lvl2
        ).length ===
        (existingLevel2Index !== -1
          ? existingEntry[entryPointKey].Level2[existingLevel2Index]
            .MetricOptions.length
          : 0)
      ) {
        this.isSelectAll = true;
      } else {
        const entryPanelOptions = this.entryPanel_Lvl3.map(
          (entry) => entry.MetricOptions
        );
        const isAllOptionsIncluded = entryPanelOptions.every((option) =>
          uniqueMetricOptionsArray.includes(option)
        );
        if (isAllOptionsIncluded) {
          this.isSelectAll = true;
        } else {
          this.isSelectAll = false;
        }
      }
    }
  }

  // getVariableData(): void {
  //   this.Loader.showLoader();
  //   this.$unSubscribeSubmitData3 = this.crossTabService
  //     .getVariableData(this.dataArray, this.isBrandAnalysis)
  //     .subscribe((result: results) => {
  //       // Response is valid
  //       if (result.HasValidData) {
  //         let JsonData = JSON.parse(result.Data);
  //         if (this.isBrandAnalysis) {
  //           JsonData.forEach((x: any) => {
  //             if (x.is_brandanalysis == 1) {
  //               x.Level2 = '';
  //             } else if (x.is_brandanalysis == 2) {
  //               x.Level3 = '';
  //             } else if (x.is_brandanalysis == 3) {
  //               x.Level4 = '';
  //             } else if (x.is_brandanalysis == 4) {
  //               x.Level5 = '';
  //             }
  //           });
  //         }

  //         this.variableTabData = JsonData;
  //         this.Loader.hideLoader();
  //         if (this.variableTabData.length > 0) {
  //           //this.BindVariableDataLeftPanel(this.variableTabData);
  //           this.crossTabService.setVariableTabData(this.variableTabData);
  //         }
  //       } else {
  //         // this.errorPopup(result.ExceptionMessage);
  //         this.Loader.hideLoader();
  //       }
  //       //hide the loader
  //     });
  // }

  BindVariableDataPanelMultiple(Variableresult: any): void {
    this.variableListMultiMarketAndCateg = [];
    this.isVariableTab = true;
    this.is_load_btn = false;
    this.isEntry_Tab = false;
    this.sidePanelblock = false;
    this.isEntry_Point = false;
    this.entry_items_expand = '';
    this.dimensionList = [];
    this.btnVisible.emit({
      save: true,
      load: true,
      custom_groups: this.isconfigCustomGrpPresent ? true : false,
      custom_calc: false,
      create_table: true,
      weighted_btns: true,
    });
    this.entryListChange.emit(this.entryPanel);
    if (this.isMultiMarketOrCateg) {
      this.dataListChange.emit(this.dataArray_Multiple);
    } else {
      this.dataListChange.emit(this.dataArray);
    }

    const result = _.sortBy(Variableresult, 'sort_id');

    const Level0VariablesAll = _.uniq(
      _.map(
        _.filter(result, (item) => item.Level0),
        'Level0'
      )
    );

    // Collect ALL entry point variable codes to identify EP data in Level0
    const allEPVariableCodesMulti: string[] = (this.entryPointsData.EntryPoints || [])
      .filter((ep: any) => ep.VariableCode && ep.study == this.selected_study)
      .map((ep: any) => ep.VariableCode.toLowerCase());

    this.Level0Variables = Level0VariablesAll.filter((item) => {
      // Check if this Level0 has data matching any entry point variable code
      // const isEPByVariableCode = allEPVariableCodesMulti.length > 0 &&
      //   !this.level0EP.includes(item) &&
      //   result.some((r: any) => r.Level0 === item &&
      //     allEPVariableCodesMulti.includes(r.data_variable_code?.toLowerCase()));

      if (!this.level0EP.includes(item)) {
        if (
          this.singleorMultiSelectMandatory1
            .toLowerCase()
            .includes(item.toLowerCase()) ||
          this.brandMandatory3.toLowerCase().includes(item.toLowerCase()) ||
          this.timeperiodMandatory2.toLowerCase().includes(item.toLowerCase())
        ) {
          return item;
        } else {
          this.level0Filters.push(item);
        }
      } else {
        this.level0EntryForOutput.push(item);
      }
    });

    if (this.Level0Variables.length > 0) {
      for (let i = 0; i < this.Level0Variables.length; i++) {
        if (
          this.Level0Variables[0] == 'Markets' &&
          (this.Level0Variables[i] == 'Time Period' || this.Level0Variables[i] == 'Brands')
        ) {
          continue;
        }
        const level0 = this.Level0Variables[i];

        let listToUpdate = [];

        listToUpdate = _.sortBy(
          _.filter(result, (item) => item.Level0 === level0),
          'sort_id'
        );

        // Get unique sequence values
        const uniqueSequenceValues = _.uniq(_.map(listToUpdate, 'sequence'));

        let level1Array = [];
        if (
          uniqueSequenceValues.includes(1) ||
          uniqueSequenceValues.includes(3)
        )
          level1Array = this.createNestedLevels(
            listToUpdate,
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            level0,
            'Level0',
            0,
            true
          );
        else if (
          uniqueSequenceValues.includes(2) ||
          uniqueSequenceValues.includes(4)
        )
          level1Array = this.createNestedLevels(
            listToUpdate,
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            level0,
            'Level0',
            1,
            false
          );

        //Changing the Levels based on FOM for option 1,2,3,4
        // let num = 4;
        // level1Array = this.AdjustLevels(num, level1Array);

        this.variableListMultiMarketAndCateg.push({
          Level0: level0,
          isEntryPoint: level1Array.some((item: any) => item.isEntryPoint),
          hasNextLevel: true,
          is_selected: false,
          Level1: level1Array,
        });
      }
    }
    if (this.selectedcompareacrossOption == 'Multiple Markets') {
      this._configService.brandSortId = _.cloneDeep(
        this.variableListMultiMarketAndCateg
          .filter((v) => v.Level0 == 'Markets')[0]
          .Level1[0].Level2.map((l: any) => ({
            name: l.Level2_value,
            sortId: l.sort_id,
          }))
      );
    }
  }

  level0EntryForOutput: any[] = [];
  variableListEpForOutput: any[] = [];
  BindLocalStorageVariableDataPanel(): void {
    let localUserdefined: any = localStorage.getItem('leftPanelFilters');
    if (
      localUserdefined != undefined &&
      localUserdefined != null &&
      localUserdefined != ''
    ) {
      const index = this.variableListFilter.findIndex(
        (x) => x.LevelMinus === 'Filters'
      );
      if (index != -1) {
        const useDefinedIndex = this.variableListFilter[index].Level1.findIndex(
          (x) => x.Level0 === 'Custom Percentage Variable - User Defined'
        );
        if (useDefinedIndex != -1) {
          localUserdefined = JSON.parse(localUserdefined);

          //add update item from existing variableListFilter.
          if (
            localUserdefined.addUpdateRecord &&
            localUserdefined.addUpdateRecord.length > 0
          ) {
            localUserdefined.addUpdateRecord.forEach((record: any) => {
              const isExistItem = this.variableListFilter[index].Level1[
                useDefinedIndex
              ].Level1.findIndex((x) => x.Level1_value === record);
              if (isExistItem != -1) {
                var filterItem =
                  this.variableListFilter[index].Level1[useDefinedIndex].Level1[
                  isExistItem
                  ];
                filterItem.Level1_value = record.selection_name;
                filterItem.data_variable_code = record.selection_name;
                filterItem.response_code = record.selection_name;
                filterItem.tooltip = record.selection_name;
                filterItem.kibanaFilterScript = record.selection_query;
                this.variableListFilter[index].Level1[useDefinedIndex].Level1[
                  isExistItem
                ] = filterItem;
              } else {
                let result: any = {
                  Level1_value: record.selection_name,
                  Level2: [],
                  calc_type: '',
                  customCalculationId: '',
                  customGroupId: '00000000-0000-0000-0000-000000000000',
                  dataYearCode: 'Yearcode',
                  data_variable_code: record.selection_name,
                  date: '0001-01-01T00:00:00',
                  derived_metric_calculation: '',
                  hasNextLevel: false,
                  isCustomCalcPresent: false,
                  isCustomGrpPresent: true,
                  isEntryPoint: false,
                  is_brand_analysis: 0,
                  is_derived: false,
                  is_dimension: false,
                  is_multi_punch: 0,
                  is_selected: false,
                  is_time_Period_Present: true,
                  kibanaFilterScript: record.selection_query,
                  response_code: record.selection_name,
                  sort_id: 730854,
                  tooltip: record.selection_name,
                  year_code: null,
                };
                this.variableListFilter[index].Level1[
                  useDefinedIndex
                ].Level1.push(result);
                this.variableList.forEach(level0Item => {
                  if (level0Item.Level0 === 'Audience') {

                    level0Item.Level1.forEach((level1Item: any) => {
                      if (level1Item.Level0 === 'Custom Percentage Variable - User Defined') {
                        const updatedResult = {
                          ...result,
                          Level2_value: result.Level1_value
                        };

                        delete updatedResult.Level1_value;
                        level1Item.Level2.push(updatedResult);  // <-- push here
                      }
                    });

                  }
                });
              }
            });
          }

          //delete item from existing variableListFilter.
          if (
            localUserdefined.deleteRecord &&
            localUserdefined.deleteRecord.length > 0
          ) {
            localUserdefined.deleteRecord.forEach((record: any) => {
              const isExistItem = this.variableListFilter[index].Level1[
                useDefinedIndex
              ].Level1.findIndex((x) => x.Level1_value === record);
              if (isExistItem != -1) {
                const existItem = this.variableListFilter[index].Level1[useDefinedIndex]
                  .Level1[isExistItem];

                this.variableListFilter[index].Level1[useDefinedIndex].Level1 =
                  this.variableListFilter[index].Level1[useDefinedIndex].Level1.filter((x) => x != existItem);
              }
            });
          }
        }
      }
    }
    localStorage.removeItem('leftPanelFilters');
  }

  BindVariableDataPanel(Variableresult: any): void {
    this.variableList = [];
    this.isVariableTab = true;
    this.is_load_btn = false;
    this.isEntry_Tab = false;
    this.sidePanelblock = false;
    this.isEntry_Point = false;
    this.entry_items_expand = '';
    this.dimensionList = [];
    this.btnVisible.emit({
      save: true,
      load: true,
      custom_groups: this.isconfigCustomGrpPresent ? true : false,
      custom_calc: false,
      create_table: true,
      weighted_btns: true,
    });
    this.entryListChange.emit(this.entryPanel);
    if (this.isMultiMarketOrCateg) {
      // this.dataListChange.emit(this.dataArray_Multiple);
      const dataArray = [...this.dataArray, ...this.dataArray_Multiple];
      this.dataListChange.emit(dataArray);
    } else {
      this.dataListChange.emit(this.dataArray);
    }

    const result = _.sortBy(Variableresult, 'sort_id');
    this.audienceRawVariableData = result;

    //contains dimension variable codes
    this.dimensionVariableList = this.snapshotType_details
      .filter(
        (type: any) => type.snapshot_type == this.selectedcompareacrossOption
      )[0]
      .dimension.map((dim: any) => dim.variable_code.toLowerCase());

    let dimensionData = _.uniq(
      result.filter((res: any) =>
        this.dimensionVariableList.includes(res.variable_code?.toLowerCase())
      )
    );
    let level0Dimensions = _.uniq(dimensionData.map((dim: any) => dim.Level0));

    let allDimensionDataExceptDim = _.uniq(
      result.filter(
        (res: any) =>
          level0Dimensions.includes(res.Level0) &&
          !this.dimensionVariableList.includes(res.variable_code?.toLowerCase())
      )
    );
    let level0DimensionsExceptDim = allDimensionDataExceptDim.map(
      (dim: any) => dim.Level0
    );

    let Level0VariablesAll = _.uniq(
      _.map(
        _.filter(result, (item) => item.Level0),
        'Level0'
      )
    );

    // additional code to add entry point if not there in above code
    // const entrypointnames = _.uniq(_.map(this.dataArray, (entry) => (Object.values(entry)[0] as any).Level1));
    // entrypointnames.forEach((entrypointname) => {
    //   if(!Level0VariablesAll.includes(entrypointname)){
    //     Level0VariablesAll.push(entrypointname);
    //   }
    // });

    Level0VariablesAll.sort((a, b) => {
      if (level0Dimensions.includes(a) && !level0Dimensions.includes(b)) {
        return -1;
      } else if (
        !level0Dimensions.includes(a) &&
        level0Dimensions.includes(b)
      ) {
        return 1;
      } else {
        return 0;
      }
    });

    this.level0Filters = [];
    this.level0EntryForOutput = [];

    // Collect ALL entry point variable codes to identify EP data in Level0
    // pick only enabled entry points form the config
    const selectedEPVariableCodes: string[] = (
      this.snapshotType_details
        .find((type: any) => type.snapshot_type == this.selectedcompareacrossOption)
        ?.entry_point || []
      )
      .filter((ep: any) => ep.is_selected === true)
      .map((ep: any) => ep.variable_code.toLowerCase());

    const allEPVariableCodes: string[] = (this.entryPointsData.EntryPoints || [])
      .filter((ep: any) =>
        ep.VariableCode &&
        ep.study == this.selected_study &&
        selectedEPVariableCodes.includes(ep.VariableCode.toLowerCase())
      )
    .map((ep: any) => ep.VariableCode.toLowerCase());

    this.Level0Variables = Level0VariablesAll.filter((item) => {
      // Check if this Level0 has data matching any entry point variable code
      const isEPByVariableCode = allEPVariableCodes.length > 0 &&
        !this.level0EP.includes(item) &&
        result.some((r: any) => r.Level0 === item &&
          allEPVariableCodes.includes(r.data_variable_code?.toLowerCase()));

      if (!this.level0EP.includes(item) && !isEPByVariableCode) {
        if (
          level0DimensionsExceptDim
            .toString()
            .toLowerCase()
            .includes(item.toLowerCase())
        )
          this.level0Filters.push(item);
        if (
          level0Dimensions.toString().toLowerCase().includes(item.toLowerCase())
        )
          return item;

        if (
          this.singleorMultiSelectMandatory1
            .toLowerCase()
            .includes(item.toLowerCase()) ||
          this.brandMandatory3.toLowerCase().includes(item.toLowerCase()) ||
          (this.timeperiodMandatory2
            .toLowerCase()
            .includes(item.toLowerCase()) &&
            !this._configService.isStaticTimeFrame)
        ) {
          if (this.singleorMultiSelectMandatory1.toLowerCase().includes(item.toLowerCase()) && item.toLowerCase() == "audience") {
            
            const showAudience =
              
            this._configService.outputSnapshotData?.audienceComparsion?.some(
              
                (x: any) => x.is_selected

            ) ||
              
            this._configService.outputSnapshotData?.audienceTotalSample?.is_selected;
            

            
            if (!showAudience) {
              
              return false; // Do not show Audience in left panel
              
}
            this.isSingleaudienceCohortType = this._configService.outputSnapshotData.audienceCohortType.toLowerCase() == 'single';
            this.isAudienceTotalSample = this._configService.outputSnapshotData.audienceTotalSample?.is_selected ? true : false;
            this.level0Filters.push(item);
            return item;
          }
          else {
            return item;
          }
        }
        else {
          if (!(this.singleorMultiSelectMandatory1.toLowerCase().includes('audience') && item.toLowerCase() == "brands")) {
            this.level0Filters.push(item);
          }

        }
      } else {
        this.level0EntryForOutput.push(item);
      }
    });

    if (this.Level0Variables.length > 0) {
      for (let i = 0; i < this.Level0Variables.length; i++) {
        const level0 = this.Level0Variables[i];

        let listToUpdate = [];
        if (
          this.dimensionVariableList.length > 0 &&
          level0Dimensions.includes(level0)
        ) {
          listToUpdate = _.sortBy(
            _.filter(dimensionData, (item) => item.Level0 === level0),
            'sort_id'
          );
        } else if (level0 == 'Audience') {
          const compareKeys = this._configService.outputSnapshotData.audienceComparsion.filter((x: any) => x.is_selected)
            .map((x: any) => x.config_name.split("|").map((s: string) => s.trim()));
       listToUpdate = _.sortBy(
          _.filter(result, (item: any) =>
            item.Level0?.trim() === level0?.trim() &&
            compareKeys.some(([lvl1, lvl2]: [string, string]) =>
              (
                item.Level1?.trim() === lvl2?.trim() ||
                item.Level2?.trim() === lvl2?.trim() ||
                item.Level3?.trim() === lvl2?.trim() ||
                item.Level4?.trim() === lvl2?.trim()
              )
            )
          ),
          'sort_id'
        );

        }
        else {
          listToUpdate = _.sortBy(
            _.filter(result, (item) => item.Level0 === level0),
            'sort_id'
          );
        }

        // Get unique sequence values
        const uniqueSequenceValues = _.uniq(_.map(listToUpdate, 'sequence'));

        let level1Array = [];
        if (
          (uniqueSequenceValues.includes(1) ||
            uniqueSequenceValues.includes(3)) && level0 != 'Audience'
        )
          level1Array = this.createNestedLevels(
            listToUpdate,
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            level0,
            'Level0',
            0,
            true
          );
        else if (
          uniqueSequenceValues.includes(2) ||
          uniqueSequenceValues.includes(4) || level0 == 'Audience'
        )
          level1Array = this.createNestedLevels(
            listToUpdate,
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            level0,
            'Level0',
            1,
            false
          );

        //Changing the Levels based on FOM for option 1,2,3,4
        // let num = 4;
        // level1Array = this.AdjustLevels(num, level1Array);

        this.variableList.push({
          Level0: level0,
          isEntryPoint: level1Array.some((item: any) => item.isEntryPoint),
          hasNextLevel: true,
          is_selected: false,
          Level1: level1Array,
        });

        if (this.defaultBrandList?.length > 0) {
          const brandsItem = this.variableList.find((v: any) => v.Level0 === 'Brands');
          if (brandsItem) {
            const defaultLevel1 = brandsItem.Level1?.find(
              (l1: any) => l1.Level1_value === 'Default'
            );
            if (defaultLevel1 && Array.isArray(defaultLevel1.Level2)) {
              defaultLevel1.Level2 = this.getDefaultBrandLevel2Items(defaultLevel1.Level2, defaultLevel1.Level2.length);
            }
          }
        }
      
      }
    }

    if (this.isAudienceTotalSample) {
      this.variableList.forEach(item => {
        if (item.Level0 === "Audience") {
          const alreadyExists = item.Level1.some(l => l.Level1_value === "Total Sample");
          this.totalSampleObj.data_variable_code = this._configService?.outputSnapshotData?.audienceTotalSample?.config_name;
          if (!alreadyExists) {
            item.Level1.unshift(this.totalSampleObj);  
          }
        }
      });
      
    }

    //temporary fix for sorting in left panel for time period
    const timePeriod = this.variableList.find(
      (v) => v.Level0 === 'Time Period'
    );
    if (timePeriod) {
      const weekData = timePeriod.Level1.find(
        (l1: any) => l1.Level1_value === 'Week'
      );

      if (weekData && Array.isArray(weekData.Level2)) {
        weekData.Level2 = [...weekData.Level2].sort(
          (a: any, b: any) => {
            const getWeekValue = (item: any): number => {
              const label = String(item.Level2_value ?? '').trim();

              const match = label.match(
                /week[\s_-]*(\d{1,2})[\s_-]*(\d{4})/i
              );

              if (match) {
                const weekNumber = Number(match[1]);
                const year = Number(match[2]);

                return year * 100 + weekNumber;
              }

              const timestamp = Date.parse(item.date ?? item.Date ?? '');

              if (!Number.isNaN(timestamp)) {
                return timestamp;
              }

              return Number(item.sort_id) || 0;
            };

            return getWeekValue(b) - getWeekValue(a);
          }
        );
      }
      const monthData = timePeriod.Level1.find(
        (l1) => l1.Level1_value === 'Month'
      );
      if (monthData && Array.isArray(monthData.Level2)) {
        monthData.Level2 = monthData.Level2.sort((a, b) => {
          const dateA = this.parseDate(a.Level2_value);
          const dateB = this.parseDate(b.Level2_value);

          if (dateA && dateB) {
            // return dateA.getTime() - dateB.getTime(); // Sort by ascending date
            return dateB.getTime() - dateA.getTime();
          }
          return 0; // Keep original order if invalid dates
        });
      }
      const quarterData = timePeriod.Level1.find(
        (l1) => l1.Level1_value === 'Quarter'
      );
      if (quarterData && Array.isArray(quarterData.Level2)) {
        quarterData.Level2 = quarterData.Level2.sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          if (!isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
            // return dateA.getTime() - dateB.getTime();
          return dateB.getTime() - dateA.getTime();
          }
          return 0;
        });
      }

      // Sort Year in ascending order
      const yearData = timePeriod.Level1.find(
        (l1) => l1.Level1_value === 'Year'
      );
      if (yearData && Array.isArray(yearData.Level2)) {
        yearData.Level2 = yearData.Level2.sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          if (!isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
            // return dateA.getTime() - dateB.getTime();
            return dateB.getTime() - dateA.getTime();
          }
          return 0;
        });
      }

      // Sort Rolling TPs (3MMA/4MMA/6MMA/12MMA) chronologically — same as Month
      const rollingNames = ['3MMA', '4MMA', '6MMA', '12MMA'];
      for (const rollingName of rollingNames) {
        const rollingData = timePeriod.Level1.find(
          (l1) => l1.Level1_value === rollingName
        );
        if (rollingData && Array.isArray(rollingData.Level2)) {
          rollingData.Level2 = rollingData.Level2.sort((a, b) => {
            const parsedA = this.parseDate(a.Level2_value);
            const parsedB = this.parseDate(b.Level2_value);
            if (parsedA && parsedB) {
              // return parsedA.getTime() - parsedB.getTime();
            return parsedB.getTime() - parsedA.getTime();
            }
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            if (!isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
              // return dateA.getTime() - dateB.getTime();
              return dateB.getTime() - dateA.getTime();
            }
            return 0;
          });
        }
      }
    }
    if (this.selectedcompareacrossOption == 'Multiple Brands') {
      this._configService.brandSortId = _.cloneDeep(
        this.variableList
          .filter((v) => v.Level0 == 'Brands')[0]
          .Level1[0].Level2.map((l: any) => ({
            name: l.Level2_value,
            sortId: l.sort_id,
          }))
      );
    }
    //for filters
    this.variableListFilter = [];
    if (this.level0Filters.length > 0) {
      let filtersLevel0: {
        LevelMinus: string;
        isEntryPoint: boolean;
        hasNextLevel: boolean;
        is_selected: boolean;
        Level1: any[];
      } = {
        LevelMinus: 'Filters',
        isEntryPoint: false,
        hasNextLevel: true,
        is_selected: false,
        Level1: [],
      };

      let result1 = result.filter((res: any) => {
        return (
          res.Level0 != 'Metrics' ||
          (res.Level0 == 'Metrics' && res.calculation_type != 'mean' && res.calculation_type.toLowerCase() != 'meanpercentage')
        );
      });

      for (let i = 0; i < this.level0Filters.length; i++) {
        const level0 = this.level0Filters[i];

        let listToUpdate = [];
        if (
          this.dimensionVariableList.length > 0 &&
          level0DimensionsExceptDim.includes(level0)
        ) {
          listToUpdate = _.sortBy(
            _.filter(
              allDimensionDataExceptDim,
              (item) => item.Level0 === level0
            ),
            'sort_id'
          );
        } else {
          listToUpdate = _.sortBy(
            _.filter(result1, (item) => item.Level0 === level0),
            'sort_id'
          );
        }

        // Get unique sequence values
        const uniqueSequenceValues = _.uniq(_.map(listToUpdate, 'sequence'));

        let level1ArrayItem: any[] = [];
        if (
          uniqueSequenceValues.includes(1) ||
          uniqueSequenceValues.includes(3)
        )
          level1ArrayItem = this.createNestedLevels(
            listToUpdate,
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            level0,
            'Level0',
            0,
            true
          );
        else if (
          uniqueSequenceValues.includes(2) ||
          uniqueSequenceValues.includes(4)
        )
          level1ArrayItem = this.createNestedLevels(
            listToUpdate,
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            'Level0',
            level0,
            'Level0',
            1,
            false
          );

        //Changing the Levels based on FOM for option 1,2,3,4
        // let num = 3;
        // level1ArrayItem = this.AdjustLevels(num, level1ArrayItem);

        filtersLevel0.Level1.push({
          Level0: level0,
          isEntryPoint: false,
          hasNextLevel: true,
          Level1: level1ArrayItem,
          is_selected: false,
        });
      }

      this.variableListFilter.push(filtersLevel0);
    }

    //-------------This is for entry points for output

    let selectedEPAll: any[] = [];
    let selectedEPAllParent: any[] = [];

    let aa = this.dataArray.map(
      (obj) =>
        Object.keys(obj)
          .filter((key) => key.startsWith('EntryPoint'))
          .map((key) => obj[key]) // Access the values of those keys
    );
    for (let i = 0; i < this.dataArray.length; i++) {
      if (aa[i][0] != undefined) {
        selectedEPAll.push(
          ...aa[i][0]?.Level2[0].MetricOptions.map((mo: any) => mo.Name)
        );
        selectedEPAllParent.push(aa[i][0]?.Level2[0].Parent);
      }
    }

    if (this.level0EntryForOutput.length > 0) {
      this.variableListEpForOutput = [];
      for (let i = 0; i < this.level0EntryForOutput.length; i++) {
        const level0 = this.level0EntryForOutput[i];
        const listToUpdate = _.sortBy(
          _.filter(result, (item) => item.Level0 === level0),
          'sort_id'
        );

        // Get unique sequence values
        const uniqueSequenceValues = _.uniq(_.map(listToUpdate, 'sequence'));

        let level1Array = [];
        if (
          uniqueSequenceValues.includes(1) ||
          uniqueSequenceValues.includes(3)
        )
          level1Array = this.createNestedLevelsEPForOutput(
            listToUpdate,
            '',
            'Level0',
            level0,
            'Level0',
            0,
            true,
            selectedEPAll,
            selectedEPAllParent
          );
        else if (
          uniqueSequenceValues.includes(2) ||
          uniqueSequenceValues.includes(4)
        )
          level1Array = this.createNestedLevelsEPForOutput(
            listToUpdate,
            '',
            'Level0',
            level0,
            'Level0',
            1,
            false,
            selectedEPAll,
            selectedEPAllParent
          );

        //Changing the Levels based on FOM for option 1,2,3,4
        // let num = 4;
        // level1Array = this.AdjustLevels(num, level1Array);
        // this.variableListEpForOutput = [];

        this.variableListEpForOutput.push({
          Level0: level0,
          // isEntryPoint: level1Array.some((item: any) => item.isEntryPoint),
          isEntryPoint: true,
          hasNextLevel: true,
          is_selected: true,
          Level1: level1Array,
        });
      }
    }
    this.AddCustomPercentageToAudience();
  }

  AddCustomPercentageToAudience() {
    // 1. Find Audience in variableList
    const audienceObj = this.variableList.find(
      (x: any) => x.Level0?.toLowerCase() === 'audience'
    );

    if (!audienceObj) return;

    if (!Array.isArray(audienceObj.Level1)) {
      audienceObj.Level1 = [];
    }

    // 2. Get all custom percentage blocks
    const customBlocks = this.variableListFilter[0].Level1.filter(
      (x: any) => x.Level0?.toLowerCase().includes('custom percentage variable')
    );

    // 3. Process each block
    customBlocks.forEach((block: any) => {
      // Copy all properties of the block
      const newBlock: any = { ...block };

      // Replace Level1 with flattened Level2 array
      newBlock.Level2 = [];
      newBlock.Level1_value = block.Level0; // Keep original Level0 as Level1_value
      delete newBlock.Level1; // remove old Level1 wrapper

      // Flatten all items from original block.Level1
      (block.Level1 || []).forEach((item: any) => {
        const level2Item = { ...item, Level2_value: item.Level1_value };
        delete level2Item.Level1_value;
        newBlock.Level2.push(level2Item);
      });

      audienceObj.Level1.push(newBlock);
    });

    // variableListFilter remains untouched
  }

  parseDate(value: string): Date | null {
    // Extract and parse "Jan_2021" format
    const parts = value?.split('_');
    if (parts?.length === 2) {
      const month = parts[0];
      const year = parts[1];
      return new Date(Date.parse(`${month} 1, ${year}`)); // Convert to a valid Date object
    }
    return null; // Return null for invalid or missing values
  }
  removeLastLevel: boolean = false;
  createNestedLevels(
    data: any[],
    parentParent4Value:String,
    parentLevel4Key: string,
    parentParent3Value:String,
    parentLevel3Key: string,
    parentParent2Value:String,
    parentLevel2Key: string,
    parentParentValue: string,
    parentLevelKey: string,
    parentValue: string,
    levelKey: string,
    level: number,
    isBrandAudience: Boolean
  ): any[] {
    let nextLevelKey = `Level${level + 1}`;
    const levelVariables = _.uniq(
      _.map(
        _.filter(
          data,
          (item) =>
            (parentLevel4Key=='Level0' ||  item[parentLevel4Key] == parentParent4Value) && 
            (parentLevel3Key=='Level0' ||  item[parentLevel3Key] == parentParent3Value) && 
            (parentLevel2Key=='Level0' ||  item[parentLevel2Key] == parentParent2Value) && 
            (parentLevelKey == 'Level0' ||  item[parentLevelKey] == parentParentValue) &&
            item[levelKey] === parentValue &&
            item[nextLevelKey]
        ),
        nextLevelKey
      )
    );
    if (levelVariables.length > 0) {
      return levelVariables.map((levelVar) => {
        const filteredItems = _.filter(
          data,
          (item) =>
            (parentLevelKey == 'Level0' ||
              item[parentLevelKey] == parentParentValue) &&
            item[levelKey] === parentValue &&
            item[nextLevelKey] === levelVar
        );
        const nextLevelData = this.createNestedLevels(
          data,
          parentParent3Value,
          parentLevel3Key,
          parentParent2Value,
          parentLevel2Key,
          parentParentValue,
          parentLevelKey,
          parentValue,
          levelKey,
          levelVar,
          nextLevelKey,
          level + 1,
          isBrandAudience
        );

        if (this.removeLastLevel) {
          this.removeLastLevel = false;
          if (isBrandAudience)
            return {
              [`Level${level + 1}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 2}`]: [],
              hasNextLevel: false,
              ...this.extractAdditionalData(filteredItems),
            };
          else
            return {
              [`Level${level}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 1}`]: [],
              hasNextLevel: false,
              ...this.extractAdditionalData(filteredItems),
            };
        } else {
          if (isBrandAudience)
            return {
              [`Level${level + 1}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 2}`]: nextLevelData,
              hasNextLevel: true,
              ...this.extractAdditionalData(filteredItems),
            };
          else
            return {
              [`Level${level}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 1}`]: nextLevelData,
              hasNextLevel: true,
              ...this.extractAdditionalData(filteredItems),
            };
        }
      });
    } else {
      const filteredItems = _.filter(
        data,
        (item) =>
           (parentLevel4Key=='Level0' ||  item[parentLevel4Key] == parentParent4Value) && 
            (parentLevel3Key=='Level0' ||  item[parentLevel3Key] == parentParent3Value) && 
            (parentLevel2Key=='Level0' ||  item[parentLevel2Key] == parentParent2Value) &&
            (parentLevelKey == 'Level0' ||item[parentLevelKey] == parentParentValue) &&
          item[levelKey] === parentValue
      );
      return filteredItems.map((item) => {
        const metricOption = item.MetricOption || '';

        let num = item.sequence;

        if (isBrandAudience) {

          if (num == 3 || metricOption == '') {
            this.removeLastLevel = true; //for 3
          } else {
            this.removeLastLevel = false; //for 1
          }

          return {
            [`Level${level + 1}_value`]: item[nextLevelKey] || metricOption,
            isEntryPoint: false,
            [`Level${level + 2}`]: [],
            hasNextLevel: false,
            ...this.extractAdditionalData([item]),
          };
        } else {

          if ((num == 4 || metricOption == '') || (data[0].Level0 == 'Audience' && num == 3)) {
            this.removeLastLevel = true; // for seq=4
          } else {
            this.removeLastLevel = false; //seq =2
          }
          return {
            [`Level${level}_value`]: item[nextLevelKey] || metricOption,
            isEntryPoint: false,
            [`Level${level + 1}`]: [],
            hasNextLevel: false,
            ...this.extractAdditionalData([item]),
          };
        }
      });
    }
  }

  extractAdditionalData(items: any[]): any {
    const firstItem = items[0];
    return {
      is_derived: firstItem.is_derived_variable,
      calc_type: firstItem.calculation_type,
      tooltip: firstItem.tooltip,
      data_variable_code: firstItem.data_variable_code,
      response_code: firstItem.response_code,
      derived_metric_calculation: firstItem.derived_metric_calculation,
      sort_id: firstItem.Level0 == 'Time Period' ? Number(firstItem.level1_sort_id) : Number(firstItem.sort_id),
      is_multi_punch: firstItem.is_multi_punch,
      date: firstItem.date,
      year_code: firstItem.year_code,
      is_dimension: firstItem.is_dimension,
      isCustomGrpPresent: firstItem.is_CustomGroup,
      isCustomCalcPresent: firstItem.is_CustomCalculation,
      // kibanaFilterScript: firstItem.customGroupQuery,
      kibanaFilterScript: firstItem.is_CustomGroup
        ? firstItem.customGroupQuery
        : firstItem.customCalculation
          ? firstItem.customCalculationQuery
          : '',
      dataYearCode: firstItem.dataYearCode,
      is_time_Period_Present: firstItem.is_time_Period_Present,
      customGroupId: firstItem.customGroupId,
      customCalculationId: firstItem.customCalculationId,
      is_brand_analysis: firstItem.is_brandanalysis,
      is_selected: false,
      Weekno_forSigcalculation: firstItem.Weekno_forSigcalculation
    };
  }

  createNestedLevelsEPForOutput(
    data: any[],
    parentParentValue: string,
    parentLevelKey: string,
    parentValue: string,
    levelKey: string,
    level: number,
    isBrandAudience: Boolean,
    selectedEPAll: any[],
    selectedEPAllParent: any[]
  ): any[] {
    const nextLevelKey = `Level${level + 1}`;
    const levelVariables = _.uniq(
      _.map(
        _.filter(
          data,
          (item) =>
            (parentLevelKey == 'Level0' ||
              item[parentLevelKey] == parentParentValue) &&
            item[levelKey] === parentValue &&
            item[nextLevelKey]
        ),
        nextLevelKey
      )
    );

    if (levelVariables.length > 0) {
      return levelVariables.map((levelVar) => {
        const filteredItems = _.filter(
          data,
          (item) =>
            (parentLevelKey == 'Level0' ||
              item[parentLevelKey] == parentParentValue) &&
            item[levelKey] === parentValue &&
            item[nextLevelKey] === levelVar
        );
        const nextLevelData = this.createNestedLevelsEPForOutput(
          data,
          parentValue,
          levelKey,
          levelVar,
          nextLevelKey,
          level + 1,
          isBrandAudience,
          selectedEPAll,
          selectedEPAllParent
        );

        if (this.removeLastLevel) {
          this.removeLastLevel = false;
          if (isBrandAudience)
            return {
              [`Level${level + 1}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 2}`]: [],
              hasNextLevel: false,
              ...this.extractAdditionalDataEPForOutput(
                filteredItems,
                selectedEPAll,
                selectedEPAllParent,
                levelVar,
                ''
              ),
            };
          else
            return {
              [`Level${level}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 1}`]: [],
              hasNextLevel: false,
              ...this.extractAdditionalDataEPForOutput(
                filteredItems,
                selectedEPAll,
                selectedEPAllParent,
                levelVar,
                ''
              ),
            };
        } else {
          if (isBrandAudience)
            return {
              [`Level${level + 1}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 2}`]: nextLevelData,
              hasNextLevel: true,
              ...this.extractAdditionalDataEPForOutput(
                filteredItems,
                selectedEPAll,
                selectedEPAllParent,
                levelVar,
                levelVar
              ),
            };
          else
            return {
              [`Level${level}_value`]: levelVar,
              isEntryPoint: nextLevelData.some((item) => item.isEntryPoint),
              [`Level${level + 1}`]: nextLevelData,
              hasNextLevel: true,
              ...this.extractAdditionalDataEPForOutput(
                filteredItems,
                selectedEPAll,
                selectedEPAllParent,
                levelVar,
                levelVar
              ),
            };
        }
      });
    } else {
      const filteredItems = _.filter(
        data,
        (item) =>
          (parentLevelKey == 'Level0' ||
            item[parentLevelKey] == parentParentValue) &&
          item[levelKey] === parentValue
      );
      return filteredItems.map((item) => {
        const metricOption = item.MetricOption || '';
        let num = item.sequence;

        if (isBrandAudience) {
          if (num == 3 || metricOption == '') {
            this.removeLastLevel = true;
          } else {
            this.removeLastLevel = false;
          }

          return {
            [`Level${level + 1}_value`]: item[nextLevelKey] || metricOption,
            isEntryPoint: false,
            [`Level${level + 2}`]: [],
            hasNextLevel: false,
            ...this.extractAdditionalDataEPForOutput(
              [item],
              selectedEPAll,
              selectedEPAllParent,
              item[nextLevelKey] || metricOption,
              ''
            ),
          };
        } else {
          if (num == 4 || metricOption == '') {
            this.removeLastLevel = true;
          } else {
            this.removeLastLevel = false;
          }
          return {
            [`Level${level}_value`]: item[nextLevelKey] || metricOption,
            isEntryPoint: false,
            [`Level${level + 1}`]: [],
            hasNextLevel: false,
            ...this.extractAdditionalDataEPForOutput(
              [item],
              selectedEPAll,
              selectedEPAllParent,
              item[nextLevelKey] || metricOption,
              ''
            ),
          };
        }
      });
    }
  }

  extractAdditionalDataEPForOutput(
    items: any[],
    selectedEPAll: any,
    selectedEPAllParent: any,
    levelValue: any,
    levelParentValue: any
  ): any {
    const firstItem = items[0];

    return {
      is_derived: firstItem.is_derived_variable,
      calc_type: firstItem.calculation_type,
      tooltip: firstItem.tooltip,
      data_variable_code: firstItem.data_variable_code,
      response_code: firstItem.response_code,
      derived_metric_calculation: firstItem.derived_metric_calculation,
      sort_id: firstItem.sort_id,
      is_multi_punch: firstItem.is_multi_punch,
      date: firstItem.date,
      year_code: firstItem.year_code,
      is_dimension: firstItem.is_dimension,
      isCustomGrpPresent: firstItem.is_CustomGroup,
      kibanaFilterScript: firstItem.customGroupQuery,
      dataYearCode: firstItem.dataYearCode,
      is_time_Period_Present: firstItem.is_time_Period_Present,
      customGroupId: firstItem.customGroupId,
      is_brand_analysis: firstItem.is_brandanalysis,
      is_selected:
        selectedEPAll.includes(levelValue) ||
        selectedEPAllParent.includes(levelParentValue),
    };
  }

  AdjustLevels(number: number, filtersLevel0: any) {
    if (number == 4) {
      let lastlev1: boolean = false;
      let lastlev2: boolean = false;
      let lastlev3: boolean = false;
      let lastlev4: boolean = false;
      let lastlev5: boolean = false;
      for (let level1 of filtersLevel0) {
        for (let level2 of level1.Level2) {
          for (let level3 of level2.Level3) {
            for (let level4 of level3.Level4) {
              for (let level5 of level4.Level5) {
                // level5.Level6.forEach((level6: any) => {
                // });
                if (level5.hasNextLevel) {
                  level5.Level6 = [];
                  level5.hasNextLevel = false;
                  lastlev5 = true;
                }
              }
              if (lastlev5) continue;
              else lastlev5 = false;

              if (level4.hasNextLevel) {
                level4.Level5 = [];
                level4.hasNextLevel = false;
                lastlev4 = true;
              }
            }
            if (lastlev4) continue;
            else lastlev4 = false;
            if (level3.hasNextLevel) {
              level3.Level4 = [];
              level3.hasNextLevel = false;
              lastlev3 = true;
            }
          }
          if (lastlev3) continue;
          else lastlev3 = false;
          if (level2.hasNextLevel) {
            level2.Level3 = [];
            level2.hasNextLevel = false;
            lastlev2 = true;
          }
        }
        if (lastlev2) continue;
        else lastlev2 = false;
        if (level1.hasNextLevel) {
          level1.Level2 = [];
          level1.hasNextLevel = false;
        }
      }
    } else if (number == 3) {
      let lastlev1: boolean = false;
      let lastlev2: boolean = false;
      let lastlev3: boolean = false;
      let lastlev4: boolean = false;
      let lastlev5: boolean = false;
      for (let level1 of filtersLevel0) {
        for (let level2 of level1.Level2) {
          for (let level3 of level2.Level3) {
            for (let level4 of level3.Level4) {
              for (let level5 of level4.Level5) {
                if (level5.hasNextLevel) {
                  level5.Level6 = [];
                  level5.hasNextLevel = false;
                  lastlev5 = true;
                }
              }
              if (lastlev5) continue;
              else lastlev5 = false;

              if (level4.hasNextLevel) {
                level4.Level5 = [];
                level4.hasNextLevel = false;
                lastlev4 = true;
              }
            }
            if (lastlev4) continue;
            else lastlev4 = false;

            if (level3.hasNextLevel) {
              level3.Level4 = [];
              level3.hasNextLevel = false;
              lastlev3 = true;
            }
          }
          if (lastlev3) continue;
          else lastlev3 = false;

          if (level2.hasNextLevel) {
            level2.Level3 = [];
            level2.hasNextLevel = false;
            lastlev2 = true;
          }
        }
        if (lastlev2) continue;
        else lastlev2 = false;

        if (level1.hasNextLevel) {
          level1.Level2 = [];
          level1.hasNextLevel = false;
          lastlev1 = true;
        }
      }
    }

    return filtersLevel0;
  }

  IsDimension(parentOption: any) {
    return this.dimensionList.includes(parentOption);
  }

  ClearAll(): void {
    this.isVariableTab = false;
    this.is_load_btn = true;
    this.isClearEverything.emit();
  }

  private isClickInside(event: Event, className: string): boolean {
    return !!(event.target as Element)?.closest(className);
  }

  selectAll(Parent: string, Selection: string) {
    this.isSelectAll = !this.isSelectAll;
    let selectedList: any[] = [];
    let callback: ((item: any) => void) | undefined = undefined;
    selectedList = this.entryPanel_Lvl3;
    callback = (item) =>
      this.checkBoxClick(
        0,
        item.Level,
        '',
        item.Level1,
        item.Level2,
        item.MetricOptions,
        item.variableCode,
        item.responseCode,
        item.mandatory_variable_mapping,
        this.isSelectAll,
        item.e1_variable_code,
        item.e2_variable_code,
        item.e3_variable_code,
        item.dimension
      );
    if (selectedList && callback) {
      this.processSelectedList(selectedList, callback);
    }
  }
  private processSelectedList(
    selectedList: any[],
    callback: (item: any) => void
  ): void {
    for (const item of selectedList) {
      callback(item);
    }
  }

  private isSameSelectedItem(a: any, b: any): boolean {
    return (
      a.response_code === b.response_code &&
      a.variable_label === b.variable_label &&
      a.Level0 === b.Level0 &&
      a.Level1 === b.Level1 &&
      a.Level2 === b.Level2 &&
      (a.Level3 ?? '') === (b.Level3 ?? '') &&
      (a.Level4 ?? '') === (b.Level4 ?? '') &&
      (a.Level5 ?? '') === (b.Level5 ?? '')
    );
  }

  private getAllSelectedItemsFromObjects(): any[] {
    return this.selectedObjects.flatMap((obj) => {
      const key = Object.keys(obj)[0];
      const values = obj[key];
      return Array.isArray(values) ? values : [];
    });
  }

  private isRadioTrackedSelection(item: any): boolean {
    return (
      item?.Level0 === 'Time Period' ||
      (item?.Level0 === 'Audience' && this.isSingleaudienceCohortType)
    );
  }
//removed the old syncVariablesSummaryFromSelectedObjects function and added a new one to preserve non-audience radio-tracked selections when Total Sample audience is active
  // private syncVariablesSummaryFromSelectedObjects(): void {
  //   if (this.isTotalSampleAudienceActive) {
  //     this.variablesSummaryObjRadio = [this.getTotalSampleDisplayObject()];
  //     return;
  //   }
     private syncVariablesSummaryFromSelectedObjects(): void {
    if (this.isTotalSampleAudienceActive) {
      // Preserve non-audience radio-tracked selections (e.g. Time Period) so they
      // still appear in the selection summary / Save Selections view alongside the
      // Total Sample audience marker.
      const preservedRadioSelections = this.getAllSelectedItemsFromObjects().filter(
        (item: any) => this.isRadioTrackedSelection(item) && item?.Level0 !== 'Audience'
      );
      this.variablesSummaryObjRadio = [
        ...preservedRadioSelections,
        this.getTotalSampleDisplayObject(),
      ];
      return;
    }

    const allSelectedItems = this.getAllSelectedItemsFromObjects();

    this.variablesSummaryObj = allSelectedItems.filter(
      (item: any) => item?.Level0 && !this.isRadioTrackedSelection(item) &&
        (item.Level0 !== 'Brands' || item.Level1 === 'Brands' || (this.defaultBrandList?.length > 0 && item.Level1 === 'Default'))
    );

    const radioSelections = allSelectedItems.filter((item: any) =>
      this.isRadioTrackedSelection(item)
    );
    if (radioSelections.length > 0) {
      this.variablesSummaryObjRadio = radioSelections;
    } else {
      this.variablesSummaryObjRadio = this.variablesSummaryObjRadio.filter(
        (item: any) =>
          allSelectedItems.some((selected) =>
            this.isSameSelectedItem(selected, item)
          )
      );
    }
  }

  private removeDuplicateAudienceFromFilterSummary(
    variableSelectionSummary: string,
    variableFilterSelectionSummary: string
  ): string {
    if (
      !variableFilterSelectionSummary ||
      !/audience\s*:/i.test(variableSelectionSummary)
    ) {
      return variableFilterSelectionSummary;
    }

    return variableFilterSelectionSummary
      .split(' | ')
      .map((block) => block.trim())
      .filter((block) => {
        if (!block || !/^audience\s*:/i.test(block)) return true;
        const contentAfterAudience = block.replace(/^audience\s*:\s*/i, '').trim().toLowerCase();
        return !variableSelectionSummary.toLowerCase().includes(contentAfterAudience);
      })
      .join(' | ');
  }

  UpdateSelectionSummary() {
    this.syncVariablesSummaryFromSelectedObjects();
    const infoRibbonDiv = document.querySelector(
      '.InforRibbonEntireSummary'
    ) as HTMLDivElement;
    const infoRibbonTextValuesDiv = document.querySelector(
      '.InforRibbonTextValues'
    ) as HTMLDivElement;

   
    const ep1Element =
      this.dataArray?.find((e: any) => e.EntryPoint1) || {};
    const ep2Element =
      this.dataArray?.find((e: any) => e.EntryPoint2) || {};
    const ep3Element =
      this.dataArray?.find((e: any) => e.EntryPoint3) || {};

    let entryPoints1Level1 = ep1Element.EntryPoint1?.hasOwnProperty(
      'Level1'
    )
      ? ep1Element.EntryPoint1.Level1
      : [];
    let entryPoints1Level2 = ep1Element.EntryPoint1?.hasOwnProperty(
      'Level2'
    )
      ? ep1Element.EntryPoint1.Level2[0].MetricOptions.map(
        (a: any) => a.Name
      ).join(', ')
      : '';

    let entryPoints2Level1 =
      ep2Element.EntryPoint2?.hasOwnProperty('Level1')
        ? ep2Element.EntryPoint2.Level1
        : [];
    let entryPoints2Level2 =
      ep2Element.EntryPoint2?.hasOwnProperty('Level2')
        ? ep2Element.EntryPoint2.Level2[0].MetricOptions.map(
          (a: any) => a.Name
        ).join(', ')
        : '';

    let entryPoints3Level1 =
      ep3Element.EntryPoint3?.hasOwnProperty('Level1')
        ? ep3Element.EntryPoint3.Level1
        : [];
    let entryPoints3Level2 =
      ep3Element.EntryPoint3?.hasOwnProperty('Level2')
        ? ep3Element.EntryPoint3.Level2[0].MetricOptions.map(
          (a: any) => a.Name
        ).join(', ')
        : '';

    // Build ordered list of the entry points that are actually selected. Using a
    // list (instead of tying the "Entry Point:" label to EntryPoint1) guarantees
    // the label is emitted whenever ANY entry point exists — e.g. Multiple
    // Markets/Categories where EntryPoint1 may be empty but EntryPoint2/3 exist.
    // const entryPointPairs: { label: string; values: string }[] = [];
    // if (entryPoints1Level1.length != 0) {
    //   entryPointPairs.push({ label: entryPoints1Level1, values: entryPoints1Level2 });
    // }
    // if (entryPoints2Level1.length != 0) {
    //   entryPointPairs.push({ label: entryPoints2Level1, values: entryPoints2Level2 });
    // }
    // if (entryPoints3Level1.length != 0) {
    //   entryPointPairs.push({ label: entryPoints3Level1, values: entryPoints3Level2 });
    // }
    //removed these code beacause isMandatoryLoadClicked false that why entrypoints are not getting patched in summary
//     const entryPointPairs: { label: string; values: string }[] = [];

// console.log('entryPointData', this._configService.entryPointData);
// console.log('variableListEpForOutput', this.variableListEpForOutput);

// this._configService.entryPointData.forEach((item: any) => {
  
//  console.log('EP ITEM', item);
//   console.log('isMandatoryLoadClicked', item.isMandatoryLoadClicked);

//   if (!item.isMandatoryLoadClicked) return;

//   const entryPointKey = Object.keys(item).find(key => key.startsWith('EntryPoint'));
//   if (!entryPointKey) return;

//   const entryPoint = item[entryPointKey];

//   entryPointPairs.push({
//     label: entryPoint.Level1,
//     values: entryPoint.Level2
//       ?.flatMap((l2: any) => l2.MetricOptions?.map((m: any) => m.Name) || [])
//       .join(', ')
//   });
// });
const entryPointPairs: { label: string; values: string }[] = [];

(this.variableListEpForOutput || []).forEach((ep: any) => {
  ep.Level1?.forEach((level1: any) => {

    const selectedValues = (level1.Level2 || [])
      .filter((level2: any) => level2.is_selected)
      .map((level2: any) => level2.Level2_value);

    if (selectedValues.length > 0) {
      entryPointPairs.push({
        label: level1.Level1_value,
        values: selectedValues.join(', ')
      });
    }
  });
});
    let variablesSummaryObjAll = structuredClone(this.variablesSummaryObj);

    variablesSummaryObjAll = variablesSummaryObjAll.filter(
      (item: any, index: number, self: any[]) =>
        index ===
        self.findIndex(
          (other: any) =>
            other.Level0 === item.Level0 &&
            other.Level1 === item.Level1 &&
            other.Level2 === item.Level2 &&
            other.Level3 === item.Level3 &&
            other.Level4 === item.Level4 &&
            other.Level5 === item.Level5
        )
    );

    variablesSummaryObjAll = variablesSummaryObjAll.filter(
      (item: any) => item.Level0 !== 'Brands' || item.Level1 !== 'Default'
    );

    let variablesSummaryObjLastLevel = variablesSummaryObjAll.reduce(
      (acc: any, obj: any) => {
        if (obj.Level5 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2 &&
              o.Level3 === obj.Level3 &&
              o.Level4 === obj.Level4
          );

          if (existingObj) {
            existingObj.Level5 = existingObj.Level5
              ? `${existingObj.Level5}, ${obj.Level5}`
              : obj.Level5;
          } else {
            acc.push(obj);
          }
        } else if (obj.Level4 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2 &&
              o.Level3 === obj.Level3
          );

          if (existingObj) {
            existingObj.Level4 = existingObj.Level4
              ? `${existingObj.Level4}, ${obj.Level4}`
              : obj.Level4;
          } else {
            acc.push(obj);
          }
        } else if (obj.Level3 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2
          );

          if (existingObj) {
            existingObj.Level3 = existingObj.Level3
              ? `${existingObj.Level3}, ${obj.Level3}`
              : obj.Level3;
          } else {
            acc.push(obj);
          }
        } else if (obj.Level2 != '') {
          const existingObj = acc.find(
            (o: any) => o.Level0 === obj.Level0 && o.Level1 === obj.Level1
          );

          if (existingObj) {
            existingObj.Level2 = existingObj.Level2
              ? `${existingObj.Level2}, ${obj.Level2}`
              : obj.Level2;
          } else {
            acc.push(obj);
          }
        } else if (obj.Level1 != '') {
          const existingObj = acc.find((o: any) => o.Level0 === obj.Level0);

          if (existingObj) {
            existingObj.Level1 = existingObj.Level1
              ? `${existingObj.Level1}, ${obj.Level1}`
              : obj.Level1;
          } else {
            acc.push(obj);
          }
        } else if (obj.Level0 != '') {
          acc.push(obj);
        }

        return acc;
      },
      []
    );

    let variablesSummaryObjLastLevelAll = structuredClone(variablesSummaryObjLastLevel);

    let variablesSummaryObjSecondLastLevel =
      variablesSummaryObjLastLevelAll.reduce((acc: any, obj: any) => {
        if (obj.Level4 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2 &&
              o.Level3 === obj.Level3
          );

          if (existingObj) {
            existingObj.Level4 = existingObj.Level4
              ? `${existingObj.Level4}: ${existingObj.Level5}; ${obj.Level4}: ${obj.Level5}`
              : obj.Level4;
            existingObj.Level5 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level3 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2
          );

          if (existingObj) {
            existingObj.Level3 = existingObj.Level3
              ? `${existingObj.Level3}: ${existingObj.Level4}; ${obj.Level3}: ${obj.Level4}`
              : obj.Level3;
            existingObj.Level4 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level2 != '') {
          const existingObj = acc.find(
            (o: any) => o.Level0 === obj.Level0 && o.Level1 === obj.Level1
          );

          if (existingObj) {
            existingObj.Level2 = existingObj.Level2
              ? `${existingObj.Level2}: ${existingObj.Level3}; ${obj.Level2}: ${obj.Level3}`
              : obj.Level2;
            existingObj.Level3 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level1 != '') {
          const existingObj = acc.find((o: any) => o.Level0 === obj.Level0);

          if (existingObj) {
            existingObj.Level1 = existingObj.Level1
              ? `${existingObj.Level1}: ${existingObj.Level2}; ${obj.Level1}: ${obj.Level2}`
              : obj.Level1;
            existingObj.Level2 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level0 != '') {
          acc.push(obj);
        }

        return acc;
      }, []);

    let variablesSummaryObjSecondLastLevelAll = structuredClone(variablesSummaryObjSecondLastLevel);

    let variablesSummaryObjThirdLevel =
      variablesSummaryObjSecondLastLevelAll.reduce((acc: any, obj: any) => {
        if (obj.Level4 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2 &&
              o.Level3 === obj.Level3
          );

          if (existingObj) {
            existingObj.Level4 = existingObj.Level4
              ? `${existingObj.Level4}: ${existingObj.Level5}; ${obj.Level4}: ${obj.Level5}`
              : obj.Level4;
            existingObj.Level5 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level3 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2
          );

          if (existingObj) {
            existingObj.Level3 = existingObj.Level3
              ? `${existingObj.Level3}: ${existingObj.Level4}; ${obj.Level3}: ${obj.Level4}`
              : obj.Level3;
            existingObj.Level4 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level2 != '') {
          const existingObj = acc.find(
            (o: any) => o.Level0 === obj.Level0 && o.Level1 === obj.Level1
          );

          if (existingObj) {
            existingObj.Level2 = existingObj.Level2
              ? `${existingObj.Level2}: ${existingObj.Level3}; ${obj.Level2}: ${obj.Level3}`
              : obj.Level2;
            existingObj.Level3 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level1 != '') {
          const existingObj = acc.find((o: any) => o.Level0 === obj.Level0);

          if (existingObj) {
            existingObj.Level1 = existingObj.Level1
              ? `${existingObj.Level1}: ${existingObj.Level2}; ${obj.Level1}: ${obj.Level2}`
              : obj.Level1;
            existingObj.Level2 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level0 != '') {
          acc.push(obj);
        }
        return acc;
      }, []);

    let variablesSummaryObjThirdLevelAll = structuredClone(variablesSummaryObjThirdLevel);

    let variablesSummaryObjsecondLevel =
      variablesSummaryObjThirdLevelAll.reduce((acc: any, obj: any) => {
        if (obj.Level3 != '') {
          const existingObj = acc.find(
            (o: any) =>
              o.Level0 === obj.Level0 &&
              o.Level1 === obj.Level1 &&
              o.Level2 === obj.Level2
          );

          if (existingObj) {
            existingObj.Level3 = existingObj.Level3
              ? `${existingObj.Level3}: ${existingObj.Level4}; ${obj.Level3}: ${obj.Level4}`
              : obj.Level3;
            existingObj.Level4 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level2 != '') {
          const existingObj = acc.find(
            (o: any) => o.Level0 === obj.Level0 && o.Level1 === obj.Level1
          );

          if (existingObj) {
            existingObj.Level2 = existingObj.Level2
              ? `${existingObj.Level2}: ${existingObj.Level3}; ${obj.Level2}: ${obj.Level3}`
              : obj.Level2;
            existingObj.Level3 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level1 != '') {
          const existingObj = acc.find((o: any) => o.Level0 === obj.Level0);

          if (existingObj) {
            existingObj.Level1 = existingObj.Level1
              ? `${existingObj.Level1}: ${existingObj.Level2}; ${obj.Level1}: ${obj.Level2}`
              : obj.Level1;
            existingObj.Level2 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level0 != '') {
          acc.push(obj);
        }
        return acc;
      }, []);

    let variablesSummaryObjSecondLevelAll = structuredClone(variablesSummaryObjsecondLevel);

    let variablesSummaryObjFirstLevel =
      variablesSummaryObjSecondLevelAll.reduce((acc: any, obj: any) => {
        if (obj.Level2 != '') {
          const existingObj = acc.find(
            (o: any) => o.Level0 === obj.Level0 && o.Level1 === obj.Level1
          );

          if (existingObj) {
            existingObj.Level2 = existingObj.Level2
              ? `${existingObj.Level2}: ${existingObj.Level3}; ${obj.Level2}: ${obj.Level3}`
              : obj.Level2;
            existingObj.Level3 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level1 != '') {
          const existingObj = acc.find((o: any) => o.Level0 === obj.Level0);

          if (existingObj) {
            existingObj.Level1 = existingObj.Level1
              ? `${existingObj.Level1}: ${existingObj.Level2}; ${obj.Level1}: ${obj.Level2}`
              : obj.Level1;
            existingObj.Level2 = '';
          } else {
            acc.push(obj);
          }
        } else if (obj.Level0 != '') {
          acc.push(obj);
        }
        return acc;
      }, []);

    let variableSelectionSummary = '';
    let variableFilterSelectionSummary = '';

    for (let i = 0; i < this.variableList.length; i++) {
      let checkRadioMet = this.variablesSummaryObjRadio.map(
        (a: any) => a.Level0
      );
      let checkboxesMet = variablesSummaryObjsecondLevel.map(
        (a: any) => a.Level1
      );

      if (
        i != 0 &&
        (checkRadioMet.includes(this.variableList[i].Level0) ||
          checkboxesMet.includes(this.variableList[i].Level0) ||
          checkboxesMet.includes(this.variableList[i].Level1[0].Level1_value))
      )
        variableSelectionSummary += ' | ';

      this.variablesSummaryObj = this.variablesSummaryObj.filter(
        (item: any, index: number, self: any[]) =>
          index ===
          self.findIndex(
            (other: any) =>
              other.Level0 === item.Level0 &&
              other.Level1 === item.Level1 &&
              other.Level2 === item.Level2 &&
              other.Level3 === item.Level3 &&
              other.Level4 === item.Level4 &&
              other.Level5 === item.Level5
          )
      );
      if (this.selectedcompareacrossOption == 'Multiple Markets') {
        this.variablesSummaryObj.forEach((item: any, index: number) => {
          if (this.variableListMultiMarketAndCateg.length > i) {
            if (this.variableListMultiMarketAndCateg[i].Level0 == item.Level0) {
              if (
                index != 0 &&
                !(
                  variableSelectionSummary == '' ||
                  variableFilterSelectionSummary == '' ||
                  variableSelectionSummary.trim().endsWith(':') ||
                  variableSelectionSummary.trim().endsWith('|')
                )
              )
                variableSelectionSummary += '; ';

              if (item.Level5 != '') {
                variableSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3}: ${item.Level4}: ${item.Level5} `;
              } else if (item.Level4 != '') {
                variableSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3}: ${item.Level4} `;
              } else if (item.Level3 != '') {
                variableSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3} `;
              } else if (item.Level2 != '') {
                variableSelectionSummary +=
                  index == 0
                    ? `${item.Level0}:${item.Level2},`
                    : `${item.Level2 + ','}`; //`${item.Level0} : ${item.Level1}: ${item.Level2} `;
              } else if (item.Level1 != '') {
                variableSelectionSummary += `${item.Level0}: ${item.Level1} `;
              } else if (item.Level0 != '') {
                variableSelectionSummary += `${item.Level0} `;
              }
            }
          }
        });
        //remove the last character from variableSelectionSummary
        variableSelectionSummary = variableSelectionSummary.slice(0, -1);
        variableSelectionSummary += ' | ';
      }

      this.variablesSummaryObjRadio.forEach((item: any, index: Number) => {
        if (this.variableList[i].Level0 == item.Level0) {
          if (
            index != 0 &&
            !(
              variableSelectionSummary == '' ||
              variableFilterSelectionSummary == '' ||
              variableSelectionSummary.trim().endsWith(':') ||
              variableSelectionSummary.trim().endsWith('|')
            )
          )
            variableSelectionSummary += '; ';

          if (item.Level5 != '') {
            variableSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3}: ${item.Level4}: ${item.Level5} `;
          } else if (item.Level4 != '') {
            variableSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3}: ${item.Level4} `;
          } else if (item.Level3 != '') {
            variableSelectionSummary += `${item.Level0}: ${item.Level1}: ${item.Level2}: ${item.Level3} `;
          } else if (item.Level2 != '') {
            variableSelectionSummary += `${item.Level0} : ${item.Level1}: ${item.Level2} `;
          } else if (item.Level1 != '') {
            variableSelectionSummary += `${item.Level0}: ${item.Level1} `;
          } else if (item.Level0 != '') {
            variableSelectionSummary += `${item.Level0} `;
          }
        }
      });

      if (this.selectedcompareacrossOption == 'Multiple Markets') {
        //search where level0 is "brands" in variablesSummaryObjFirstLevel
        let brands = variablesSummaryObjFirstLevel.filter(
          (a: any) => a.Level0 == 'Brands'
        );
        if (brands.length > 0) {
          brands[0].Level2 = brands[0].Level2.split(',')[0];
        }
      }

      variablesSummaryObjFirstLevel.forEach((item: any, index: Number) => {
        let lev0Val = variableFilterSelectionSummary.includes(
          item.Level0 + ': '
        )
          ? ''
          : item.Level0 + ': ';

        if (
          this.variableList[i].Level0 == item.Level1 ||
          this.variableList[i].Level1[0].Level1_value == item.Level1
        ) {
          if (
            index != 0 &&
            !(
              variableSelectionSummary == '' ||
              variableSelectionSummary.trim().endsWith(':') ||
              variableSelectionSummary.trim().endsWith('|')
            )
          )
            variableSelectionSummary += '; ';

          if (item.Level5 != '') {
            variableSelectionSummary +=
              lev0Val +
              `${item.Level1}: ${item.Level2}: ${item.Level3}: ${item.Level4}: ${item.Level5} `;
          } else if (item.Level4 != '') {
            variableSelectionSummary +=
              lev0Val +
              `${item.Level1}: ${item.Level2}: ${item.Level3}: ${item.Level4} `;
          } else if (item.Level3 != '') {
            variableSelectionSummary +=
              lev0Val + `${item.Level1}: ${item.Level2}: ${item.Level3} `;
          } else if (item.Level2 != '') {
            variableSelectionSummary +=
              lev0Val + `${item.Level1}: ${item.Level2} `;
          } else if (item.Level1 != '') {
            variableSelectionSummary += lev0Val + `${item.Level1} `;
          } else if (item.Level0 != '') {
            variableSelectionSummary += `${item.Level0} `;
          }
        }
      });
    }

    for (const filterLevelMinus of this.variableListFilter) {
      for (const level1Item of filterLevelMinus.Level1) {
        const level1Children = level1Item.Level1 || [];

        if (level1Children.length === 0) {
          if (!level1Item.is_selected) continue;
          if (variableFilterSelectionSummary !== '') variableFilterSelectionSummary += ' | ';
          variableFilterSelectionSummary += `${level1Item.Level0} `;
          continue;
        }

        const level1CategoryName: string = level1Item.Level0;
        const filterSummaryEntries: string[] = [];

        for (const level2Item of level1Children) {
          const level2Children = level2Item.Level2 || [];

          if (level2Children.length === 0) {
            if (!level2Item.is_selected) continue;
            filterSummaryEntries.push(`${level2Item.Level1_value} `);
            continue;
          }

          const level2Value: string = level2Item.Level1_value;
          // Siblings selected directly under this level2 node (no further nesting)
          // are grouped into a single entry rather than repeating the prefix.
          const level3LeafValues: string[] = [];

          for (const level3Item of level2Children) {
            const level3Children = level3Item.Level3 || [];

            if (level3Children.length === 0) {
              if (level3Item.is_selected) level3LeafValues.push(level3Item.Level2_value);
              continue;
            }

            const level3Value: string = level3Item.Level2_value;
            const level4LeafValues: string[] = [];

            for (const level4Item of level3Children) {
              const level4Children = level4Item.Level4 || [];

              if (level4Children.length === 0) {
                if (level4Item.is_selected) level4LeafValues.push(level4Item.Level3_value);
                continue;
              }

              const level4Value: string = level4Item.Level3_value;
              const selectedLevel5Items = level4Children.filter((item: any) => item.is_selected);
              if (selectedLevel5Items.length > 0) {
                const level5Values = selectedLevel5Items.map((item: any) => item.Level4_value);
                filterSummaryEntries.push(`${level2Value}: ${level3Value}: ${level4Value}: ${level5Values.join('; ')} `);
              }
            }

            if (level4LeafValues.length > 0) {
              filterSummaryEntries.push(`${level2Value}: ${level3Value}: ${level4LeafValues.join('; ')} `);
            }
          }

          if (level3LeafValues.length > 0) {
            filterSummaryEntries.push(`${level2Value}: ${level3LeafValues.join('; ')} `);
          }
        }

        if (filterSummaryEntries.length === 0) {
          if ((level1Item.Level1 || []).length === 0) {
            if (variableFilterSelectionSummary !== '') variableFilterSelectionSummary += ' | ';
            variableFilterSelectionSummary += `${level1CategoryName} `;
          }
          continue;
        }

        if (variableFilterSelectionSummary !== '') variableFilterSelectionSummary += ' | ';
        variableFilterSelectionSummary += `${level1CategoryName}: ` + filterSummaryEntries.join('; ');
      }
    }

    variableFilterSelectionSummary = this.removeDuplicateAudienceFromFilterSummary(
      variableSelectionSummary,
      variableFilterSelectionSummary
    );

    this._configService.selectedSnapshotType = this.selectedcompareacrossOption;

    // HTML entry-point segment: label emitted once, then each pair separated by " | ".
    const entryPointHtml =
      entryPointPairs.length == 0
        ? ''
        : `<span class="grey-separator"> ||  </span><span class="summary-label">Entry Point:</span> ` +
        entryPointPairs
          .map(
            (ep, i) =>
              (i == 0
                ? ''
                : `<span class="summary-label"> | </span> `) +
              `${ep.label} : ${ep.values}  `
          )
          .join('');

    this.selectionSummary =
      `<span class="summary-label">Compare Across:</span> ${this.selectedcompareacrossOption} : ${this.selectedSection}` +
      (this.selectedSubSection != 'NA' ? ` : ${this.selectedSubSection}` : ``) +
      entryPointHtml +
      `<span class="grey-separator"> ||  </span> <span class="summary-label">Selections: </span>` +
      variableSelectionSummary +
      (variableFilterSelectionSummary != ''
        ? `<span class="grey-separator"> || </span> <span class="summary-label">Filters: </span>` +
        variableFilterSelectionSummary
        : '');

    this._configService.selectionSummaryText = this.selectionSummary;
    this._configService.audienceSummary = this.audienceTooltip;

    // Plain-text entry-point segment (used by the structured Selection Summary view):
    // "Entry Point: label1: values1; label2: values2 ...". The label is always emitted
    // when any entry point exists so it never merges into the Compare Across section.
    const entryPointTitle =
      entryPointPairs.length == 0
        ? ''
        : ' || Entry Point: ' +
        entryPointPairs
          .map((ep) => `${ep.label}: ${ep.values}`)
          .join('; ');

    this.selectionSummaryTitle =
      'Compare Across: ' +
      this.selectedcompareacrossOption +
      ': ' +
      this.selectedSection +
      (this.selectedSubSection != 'NA' ? ': ' + this.selectedSubSection : '') +
      entryPointTitle +
      ' || Selections: ' +
      variableSelectionSummary +
      (variableFilterSelectionSummary != ''
        ? ' || Filters: ' + variableFilterSelectionSummary
        : '');

    this._configService.selectionSummaryTextTitle = this.selectionSummaryTitle;

    if (infoRibbonDiv != null) {
      setSanitizedHtml(infoRibbonDiv, this.selectionSummary);
      infoRibbonDiv.title = this.selectionSummaryTitle;
    }

    if (infoRibbonTextValuesDiv != null) {
      setSanitizedHtml(infoRibbonTextValuesDiv, this.selectionSummary);
      infoRibbonTextValuesDiv.title = this.selectionSummaryTitle;
    }

    // const toggleLeftPanelDiv = document.querySelector(
    //   '.toggleLeftPanel'
    // ) as HTMLDivElement;
    // toggleLeftPanelDiv.click();
  }

  colNest: any;
  Level1: any;
  Level2: any;
  Level3: any;
  Level4: any;
  Level5: any;
  selectedArray: any[] = [];
  outputArray() {
    // ;
    // for (let i = 0; i < this.variableList.length; i++) {
    //   if (this.variableList[i].Level0 == 'Time Period') {
    //     for (let j = 0; j < this.variableList[i].Level1.length; j++) {
    //       if (this.variableList[i].Level1[j].is_selected == true) {
    //         this.Level1 = this.variableList[i].Level1[j];
    //         this.findLevel(this.Level1, 2)
    //       }
    //     }
    //   }
    // }
  }
  findLevel(obj: any, level: any) {
    let x: any;
    if (_.keys(obj).indexOf('Level' + level) != -1) {
      //level5, 6
      for (let i = 0; i < obj['Level' + level].length; i++) {
        if (obj['Level' + level][i].is_selected == true) {
          x = obj['Level' + level][i];
        }
        // ;
      }
      this.findLevel(x, level + 1);
    } else {
      //level5
      // ;
      return level;
    }
  }

  
  private isWaveTimePeriod() {
    if (
      this.mandatoryVariableMapping == undefined ||
      this.mandatoryVariableMapping == null
    )
      return false;
    else {
      let timePeriodEntries: any = this.mandatoryVariableMapping.filter(
        (entry: any) =>
          entry.variable_label === 'Time Period' &&
          entry.variable_code &&
          entry.variable_code.trim() !== ''
      );

      let isWaveTimePeriod =
        timePeriodEntries.length === 0 ||
        timePeriodEntries.every(
          (entry: any) =>
            entry.variable_code === timePeriodEntries[0].variable_code
        );

      return isWaveTimePeriod;
    }
  }

  significance = '';
  isFilteringActive = false;
  DefaultConfidenceLevel = '';
  isTotalBase = false;
  selectedWeight = '';
  weightColumnName = '';
  SignificanceVsReference = '';
  isAggregatedData: boolean = false;
  isSemiAggregatedData: boolean = false;
  isRespondentLevel: boolean = false;
  aggregatedVariables: any = [];
  columnLength = 0;
  previewData: DataObjectSnapshot = {
    Row: [],
    Column: [],
    RowNesting: [],
    ColNesting: [],
    Filter: [],
    CustomGroup: [],
  };
  widegtconfigdetails: any = {
    section: '',
    subSection: '',
    snapshotType: '',
    snapshotName: '',
    clientName: '',
    study: '',
    IsCustomSnapshot: false,
  };

  updatedDataForSubmit(data: any) {
    return data.map((item: any) => {
      // Extract Level0 to Level5 values
      let levels = [];
      levels = [
        item.Level1,
        item.Level2,
        item.Level3,
        item.Level4,
        item.Level5,
        item.Level6,
        item.Level7,
        item.Level8,
        item.Level9,
      ];
      if(item.Level0 == "Audience")
      {
        levels = [
        item.Level0,
        item.Level1,
        item.Level2,
        item.Level3,
        item.Level4,
        item.Level5,
        ];
      }
      // Adding these field in existing array
      let parent = '';
      let isTimePeriod = false;
      let isMarket = false;
      let isRolling = false;

      // Filter out empty values and join with |
      let child = levels.filter((level) => level).join('|');
      let arr = child.split('|');

      if (item.Level0 == 'Time Period') {
        isTimePeriod = true;
      } else {
        isTimePeriod = false;
      }

      if (item.Level0 == 'Markets') {
        isMarket = true;
      } else {
        isMarket = false;
      }

      if (
        item.Level1 == '3MMA' ||
        item.Level1 == '4MMA' ||
        item.Level1 == '6MMA' ||
        item.Level1 == '12MMA'
      ) {
        isRolling = true;
      } else {
        isRolling = false;
      }

      parent = arr[arr.length - 2];

      let multiPunchMetric = '';
      if (item.is_multi_punch == 0 || item.is_multi_punch == '0') {
        multiPunchMetric = '';
      } else {
        multiPunchMetric = parent;
      }
      // Adding all extra created variable in existing data-item
      return {
        ...item,
        child: child,
        parent: parent,
        isTimePeriod: isTimePeriod,
        isMarket: isMarket,
        isRolling: isRolling,
        multiPunchMetric: multiPunchMetric,
      };
    });
  }

  previewDataCreation(
    data: any
  ): checkboxSelectionWithParentSnapshot | undefined {
    for (let i = 0; i < data.length; i++) {
      const checkboxSelection = [];

      for (let j = 0; j < data.length; j++) {
        checkboxSelection.push({
          CheckboxStatus: false,
          Child: data[j].child ?? '',
          variablecode: data[j].variable_code ?? '',
          responsecode:
            (data[j].calc_type.toLowerCase() == 'respgrp'
              ? data[j].derived_metric_calculation
              : data[j].response_code) ?? '',
          // isDerviedVariable: data[j].is_derived == null ? false : Boolean(data[j].is_derived),
          isDerviedVariable: false,
          CalculationType: data[j].calc_type ?? '',
          sort_id: data[j].sort_id == null ? 0 : Number(data[j].sort_id),
          year_response_code: data[j].year_code ?? '',
          year_variable_code: data[j].dataYearCode ?? '',
          Date: data[j].date ?? '',
          // isMultiPunch: data[j].is_multi_punch == null ? 0 : Number(data[j].is_multi_punch),
          isMultiPunch:
            data[j].is_multi_punch == null ? 0 : Number(data[j].is_multi_punch),
          isTimePeriod:
            data[j].isTimePeriod == null
              ? false
              : Boolean(data[j].isTimePeriod),
          isMarket:
            data[j].isMarket == null ? false : Boolean(data[j].isMarket),
          multiPunchMetric: data[j].multiPunchMetric,
          MultiPunchNumber:
            data[j].is_multi_punch == null ? 0 : Number(data[j].is_multi_punch),
          isCustomGroup:
            data[j].is_CustomGroup == null
              ? false
              : data[j].is_CustomGroup === 'true',
          // isCustomGroup: false,
          kibanaFilterScript: data[j].kibanaFilterScript ?? '',
          //kibanaFilterScript: '',
          customGroupId: data[j].customGroupId ?? '',
          // customGroupId: '',
          customGroupRowOrder: 0,
          isRolling:
            data[j].isRolling == null ? false : Boolean(data[j].isRolling),
          Weekno_forSigcalculation: Number(data[j].Weekno_forSigcalculation) ?? null,
        });
        //;
      }
      // ;
      const columnData: checkboxSelectionWithParentSnapshot = {
        Parent: data[i].parent == null ? '' : data[i].parent,
        SortId: data[i].sort_id == null ? 0 : Number(data[i].sort_id),
        Data: checkboxSelection,
        isMultiPunch:
          data[i].is_multi_punch == null ||
            data[i].is_multi_punch == 0 ||
            data[i].is_multi_punch == '0'
            ? false
            : Boolean(data[i].is_multi_punch),
        //isMultiPunch: false,
        MultiPunchNumber:
          data[i].is_multi_punch == null ? 0 : Number(data[i].is_multi_punch),
        //MultiPunchNumber: 0,
        isCustomGroup:
          data[i].is_CustomGroup == null
            ? false
            : data[i].is_CustomGroup === 'true',
        //isCustomGroup: false,
        customGroupId:
          data[i].customGroupId == null ? '' : data[i].customGroupId,
        // customGroupId: '',
        brandanalysisCode:
          data[i].is_brand_analysis == null
            ? 0
            : Number(data[i].is_brand_analysis)
       
      };

      // ;
      return columnData;
      break;
    }

    // Return undefined if data.length === 0
    return undefined;
  }
  opData: any;
  sortedOPdata: any;
  indexVsBrandReference: checkboxSelectionWithParentSnapshot[] = [];
  significanceVsBrandReference: checkboxSelectionWithParentSnapshot[] = [];
  selectedBrand: any[] = [];
  selectedTimePeriod: any[] = [];
  selectedMarket: any[] = [];
  selectedCategory: any[] = [];
  selectedAudience: any[] = [];
  selectedTotalSample: any[] = [];

  private getTotalSampleConfigKey(): [string, string] | null {
    const configName =
      this._configService?.outputSnapshotData?.audienceTotalSample?.config_name;
    if (!configName) {
      return null;
    }
    const parts = configName.split('|').map((s: string) => s.trim());
    if (parts.length < 2) {
      return null;
    }
    return [parts[0], parts[1]];
  }

  private getTotalSampleDisplayObject(): any {
    return {
      Level0: 'Audience',
      Level1: 'Total Sample',
      Level2: '',
      Level3: '',
      Level4: '',
      Level5: '',
      variable_label: 'Total Sample',
    };
  }

  private findTotalSampleMetricLevels(): {
    level1: any;
    level2: any;
    options: any[];
  } | null {
    const configKey = this.getTotalSampleConfigKey();
    if (!configKey || !this.audienceRawVariableData?.length) {
      return null;
    }

    const [lvl1, lvl2] = configKey;

    let filteredData = [];
    if (this._configService.audienceTotalSampleVariables.length > 0) {
      filteredData = this._configService.audienceTotalSampleVariables;
    } else {
      filteredData = this.audienceRawVariableData.filter(
        (item: any) =>
          item.Level0?.trim() === 'Audience' &&
          item.Level1?.trim() === lvl2?.trim() ||
          item.Level2?.trim() === lvl2?.trim() ||
          item.Level3?.trim() === lvl2?.trim() ||
          item.Level4?.trim() === lvl2?.trim()
      );
    }

    if (!filteredData.length) {
      return null;
    }

    const nested = this.createNestedLevels(
      filteredData,
      'Level0',
      'Level0',
      'Level0',
      'Level0',
      'Level0',
      'Level0',
      'Level0',
      'Level0',
      'Audience',
      'Level0',
      1,
      false
    );

    if (!nested?.length) {
      return null;
    }

    for (const level1 of nested) {
      if (level1.Level1_value === lvl1) {
        const level2 = level1.Level2?.find(
          (item: any) => item.Level2_value === lvl2
        );
        if (level2?.Level3?.length) {
          return { level1, level2, options: level2.Level3 };
        }
        if (level1.Level2?.length) {
          return { level1, level2: null, options: level1.Level2 };
        }
      }
      if (level1.Level1_value === lvl2 && level1.Level2?.length) {
        return { level1, level2: null, options: level1.Level2 };
      }
    }

    const level1 = nested[0];
    const level2 = level1.Level2?.[0];
    if (level2?.Level3?.length) {
      return { level1, level2, options: level2.Level3 };
    }
    if (level1.Level2?.length) {
      return { level1, level2: null, options: level1.Level2 };
    }

    return null;
  }

  private buildTotalSampleAudienceObjects(): any[] {
    const metricLevels = this.findTotalSampleMetricLevels();
    if (!metricLevels) {
      return [];
    }

    // const count = this.isSingleaudienceCohortType ? 1 : 3;
    const { level1, level2, options } = metricLevels;
    const selectedItems: any[] = [];

    options.forEach((option: any) => {
      if (level2) {
        selectedItems.push(
          this.buildSelectedObject('Audience', level1, level2, option)
        );
      } else if (option.Level3?.length) {
        selectedItems.push(
          this.buildSelectedObject('Audience', level1, option, option.Level3[0])
        );
      } else {
        selectedItems.push(
          this.buildSelectedObject('Audience', level1, option, {})
        );
      }
    });

    return selectedItems;
  }

  private applyTotalSampleToSelectedObjects(): void {
    if (!this.isAudienceTotalSample || !this.isTotalSampleAudienceActive) {
      return;
    }

    const metricSelections = this.buildTotalSampleAudienceObjects();
    if (!metricSelections.length) {
      return;
    }

    const audienceIndex = this.selectedObjects.findIndex((obj) => obj['Audience']);
    if (audienceIndex >= 0) {
      this.selectedObjects[audienceIndex]['Audience'] = metricSelections;
    } else {
      this.selectedObjects.push({ Audience: metricSelections });
    }
  }

  private handleTotalSampleAudienceSelection(
    level0: string,
    level1: string,
    isDeselecting: boolean
  ): void {
    if (!this.isAudienceTotalSample || level0 !== 'Audience') {
      return;
    }

    if (level1 === 'Total Sample') {
      this.isTotalSampleAudienceActive = !isDeselecting;
      const audienceObj = this.selectedObjects.find((obj) => obj['Audience']);

      if (this.isTotalSampleAudienceActive) {
        // Single cohort: Total Sample is the only selection -> clear other audiences.
        // Multi cohort: keep the (up to 2) audiences the user already picked.
        if (this.isSingleaudienceCohortType && audienceObj) {
          audienceObj['Audience'] = (audienceObj['Audience'] || []).filter(
            (a: any) => this.isTotalSampleMarker(a)
          );
        }
        // Do NOT inject configured options into selectedObjects;
        // they are built on the fly at submit and go to Filter only.
      } else if (audienceObj) {
        // Unchecked -> drop only the marker.
        audienceObj['Audience'] = (audienceObj['Audience'] || []).filter(
          (a: any) => !this.isTotalSampleMarker(a)
        );
      }
    } else if (this.isSingleaudienceCohortType) {
      // Only single cohort clears Total Sample when another audience is chosen.
      this.isTotalSampleAudienceActive = false;
    }
  }

  SubmitClicked(
    load: boolean,
    isDefaultPanel: boolean = false,
    globalSelection: boolean = false,
    innerSelection: any = {}
  ) {
    this._configService.showGlobalDefaultPopup = globalSelection;
    if(this.selectedcompareacrossOption == 'Audience Snapshot' && this._configService.outputSnapshotData?.audienceCohortType?.toLowerCase() == 'multiple'){
      this.multiCohort=true;
      this._configService.multiCohort=true;
    } else {
      this.multiCohort=false;
      this._configService.multiCohort=false;
    }
    //this.collapsePanel();////
    if (isDefaultPanel) {
      this.selectedSection = sessionStorage.getItem('sectionName') ?? '';
      this.selectedSubSection = sessionStorage.getItem('subsectionName') ?? '';
    }
    this._configService.pageCounter.next(1);
    this._configService.page2ToggleSubject.next(1);
    this.previewData.ColNesting = [];
    this.previewData.Column = [];
    this.previewData.Filter = [];
    this.previewData.Row = [];
    this.previewData.RowNesting = [];
    this.selectedTimePeriod = [];

    let timePeriodData = this.selectedObjects.find((item) =>
      item.hasOwnProperty('Time Period')
    )?.['Time Period'];
    if (timePeriodData) {
      for (let i = 0; i < timePeriodData.length; i++) {
        this.selectedTimePeriod.push(timePeriodData[i].Level2);
      }
      timePeriodData = this.updatedDataForSubmit(timePeriodData); //adding child and parent key
      this._configService.selectedTimePeriod = timePeriodData.child;
      const x = this.previewDataCreation(timePeriodData);
      if (x !== undefined) {
        this.previewData.ColNesting.push(x);
      }
    }
    if (this.selectedcompareacrossOption == 'Multiple Markets') {
      this.selectedMarket = [];
      // this.variableListEpForOutput =[];
      let marketData = this.selectedObjects.find((item) =>
        item.hasOwnProperty('Markets')
      )?.['Markets'];
      //brand which is selected from left panel

      if (marketData) {
        for (let i = 0; i < marketData.length; i++) {
          this.selectedBrand.push(marketData[i].Level2);
        }

        marketData = this.updatedDataForSubmit(marketData);
        const x = this.previewDataCreation(marketData);
        if (x !== undefined) {
          this.previewData.Column.push(x);
        }
      }
      // ;

      const filteredData = this.selectedObjects.filter(
        (item) => !('Time Period' in item || 'Markets' in item)
      );

      for (let i = 0; i < filteredData.length; i++) {
        const item = filteredData[i]; // Access each item in filteredData array
        const key = Object.keys(item)[0]; // Get the key of the current item
        let array = item[key]; // Get the corresponding array
        if (array) {
          array = this.updatedDataForSubmit(array);
          // ;
          const x = this.previewDataCreation(array);
          if (x !== undefined) {
            this.previewData.Filter.push(x);
          }
        }
      }
    } else if (this.selectedcompareacrossOption == 'Multiple Categories') {
      this.selectedBrand = [];
      let brandData = this.selectedObjects.find((item) =>
        item.hasOwnProperty('Brands')
      )?.['Brands'];
      //brand which is selected from left panel
      for (let i = 0; i < brandData.length; i++) {
        this.selectedBrand.push(brandData[i].Level2);
      }

      if (brandData) {
        brandData = this.updatedDataForSubmit(brandData);
        const x = this.previewDataCreation(brandData);
        if (x !== undefined) {
          this.previewData.Column.push(x);
        }
      }
      // ;

      const filteredData = this.selectedObjects.filter(
        (item) => !('Time Period' in item || 'Brands' in item)
      );

      for (let i = 0; i < filteredData.length; i++) {
        const item = filteredData[i]; // Access each item in filteredData array
        const key = Object.keys(item)[0]; // Get the key of the current item
        let array = item[key]; // Get the corresponding array
        if (array) {
          array = this.updatedDataForSubmit(array);
          // ;
          const x = this.previewDataCreation(array);
          if (x !== undefined) {
            this.previewData.Filter.push(x);
          }
        }
      }
    } else if (this.selectedcompareacrossOption == 'Audience Snapshot') {
      this.selectedAudience = [];
      let audienceData: any = [];
      const audienceRequired =
        (this._configService.outputSnapshotData?.audienceComparsion || []).some(
          (x: any) => x.is_selected
        ) ||
        this._configService.outputSnapshotData?.audienceTotalSample?.is_selected;
        if (!audienceRequired) {
  this.previewData.Column = [...this.previewData.ColNesting];
  this.previewData.ColNesting = [];
}
      if (this._configService.outputSnapshotData?.audienceCohortType != 'multiple') {
        audienceData = this.selectedObjects.find((item) =>
          item.hasOwnProperty('Audience')
        )?.['Audience'] ?? [];
      }
      else {
        this.selectedObjects?.forEach(obj => {
          if (!obj || typeof obj !== 'object') return;

          Object.keys(obj).forEach(key => {
            const value = obj[key];

            if (Array.isArray(value) && key === 'Audience') {
              value.forEach(item => {
                const isDuplicate = audienceData.some((existingItem: any) =>
                  existingItem.variable_code === item.variable_code &&
                  existingItem.response_code === item.response_code
                );

                if (!isDuplicate) {
                  audienceData.push(item);
                }
              });
            }
          });
        });
      }

      // Build the Total Sample bucket (configured audience + ALL its options)
      let totalSampleData: any[] =
        this.isAudienceTotalSample && this.isTotalSampleAudienceActive
          ? this.buildTotalSampleAudienceObjects()
          : [];

      // 1. Total Sample -> Filter with Parent = "Total Sample"
      this.selectedTotalSample = totalSampleData;
      if (totalSampleData.length) {
        const tsForSubmit = this.updatedDataForSubmit(totalSampleData);
        const ts = this.previewDataCreation(tsForSubmit);
        if (ts !== undefined) {
          ts.Parent = 'Total Sample'; // backend identifies total sample via this
          this.previewData.Filter.push(ts);
        }
      }

      // 2. Remove ONLY the Total Sample marker from Column audiences.
      //    Genuine column audiences stay, even if they overlap the configured total-sample audience.
      audienceData = (audienceData ?? []).filter((a: any) => !this.isTotalSampleMarker(a));

      // Single cohort with Total Sample can only pick Total Sample -> nothing goes to Column.
      // Multi cohort keeps the other 2 audiences for Column.
      if (
        this.isSingleaudienceCohortType &&
        this.isAudienceTotalSample &&
        this.isTotalSampleAudienceActive
      ) {
        audienceData = [];
      }

      // 3. The remaining (2nd/3rd) audiences -> Column as-is
      for (let i = 0; i < audienceData.length; i++) {
        this.selectedAudience.push(audienceData[i].Level2);
      }
      if (!audienceRequired) {
        console.log('Audience not configured');
        console.log(this.previewData);
      }
      if (audienceData.length) {
        audienceData = this.updatedDataForSubmit(audienceData);
        const x = this.previewDataCreation(audienceData);
        if (x !== undefined) {
          this.previewData.Column.push(x);
        }
      }

      // //brand which is selected from left panel
      // for (let i = 0; i < audienceData.length; i++) {
      //   this.selectedAudience.push(audienceData[i].Level2);
      // }
      // this.selectedTotalSample = this.isTotalSampleAudienceActive
      //   ? audienceData
      //   : (audienceData ?? []).filter((a: any) =>
      //     a.Level1 === 'Total Sample' ||
      //     a.variable_code === 'total_sample' ||
      //     a.data_variable_code === 'total_sample'
      //   );


      // if (audienceData) {
      //   audienceData = this.updatedDataForSubmit(audienceData);
      //   const x = this.previewDataCreation(audienceData);
      //   if (x !== undefined) {
      //     this.previewData.Column.push(x);
      //   }
      // }
      // ;

      // const filteredData = this.selectedObjects.filter(
      //   (item) => !('Time Period' in item || 'Brands' in item)
      // );
      const filteredData = this.selectedObjects.filter((item) => {
        const key = Object.keys(item)[0];
        return key !== 'Time Period' && key !== 'Brands' && key !== 'Audience';
      });
      for (let i = 0; i < filteredData.length; i++) {
        const item = filteredData[i]; // Access each item in filteredData array
        const key = Object.keys(item)[0]; // Get the key of the current item
        let array = item[key]; // Get the corresponding array
        if (array) {
          array = this.updatedDataForSubmit(array);
          const x = this.previewDataCreation(array);
          if (x !== undefined) {
            this.previewData.Filter.push(x);
          }
        }
      }
    }
    
    else {
      this.selectedBrand = [];
      let brandData = this.selectedObjects.find((item) =>
        item.hasOwnProperty('Brands')
      )?.['Brands']?.filter((b: any) => b.Level1 === 'Brands');
      if (brandData == undefined || brandData.length === 0) {
        brandData = this.selectedObjects.find((item) =>
          item.hasOwnProperty('Brand')
        )?.['Brand']?.filter((b: any) => b.Level1 === 'Brands');
      }
      if (!brandData) {
        this._loaderService.hideLoader();
        return;
      }
      //brand which is selected from left panel
      for (let i = 0; i < brandData.length; i++) {
        this.selectedBrand.push(brandData[i].Level2);
      }

      if (brandData) {
        brandData = this.updatedDataForSubmit(brandData);
        const x = this.previewDataCreation(brandData);
        if (x !== undefined) {
          this.previewData.Column.push(x);
        }
      }
      // ;

      const filteredData = this.selectedObjects.filter(
        (item) => !('Time Period' in item || 'Brands' in item)
      );

      for (let i = 0; i < filteredData.length; i++) {
        const item = filteredData[i]; // Access each item in filteredData array
        const key = Object.keys(item)[0]; // Get the key of the current item
        let array = item[key]; // Get the corresponding array
        if (array) {
          array = this.updatedDataForSubmit(array);
          // ;
          const x = this.previewDataCreation(array);
          if (x !== undefined) {
            this.previewData.Filter.push(x);
          }
        }
      }
    }
 let selectedDimension=[];
  let dimensionData = this.selectedObjects.find((item) =>
        item.hasOwnProperty('Dimension')
      )?.['Dimension'];
      //brand which is selected from left panel
 
      if (dimensionData) {
        for (let i = 0; i < dimensionData.length; i++) {
          selectedDimension.push(dimensionData[i].Level2);
        }
 
        dimensionData = this.updatedDataForSubmit(dimensionData);
        const x = this.previewDataCreation(dimensionData);
        if (x !== undefined) {
          this.previewData.Filter.push(x);
       
        }}
    //Entry point binding for filter in Leftpanel submit
    let epArray: any[] = [];
    //added for filtered out entry point
    if (
      this.variableListEpForOutput != undefined &&
      this.variableListEpForOutput.length != 0
    ) {
      for (let i = 0; i < this.variableListEpForOutput.length; i++) {
        this.variableListEpForOutput.forEach((item) => {
          item.Level1.forEach((level1: any) => {
            level1.Level2 = level1.Level2.filter(
              (level2: any) => level2.is_selected
            );
          });
        });

        epArray = [];
        for (
          let j = 0;
          j < this.variableListEpForOutput[i].Level1[0].Level2.length;
          j++
        ) {
          epArray.push({
            Level0: this.variableListEpForOutput[i].Level0,
            Level1: this.variableListEpForOutput[i].Level1[0].Level1_value,
            Level2:
              this.variableListEpForOutput[i].Level1[0].Level2[j].Level2_value,
            Level3: '',
            Level4: '',
            Level5: '',
            calc_type:
              this.variableListEpForOutput[i].Level1[0].Level2[j].calc_type,
            customGroupId:
              this.variableListEpForOutput[i].Level1[0].Level2[j].customGroupId,
            dataYearCode:
              this.variableListEpForOutput[i].Level1[0].Level2[j].dataYearCode,
            date: this.variableListEpForOutput[i].Level1[0].Level2[j].date,
            hasNextLevel:
              this.variableListEpForOutput[i].Level1[0].Level2[j].hasNextLevel,
            is_CustomGroup:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .isCustomGrpPresent,
            is_brand_analysis:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .is_brand_analysis,
            is_derived:
              this.variableListEpForOutput[i].Level1[0].Level2[j].is_derived,
            is_dimension:
              this.variableListEpForOutput[i].Level1[0].Level2[j].is_dimension,
            is_multi_punch:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .is_multi_punch,
            is_time_Period_Present:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .is_time_Period_Present,
            kibanaFilterScript:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .kibanaFilterScript,
            response_code:
              this.variableListEpForOutput[i].Level1[0].Level2[
                j
              ].calc_type.toLowerCase() == 'respgrp'
                ? this.variableListEpForOutput[i].Level1[0].Level2[j]
                  .derived_metric_calculation
                : this.variableListEpForOutput[i].Level1[0].Level2[j]
                  .response_code,
            sort_id:
              this.variableListEpForOutput[i].Level1[0].Level2[j].sort_id,
            variable_code:
              this.variableListEpForOutput[i].Level1[0].Level2[j]
                .data_variable_code,
            variable_label: null, //No data available
            year_code:
              this.variableListEpForOutput[i].Level1[0].Level2[0].year_code,
            Weekno_forSigcalculation:
              this.variableListEpForOutput[i].Level1[0].Level2[j].Weekno_forSigcalculation,
          });
        }

        if (epArray) {
          epArray = this.updatedDataForSubmit(epArray);
          // ;
          const x = this.previewDataCreation(epArray);
          if (x !== undefined) {
            this.previewData.Filter.push(x);
          }
        }
      }
    }
    this.selectedWeight =
      innerSelection?.selectedWeight ?? this.getWeightFromConfig();
    //this.outputArray();
    this.significance = load
      ? this.output_data?.significance
      : innerSelection?.significance ?? 'None';
    this.isFilteringActive = load ? this.output_data?.isFilteringActive : true;
    this.DefaultConfidenceLevel = load
      ? this.output_data?.DefaultConfidenceLevel
      : innerSelection?.displayConfidenceLevel ?? 'None';
    this.SignificanceVsReference = load
      ? this.output_data?.SignificanceVsReference
      : innerSelection?.significanceVsReference ?? '';
    this.isTotalBase = load
      ? this.output_data?.isTotalBase
      : innerSelection?.isTotalBase ?? false;
    this.weightColumnName = load ? this.output_data?.weightColumnName : '';
    let isBoostFactor = load ? this.output_data?.isBoostFactor : false;
    let weightColumnName = load ? this.output_data?.weightColumnName : '';
    var istimePeriodWave = this.isWaveTimePeriod();
    this.widegtconfigdetails.section = load
      ? this.output_data?.widegtconfigdetails.section
      : this.selectedSection;
    this.widegtconfigdetails.subSection = load
      ? this.output_data?.widegtconfigdetails.subSection
      : this.selectedSubSection;
    this.widegtconfigdetails.snapshotType = load
      ? this.output_data?.widegtconfigdetails.snapshotType
      : this.selectedcompareacrossOption;
    this.widegtconfigdetails.snapshotName = load
      ? this.output_data?.widegtconfigdetails.snapshotName
      : this.snapshotName;
    this.widegtconfigdetails.clientName = load
      ? this.output_data?.widegtconfigdetails.clientName
      : this.selected_client;
    this.widegtconfigdetails.study = load
      ? this.output_data?.widegtconfigdetails.study
      : this.selected_study;
    this.widegtconfigdetails.IsCustomSnapshot = load
      ? this.output_data?.widegtconfigdetails.IsCustomSnapshot == undefined
        ? false
        : this.output_data?.widegtconfigdetails.IsCustomSnapshot
      : this._configService.snapshotProductType == 'custom'
        ? true
        : false;
    let isBrandAnalysis = load ? this.output_data?.isBrandAnalysis : true;
    this.indexVsBrandReference = load
      ? this.output_data?.indexVsBrandReference
      : innerSelection?.indexVsBrandReference ?? this.indexVsBrandReference;
    this.significanceVsBrandReference = load
      ? this.output_data?.significanceVsBrandReference
      : innerSelection?.significanceVsBrandReference ??
      this.significanceVsBrandReference;
    //API call
    this._configService.selectedSection = this.widegtconfigdetails.section;
    this._configService.selectedSubSection =
      this.widegtconfigdetails.subSection;
    this._loaderService.showLoader();
    let passOutputData: any = {
      previewData: load ? this.output_data?.previewData : this.previewData,
      selectedClient: this.widegtconfigdetails.clientName,
      selectedStudy: this.widegtconfigdetails.study,
      significance: this.significance,
      isFilteringActive: this.isFilteringActive,
      DefaultConfidenceLevel: this.DefaultConfidenceLevel,
      isTotalBase: this.isTotalBase,
      selectedWeight: innerSelection?.selectedWeight ?? this.selectedWeight,
      weightColumnName: weightColumnName,
      isBoostFactor: isBoostFactor,
      SignificanceVsReference: this._configService.passdata?.SignificanceVsReference || this.SignificanceVsReference,
      columnLength: load ? this.output_data?.columnLength : this.columnLength,
      dataArray: load ? this.output_data?.dataArray : this.dataArray,
      isBrandAnalysis: isBrandAnalysis,
      isAggregatedData: load
        ? this.output_data?.isAggregatedData
        : this.isAggregatedData,
      isSemiAggregatedData: load
        ? this.output_data?.isSemiAggregatedData
        : this.isSemiAggregatedData,
      isRespondentLevel: load
        ? this.output_data?.isRespondentLevel
        : this.isRespondentLevel,
      aggregatedVariables: load
        ? this.output_data?.aggregatedVariables
        : this.aggregatedVariables,
      istimePeriodWave: load
        ? this.output_data?.istimePeriodWave
        : istimePeriodWave,
      widegtconfigdetails: load
        ? this.output_data?.widegtconfigdetails
        : this.widegtconfigdetails,
      indexVsBrandReference: this._configService.passdata?.indexVsBrandReference || this.indexVsBrandReference,
      significanceVsBrandReference: this._configService.passdata?.significanceVsBrandReference || this.significanceVsBrandReference,
      LeftPanelSelectedBrand: this.selectedBrand,
      LeftPanelSelectedAudience: this.selectedAudience,
      LeftPanelSelectedTimePeriod: this.selectedTimePeriod,
      LeftPanelAudienceTotalSample: this.selectedTotalSample,
    };
    this._configService.isRespondentLevel = this.isRespondentLevel;
    this._configService.isAggregatedData = this.isAggregatedData;
    this._configService.isSemiAggregatedData = this.isSemiAggregatedData;
    // this._configService.PassOutput.next(passOutputData);
    // // ;
    // this._configService.PassOutput.subscribe((data)=>{
    //   // ;
    //   let x=data;
    // })

    this._configService.dataObjectForSaveSelection = this.previewData;
    this._configService.widgetConfigDetails = this.widegtconfigdetails;
    this._configService.passdata = passOutputData;

    let finalLeftPanelSubmitObject = {
      previewData: this.previewData,
      selectedClient: this.selected_client,
      selectedStudy: this.selected_study,
      significance: this.significance,
      isFilteringActive: this.isFilteringActive,
      DefaultConfidenceLevel: this.DefaultConfidenceLevel,
      isTotalBase: this.isTotalBase,
      selectedWeight: this.selectedWeight,
      weightColumnName: weightColumnName,
      isBoostFactor: isBoostFactor,
      SignificanceVsReference: this._configService.passdata?.SignificanceVsReference || this.SignificanceVsReference,
      columnLength: this.columnLength,
      dataArray: this.dataArray,
      isBrandAnalysis: isBrandAnalysis,
      isAggregatedData: this.isAggregatedData,
      isSemiAggregatedData: this.isSemiAggregatedData,
      isRespondentLevel: this.isRespondentLevel,
      aggregatedVariables: this.aggregatedVariables,
      istimePeriodWave: istimePeriodWave,
      widegtconfigdetails: this.widegtconfigdetails,
      indexVsBrandReference: this._configService.passdata?.indexVsBrandReference || this.indexVsBrandReference,
      significanceVsBrandReference: this._configService.passdata?.significanceVsBrandReference || this.significanceVsBrandReference,
      isTrend: load
        ? this.output_data.isTrend
        : this._configService.checkTrendEnabled(
          this._configService.widgetAllData
        ),
      LeftPanelSelectedBrand: this.selectedBrand,
      LeftPanelSelectedAudience: this.selectedAudience,
        LeftPanelSelectedTimePeriod: this.selectedTimePeriod,
        customBaseMetric: !this.isTotalBase ?(load ? this.selectedCustomBaseReference : innerSelection.customBaseMetric) : null
    };
    let finalLeftPanelInputSelectedObject = {
      compareAcross: this.selectedcompareacrossOption,
      entryPoints: epArray,
      selections: this.selectedObjects,
      LeftPanelSelectedBrand: this.selectedBrand,
    };
    this._configService.finalLeftPanelInputSelectedObject =
      finalLeftPanelInputSelectedObject;
    this._configService.finalLeftPanelSubmitObject = finalLeftPanelSubmitObject;
    this._configService.entryPointData = this.dataArray;
    this._configService.passdata = passOutputData;

    // if(this.selectedcompareacrossOption == 'Multiple Brands'){
    //   this.previewData.Column =this.previewData.Column[0].Data.map(item => ({
    //     Data: [item],
    //     MultiPunchNumber: this.previewData.Column[0].MultiPunchNumber,
    //     Parent: this.previewData.Column[0].Parent,
    //     SortId: this.previewData.Column[0].SortId,
    //     brandanalysisCode: this.previewData.Column[0].brandanalysisCode,
    //     customGroupId: this.previewData.Column[0].customGroupId,
    //     isCustomGroup: this.previewData.Column[0].isCustomGroup,
    //     isMultiPunch: this.previewData.Column[0].isMultiPunch
    // }));
    // }
    
    const rawData = this.selectedScenarioData?.[0]?.output_selection_data;
  const outputSelectionData = rawData ? JSON.parse(rawData) : null;

  const audienceBrand = outputSelectionData?.previewData?.Audiencebrand?.[0];

  let selectedBrandFromConfig = audienceBrand?.data
  ? {
      config_name: `${audienceBrand.data.variable_label}|${audienceBrand.data.response_label}`,
      is_selected: audienceBrand.is_selected ?? true,
      metric_group: audienceBrand.data.metric_group || "",
      response_label: `${audienceBrand.data.variable_label}|${audienceBrand.data.response_label}`,
      variable_label: audienceBrand.data.variable_label
    }
  : this._configService.outputSnapshotData?.selectedBrand ?? null;

  
  if (selectedBrandFromConfig && this.selectedcompareacrossOption === 'Audience Snapshot') {
    const hasValidBrandName = !!(selectedBrandFromConfig.response_label || selectedBrandFromConfig.value);
    if (!hasValidBrandName) {
      const snapshotBrands = (this._configService.brandData || []).filter((b: any) => b.is_snapshot === 1 || b.is_snapshot === true);
      if (snapshotBrands.length > 0) {
        const firstBrand = snapshotBrands[0];
        selectedBrandFromConfig = {
          response_label: firstBrand.response_label || firstBrand.variable_label || firstBrand.MetricOption,
          value: firstBrand.response_label || firstBrand.variable_label || firstBrand.MetricOption,
          variable_label: firstBrand.variable_label || 'Brands',
          is_snapshot: firstBrand.is_snapshot || 1,
          metric_group: firstBrand.metric_group || firstBrand.metric_group_snapshot || ''
        };
      } else {
        selectedBrandFromConfig = null; 
      }
    }
  }

    if (selectedBrandFromConfig && this.selectedcompareacrossOption === 'Audience Snapshot') {
      const formattedBrandObject = {
        option: selectedBrandFromConfig.response_label || selectedBrandFromConfig.value,
        is_selected: true,
        selectOrder: 1,
        value: selectedBrandFromConfig.value ? `${selectedBrandFromConfig.value}_${selectedBrandFromConfig.value}` : '',
        index: 0,
        data: {
          variable_label: selectedBrandFromConfig.variable_label || 'Brands',
          Is_snapshot: selectedBrandFromConfig.is_snapshot || 1,
          response_label: selectedBrandFromConfig.response_label || selectedBrandFromConfig.value,
          metric_group: selectedBrandFromConfig.metric_group || ''
        }
      };
      
      const audienceBrandArray = [formattedBrandObject];
      (this.previewData as any)['Audiencebrand'] = audienceBrandArray;
    }
    
    let pageNumber = this._configCustomService.pageCount || 1;
    this._configService
      .getOutPutData(
      this.previewData,
        this.selected_client,
        this.selected_study,
        this.significance,
        this.isFilteringActive,
        this.DefaultConfidenceLevel,
        this.isTotalBase,
        this.selectedWeight,
        weightColumnName,
        isBoostFactor,
        
        this.SignificanceVsReference,
        this.columnLength,
        this.dataArray,
        isBrandAnalysis,
        this.isAggregatedData,
        this.isSemiAggregatedData,
        this.isRespondentLevel,
        this.aggregatedVariables,
        istimePeriodWave,
        this.widegtconfigdetails,
        this.indexVsBrandReference,
        this.significanceVsBrandReference,
        false, // this._configService.checkTrendEnabled(this._configService.widgetAllData),
        this._configService.widgetPageData,
        this._configService.widgetData,
        pageNumber, //1 //for page wise data fetch,
        false,
        !this.isTotalBase ?(load ? this.selectedCustomBaseReference : innerSelection.customBaseMetric) : null,
        this.multiCohort
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (
          result.Data != null &&
          result.Data != undefined &&
          result.Data != ''
        ) {
          this.opData = JSON.parse(result.Data);
          //this._configService.tiggerSelectionSnapshotType = false;
          this.sortedOPdata = _.cloneDeep(
            this.opData.sort(
              (a: any, b: any) => a.widgetNumber - b.widgetNumber
            )
          );
          // Store opData globally
          if (typeof window !== undefined) {
            (window as any)['jsonobject'] = this.sortedOPdata;
          }
          this._configService.standardSnapOutputData = this.sortedOPdata;
          this._configService.standardSnapOutputDataWhenSigClicked =
            this.sortedOPdata;
          const outputViewDiv = document.querySelector('.output-view');
          if (outputViewDiv) {
            outputViewDiv?.classList.remove('DN');
            this.showOutput.emit();
          }
        } else {
          //No Output Data
          this._loaderService.hideLoader();
        }
        this.cdr.markForCheck();
      });

    this.UpdateSelectionSummary();

    //Adding values for Excel export
    this._configService.setDropdownValue(
      'selectionSummary',
      this._configService.selectionSummaryTextTitle
    );
    this._configService.setDropdownValue('studyName', this.selected_study);
    this._configService.setDropdownValue('uiStudyName', this.uiStudyName);
    this._configService.setDropdownValue('clientName', this.selected_client);
    this._configService.setDropdownValue('snapshotName', this.snapshotName);
    this._configService.setDropdownValue(
      'lowBase',
      this._configService.LBthreshold
    );
    this._configService.setDropdownValue(
      'insufficientBase',
      this._configService.ISthreshold
    );
    this._configService.setDropdownValue(
      'thresholdIndex',
      this._configService.thresholdIndex
    );
    this.baseValuesChanged.emit({
      insufficientBase: this._configService.ISthreshold,
      lowBase: this._configService.LBthreshold, // Adjust this based on your logic
    });
    this.usageDataLog('Snapshot Output');
    this.isPanelLoaded = false;
    this.cdr.markForCheck();
  }

  private isTotalSampleMarker(a: any): boolean {
    return a?.Level1 === 'Total Sample'
      || a?.variable_code === 'total_sample'
      || a?.data_variable_code === 'total_sample';
  }
  usageDataLog(feature: string) {
    let summarytext = '';
    if (
      this._configService.selectionSummaryTextTitle != undefined &&
      this._configService.selectionSummaryTextTitle != null
    ) {
      // summarytext = this.summaryText?.nativeElement.innerText;
      summarytext = this._configService.selectionSummaryTextTitle;
    } else {
      summarytext = this.selectionSummary.replace(/<[^>]*>/g, '');
    }
    this._usermanagementService.UsageData(
      '3',
      this.selected_client,
      this.selected_study,
      feature,
      summarytext,
      this.snapshotName
    );
  }
  getWeightFromConfig() {
    const result = this._configService.weights?.find(
      (item: any) => item.is_selected === true
    );
    const output =
      result && result.variable_label === 'Unweighted'
        ? 'Unweighted'
        : result?.variable_code;
    return output;
  }

  

ResetClicked() {

if (this.variableListEpForOutput) {
  this.variableListEpForOutput.forEach((item: any) => {
    item.is_selected = false; 
    item?.Level1?.forEach((level1: any) => {

     
      level1.is_selected = false;

      level1?.Level2?.forEach((level2: any) => {
        level2.is_selected = false;

        
        if (level2.Level2) {
          level2.Level2.forEach((lvl3: any) => {
            lvl3.is_selected = false;
          });
        }
      });
    });
  });
}

this.cdr.detectChanges();

this.entryPanel_Lvl3?.forEach(item => {
  item.isActive = false;
});
this.entryPanel_Lvl3 = [...this.entryPanel_Lvl3];
this.selectedEP1 = '';
this.selectedEP2 = '';
this.selectedEP3 = '';
this.entry_items_expand = '';
this.entry_nested_items_expand = '';
this.entry_nested_items_expand1 = '';
this.entry_nested_items_expandParent1 = '';
this.entry_nested_items_expand2 = '';
this.entry_nested_items_expandParent2 = '';
this.entry_nested_items_expand3 = '';
this.entry_nested_items_expandParent3 = '';
this.entryFlag = false;
this.searchTextLevel2 = '';
this.searchMetricOption = '';
this.isSelectAll = false;
this.sidePanelblock = true;
this._lastSelectedTextClickEl?.classList.remove('selectedTextClick');
this._lastSelectedTextClickEl = null;
    this.variableListFilter.forEach((item) => {
      item?.Level1?.forEach((level1Item) => {
        level1Item.is_selected = false;
        level1Item?.Level1?.forEach((level2Item: any) => {
          level2Item.is_selected = false;
          level2Item?.Level2?.forEach((level3Item: any) => {
            level3Item.is_selected = false;
            level3Item?.Level3?.forEach((level4Item: any) => {
              level4Item.is_selected = false;
              level4Item?.Level4?.forEach((level5Item: any) => {
                level5Item.is_selected = false;
                level5Item?.Level5?.forEach((level6Item: any) => {
                  level6Item.is_selected = false;
                  level6Item?.Level6?.forEach((level7Item: any) => {
                    level7Item.is_selected = false;
                    level7Item?.Level7?.forEach((level8Item: any) => {
                      level8Item.is_selected = false;
                      level8Item?.Level8?.forEach((level9Item: any) => {
                        level9Item.is_selected = false;
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });

    this.variableList.forEach((item) => {
      item?.Level1?.forEach((level1Item) => {
        level1Item.is_selected = false;
        level1Item?.Level2?.forEach((level2Item: any) => {
          level2Item.is_selected = false;
          level2Item?.Level3?.forEach((level3Item: any) => {
            level3Item.is_selected = false;
            level3Item?.Level4?.forEach((level4Item: any) => {
              level4Item.is_selected = false;
              level4Item?.Level5?.forEach((level5Item: any) => {
                level5Item.is_selected = false;
                level5Item?.Level6?.forEach((level6Item: any) => {
                  level6Item.is_selected = false;
                  level6Item?.Level7?.forEach((level7Item: any) => {
                    level7Item.is_selected = false;
                    level7Item?.Level8?.forEach((level8Item: any) => {
                      level8Item.is_selected = false;
                      level8Item?.Level9?.forEach((level9Item: any) => {
                        level9Item.is_selected = false;
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });

    this.variableListMultiMarketAndCateg.forEach((item) => {
      item?.Level1?.forEach((level1Item) => {
        level1Item.is_selected = false;
        level1Item?.Level2?.forEach((level2Item: any) => {
          level2Item.is_selected = false;
          level2Item?.Level3?.forEach((level3Item: any) => {
            level3Item.is_selected = false;
            level3Item?.Level4?.forEach((level4Item: any) => {
              level4Item.is_selected = false;
              level4Item?.Level5?.forEach((level5Item: any) => {
                level5Item.is_selected = false;
              });
            });
          });
        });
      });
    });









this._configService.entryPointData = null

    if (!this._submitButtonEl) {
      this._submitButtonEl = document.getElementById('submitButton');
    }
    this._submitButtonEl?.classList.add('disabled');
    this.issubmitReset.emit(false);
  
      this.selectedBrand = [];
    this.selectedTimePeriod = [];
    this.selectedMarket = [];
    this.selectedCategory = [];
    this.selectedAudience = [];
    this.selectedTotalSample = [];   
     this.selectedObjects = [];
    this.variablesSummaryObj = [];
    this.variablesSummaryObjRadio = [];
    this.isSavedScenarioSelected = false;
    this.audienceTooltip = 'No selections';
    this._configService.entryPointData = null;
    this._configService.finalLeftPanelSubmitObject = null;
    this._configService.finalLeftPanelInputSelectedObject = null;
    // Prevent global/default re-selection from re-applying after reset
    this._configService.globalDefaultSelectionFlag = false;
    this._configService.tiggerSelectionSnapshotType = false;
    this.dataArray = [];
    this.selectedMarketItems = [];
    this._rebuildToggleStatusCache();
   




this._clearAllVariableExpands();

this.variable_expand = '';
this.entry_items_expand = '';
this.sidePanelblock = false;
this.iscompareacrossDropdownOpen = false;
this.variableListFilter = [...this.variableListFilter];
this.variableList = [...this.variableList];
this.variableListMultiMarketAndCateg = [...this.variableListMultiMarketAndCateg];
this.variableListEpForOutput = [...this.variableListEpForOutput];
this.cdr.detectChanges();

}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // Fast path: if nothing is open, skip all DOM queries entirely.
    if (
      !this.sidePanelblock &&
      !this.variable_expand &&
      !this.entry_items_expand &&
      !this.iscompareacrossDropdownOpen
    ) {
      return;
    }

    const clickedInside = this.elRef.nativeElement.contains(event.target);

    // Check toggleLeftPanel first — single closest() instead of multiple
    if (this.isClickInside(event, '.toggleLeftPanel')) {
      this.sidePanelblock = false;
      this.entry_items_expand = '';
      this._clearAllVariableExpands();
      return;
    }

    if (clickedInside) return; // Inside the panel — nothing to close

    const target = event.target as Element;
    const isElement = target instanceof Element;

    // Only run closest() checks for things that are actually open
    if (this.sidePanelblock) {
      const inSidePanel = isElement && target.closest('.side-panel-block');
      const inLvl0 = isElement && target.closest('.leftPanelLvl0');
      if (!inSidePanel && !inLvl0) {
        this.sidePanelblock = false;
        this.entry_items_expand = '';
      } else if (!inSidePanel) {
        this.sidePanelblock = false;
      }
    }

    if (this.variable_expand) {
      const inSelection = isElement && target.closest('.variables-sub-itemsLev1');
      if (!inSelection) {
        this._clearAllVariableExpands();
        this.increaseLeftpanelHeight.emit({ isReset: true });
      }
    }

    if (this.iscompareacrossDropdownOpen) {
      const inDropdown = isElement && target.closest('.custom-options');
      if (!inDropdown) {
        this.iscompareacrossDropdownOpen = false;
        this.isSubSectionDropdownOpen = false;
        this.isSectionDropdownOpen = false;
      }
    }
  }

  private _clearAllVariableExpands(): void {
    this.variable_expand = '';
    this.variable_expandLev1 = '';
    this.variable_expandLev2 = '';
    this.variable_expandLev3 = '';
    this.variable_expandLev4 = '';
    this.variable_expandLev5 = '';
    this.variable_expandLev6 = '';
    this.variable_expandLev7 = '';
    this.variable_expandLev8 = '';
    this.variable_expandLev9 = '';
  }

  LoadSelection(isDefaultLoad: boolean) {
    this._configService.selectedStudy = this.selected_study;
    this.isLoadSelection.emit(isDefaultLoad);
    //this.collapsePanel();
  }

  updateLeftPanel() {
    let option = this.selectedScenarioData[0].snapshotType;
    this.selectedSection = this.selectedScenarioData[0].section;
    this.selectedSubSection = this.selectedScenarioData[0].subSection;
    this._configService.setDropdownValue('compareAcross', option);
    this.compareacross.forEach((c: any) => {
      c.selected = c.name === option ? true : false;
      c.section.forEach((s: any) => {
        s.selected = s.name === this.selectedSection ? true : false;
        if (s.subSection) {
          s.subSection?.forEach(
            (ss: any) =>
              (ss.selected = ss.name === this.selectedSubSection ? true : false)
          );
        }
        if (s.subsection) {
          s.subsection?.forEach(
            (ss: any) =>
              (ss.selected = ss.name === this.selectedSubSection ? true : false)
          );
        }
      });
    });
    this.selectedcompareacrossOption = option;
    // Keep the shared snapshot state in sync before the saved selections are
    // replayed. Otherwise a cross-type load (for example Single Brand to
    // Multiple Brands) builds the output with the previous snapshot rules.
    // Also keep sessionStorage + header selected name in sync so later
    // Single → Multiple switches via the header do not treat the change as
    // the same snapshot type and skip remount.
    this._configService.selectedcompareacrossOption = option;
    this._configService.selectedSnapshotType = option;
    this._configService.snapshotTypeSelectedName = option;
    this._configService.snapshotSelectedName = option;
    sessionStorage.setItem('snapshotType', option);
    this.selectedType.emit(option);
    this.entry_nested_items_expand = '';

    this.entry_nested_items_expand1 = '';
    this.entry_nested_items_expandParent1 = '';
    this.entry_nested_items_expand2 = '';
    this.entry_nested_items_expandParent2 = '';
    this.entry_nested_items_expand3 = '';
    this.entry_nested_items_expandParent3 = '';
    this.GetMandatorySelectionsList();

    if (this.snapshotDataConfig.snapshotType_details.length > 0) {
      let snapshotTypeEPandD =
        this.snapshotDataConfig.snapshotType_details.find(
          (x: any) => x.snapshot_type === option
        );

      const entryTabDiv = this.getEntryTabEl();
      const loadDiv = this.getBtnLoadEl();
      const variableTab = this.getVariableTabEl();

      entryTabDiv?.classList.add('DN');
      loadDiv?.classList.add('DN');
      variableTab?.classList.add('DN');

      const submitreset = document.querySelector('.submit-reset-btn disabled');
      if (!submitreset?.classList.contains('disabled'))
        submitreset?.classList.add('disabled');

      let selectedEPs = snapshotTypeEPandD.entry_point.filter(
        (x: any) => x.is_selected === true
      );
      let selectedEPsVariableCodes = selectedEPs.map(
        (x: any) => x.variable_code
      );
      this.level0EP = [];
      this.entryPanel = [];
      if (selectedEPs.length > 0) {
        if (entryTabDiv) {
          entryTabDiv.classList.remove('DN');
        }
        if (loadDiv) loadDiv.classList.remove('DN');
        let entryPointsData = this.entryPointsData.EntryPoints.filter((a: any) =>
          selectedEPsVariableCodes.includes(a.VariableCode)
        );
        const Leve1 = _.uniq(
          _.map(
            _.filter(
              entryPointsData,
              (item) =>
                item.Level1 !== null &&
                item.Level2 !== '' &&
                item.study == this.selected_study
            ),
            'Level1'
          )
        );
        let index = 0;
        let uniqueVariableCode: string[] = [];

        let isEntryPoints = false;
        for (const element of Leve1) {
          this.entryPanel.push({
            Level1: element,
          });

          this.level0EP.push(element);
          if (
            this._configService.isGlobalDefaultSelectionEnabled &&
            this._configService.globalDefaultSelectionFlag &&
            !this.isSavedScenarioSelected &&
            this._configService.tiggerSelectionSnapshotType
          ) {
            let entryPointsDataForSelection = this.entryPointsData.EntryPoints.find(
              (a: any) =>
                a.Level1 == element &&
                a.study == this.selected_study &&
                a.MetricOption != ''
            );
            const match = this.EPdataFor_Multiple.find(
              (a: any) =>
                a.variable_code === entryPointsDataForSelection.VariableCode
            );
            if (
              match &&
              this.selectedcompareacrossOption !== 'Multiple Markets'
            ) {
              uniqueVariableCode.push(entryPointsDataForSelection.VariableCode);
              match.variable_label = `Entry Point ${index + 1}`;
            }

            if (this.isMultiSelectEP) {
              if (entryPointsDataForSelection) {
                isEntryPoints = true;
                this.checkBoxClick(
                  index,
                  0,
                  entryPointsDataForSelection.Header,
                  entryPointsDataForSelection.Level1,
                  entryPointsDataForSelection.Level2,
                  entryPointsDataForSelection.MetricOption,
                  entryPointsDataForSelection.VariableCode,
                  entryPointsDataForSelection.ResponseCode,
                  entryPointsDataForSelection.mandatory_variable_mapping,
                  entryPointsDataForSelection.is_SelectAll_Metrics,
                  entryPointsDataForSelection.e1_variable_code,
                  entryPointsDataForSelection.e2_variable_code,
                  entryPointsDataForSelection.e3_variable_code,
                  entryPointsDataForSelection.dimension
                );
              }
            } else {
              if (entryPointsDataForSelection) {
                isEntryPoints = true;
                this.EPRadioClick(
                  index,
                  0,
                  entryPointsDataForSelection.Header,
                  entryPointsDataForSelection.Level1,
                  entryPointsDataForSelection.Level2,
                  entryPointsDataForSelection.MetricOption,
                  entryPointsDataForSelection.VariableCode,
                  entryPointsDataForSelection.ResponseCode,
                  entryPointsDataForSelection.mandatory_variable_mapping,
                  entryPointsDataForSelection.is_SelectAll_Metrics,
                  entryPointsDataForSelection.e1_variable_code,
                  entryPointsDataForSelection.e2_variable_code,
                  entryPointsDataForSelection.e3_variable_code,
                  entryPointsDataForSelection.dimension
                );
              }
            }
            index++;
          }
        }
        if (uniqueVariableCode && uniqueVariableCode.length > 0) {
          this.EPdataFor_Multiple = this.EPdataFor_Multiple.filter(
            (item: any) =>
              item.variable_code === '' ||
              uniqueVariableCode.includes(item.variable_code)
          );
        }
        if (
          isEntryPoints &&
          this._configService.isGlobalDefaultSelectionEnabled &&
          this._configService.globalDefaultSelectionFlag &&
          !this.isSavedScenarioSelected
        ) {
          this.loadBtnClick(true);
        }
      } else {
        this.dataArray = [];
        const clientStudyInfo = {
          clientName: this.clientDetails.clientDetails.client_code,
          studyName: this.selected_study,
          snapshotType: this.selectedcompareacrossOption,
          isMandatoryLoadClicked:
            this.selectedcompareacrossOption == 'Multiple Markets' ||
              this.selectedcompareacrossOption == 'Multiple Categories'
              ? true
              : false,
        };
        this.dataArray.push(clientStudyInfo);
        this.loadBtnClick(selectedEPs.length > 0 ? true : false);

        // const variableTab = document.querySelector('.variableTab');
        // if (variableTab)
        //   variableTab.classList.remove('DN');
      }
      let lvl1 = '';
      let MetricOptionSelected = '';
      if (this.selectedcompareacrossOption != 'Multiple Markets') {
        lvl1 = this.dataArray[0]?.EntryPoint1?.Level1;
        //for multi market
        MetricOptionSelected =
          this.dataArray[0]?.EntryPoint1?.Level2[0]?.MetricOptions[0]?.Name;
      } else {
        lvl1 = this.dataArray[0]?.EntryPoint2?.Level1;
        //for multi market
        MetricOptionSelected =
          this.dataArray[0]?.EntryPoint2?.Level2[0]?.MetricOptions[0]?.Name;
      }
      const BindL1Entry =
        this.entryPanel.find((el) => el.Level1 === lvl1)?.Level1 || '';
      const BindL1Index = this.entryPanel.findIndex((el) => el.Level1 === lvl1);

      this.entryExpand(BindL1Entry);
      const BindL2Entry =
        this.entryPanel_Lvl2.find((el) => el.Level1 === lvl1)?.Level2 || '';
      this.entry_nested_items_expand1 = BindL2Entry;
      this.entry_nested_items_expand2 = BindL2Entry;
      this.entry_nested_items_expand3 = BindL2Entry;
      this.BindSidePanel(BindL1Index, BindL1Entry, BindL2Entry);
      const BindL3Index = this.entryPanel_Lvl3.findIndex(
        (el) => el.Level1 === lvl1 && el.MetricOptions === MetricOptionSelected
      );
      const BindL3Entry = this.entryPanel_Lvl3.find(
        (el) => el.Level1 === lvl1 && el.MetricOptions === MetricOptionSelected
      );
      if (BindL3Entry && !this.isMultiSelectEP) {
        this.EPRadioClick(
          BindL3Index,
          BindL1Index,
          this.EntryPointHeader,
          BindL3Entry.Level1,
          BindL3Entry.Level2,
          BindL3Entry.MetricOptions,
          BindL3Entry.variableCode,
          BindL3Entry.responseCode,
          BindL3Entry.mandatory_variable_mapping,
          false,
          BindL3Entry.e1_variable_code,
          BindL3Entry.e2_variable_code,
          BindL3Entry.e3_variable_code,
          BindL3Entry.dimension
        );
      }
      if (this.selectedcompareacrossOption != 'Multiple Markets') {
        this.loadBtnClick(selectedEPs.length > 0 ? true : false);
      } else if (
        this.selectedcompareacrossOption == 'Multiple Markets' &&
        selectedEPs.length > 0
      ) {
        this.loadBtnClick(selectedEPs.length > 0 ? true : false);
      }

      // const simulatedEvent = new MouseEvent('click', {
      //   bubbles: true,
      //   cancelable: true,
      //   view: window
      // });
      //   let TP = JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)?.selections[0]['Time Period'][0];
      //   let BrandLoad = JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)?.selections[1]['Brands'][0];
      //   let TPData: any = this.variableList?.find((item: any) => item?.Level0 === TP?.Level0);
      //   let TPDataL1: any = TPData?.Level1?.find((item: any) => item?.Level1_value === TP?.Level1);
      //   let BrandLoadData: any = this.variableList?.find((item: any) => item?.Level0 === BrandLoad?.Level0);
      //   let BrandLoadDataL1: any = BrandLoadData?.Level1?.find((item: any) => item?.Level1_value === BrandLoad?.Level1);
      //   this.checkBoxClickNotEPRadio('NOTfilters', simulatedEvent, TP.Level1, TP.Level2, TP.Level3, TP.Level4, TP.Level5, TPDataL1?.Level2, 'Level2', TPDataL1, TP.Level0, true);
      //   this.checkBoxClickNotEPRadio('NOTfilters', simulatedEvent, BrandLoad.Level1, BrandLoad.Level2, BrandLoad.Level3, BrandLoad.Level4, BrandLoad.Level5, BrandLoadDataL1?.Level2, 'Level2', BrandLoadDataL1, BrandLoad.Level0, true);

      //   setTimeout(() => {
      //     let index = this.variableList.indexOf(TPData);
      //     if (index !== -1) {
      //       this.variableList[index].Level1 = TPData.Level1; // Explicitly reassign modified object
      //       this.variableList = [...this.variableList];
      //       this.cdr.detectChanges();
      //     }
      //   }, 0);
      //   setTimeout(() => {
      //     let index = this.variableList.indexOf(BrandLoadData);
      //     if (index !== -1) {
      //       this.variableList[index].Level1 = BrandLoadData.Level1; // Explicitly reassign modified object
      //       this.variableList = [...this.variableList];
      //       this.cdr.detectChanges();
      //     }
      //   }, 0);
    }
  }

  autoSelectDefaultBrands() {
    if (!this.defaultBrandList || this.defaultBrandList.length === 0) return;

    const simulatedEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    });

    const brandsVariable = this.variableList.find(
      (item: any) => item.Level0 === 'Brands'
    );
    if (!brandsVariable) return;

    const filterbrands = brandsVariable.Level1?.find((a: any) => a.Level1_value === "Brands")?.Level2?.map((a: any) => a.Level2_value) ?? [];
    this.defaultBrandList = this.defaultBrandList.filter((brand: string) => filterbrands.includes(brand));

    for (const level1Data of brandsVariable.Level1 || []) {
      for (const level2Data of level1Data.Level2 || []) {
        if (this.defaultBrandList.includes(level2Data.Level2_value) && !level2Data.is_selected) {
          const selection = this.buildSelectedObject('Default', level1Data, level2Data, '');
          this.checkBoxClickNotEP(
            'NOTfilters',
            simulatedEvent,
            selection.Level1,
            selection.Level2,
            selection.Level3,
            selection.Level4,
            selection.Level5,
            selection.Level6 || '',
            selection.Level7 || '',
            selection.Level8 || '',
            selection.Level9 || '',
            'Brands',
            true,
            selection,
            true
          );
        }
      }
    }
  }

  GlobalDefaultSelection() { 
    //this.selectedObjects = [];
    this._configService.saveSelectionLoad = true;
    const simulatedEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    });

    if (!this.selectedcompareacrossOption.includes('Multiple') && !(this.selectedcompareacrossOption === 'Audience Snapshot' && !this.isSingleaudienceCohortType)) {
      this.variableList.forEach((item: any) => {
        const level0 = item.Level0;
        const level1List = item.Level1;
        if (!level1List?.length) return;
        const selectedItems = [];
        if (level0 === 'Time Period') {
          const _askMeTP = this._findAskMeTimePeriod(level1List);
          const selectedL1Item = _askMeTP?.l1Item ?? level1List[0];
          const selectedLevel2 = _askMeTP?.level2 ?? level1List[0]?.Level2?.at(0);
          if (selectedLevel2) {
            selectedItems.push(
              this.buildSelectedObject(
                level0,
                selectedL1Item,
                selectedLevel2,
                ''
              )
            );
          }
        } else if (level0 === 'Brands') {
          const _askMeBrand = this._findAskMeBrand(level1List);
          if (_askMeBrand) {
            selectedItems.push(this.buildSelectedObject(level0, _askMeBrand.level1, { ..._askMeBrand.level2, sort_id: '1' }, ''));
          }
          if (!_askMeBrand) level1List.forEach((level1: any) => {
            const level2Items = this.getDefaultBrandLevel2Items(level1.Level2 || [], 1);
            level2Items.forEach((selectedLevel2: any) => {
              if (selectedLevel2 && level1.Level1_value =="Brands") {
                selectedItems.push(
                  this.buildSelectedObject(level0, level1, selectedLevel2, '')
                );
              }
            });
          });
        }
        else if (level0 === 'Audience' && this.isSingleaudienceCohortType) {         
          if (this.isAudienceTotalSample) {
            const totalSampleLevel1 = level1List.find(
              (level1: any) => level1.Level1_value === 'Total Sample'
            );
            if (totalSampleLevel1) {
              totalSampleLevel1.is_selected = true;
              this.isTotalSampleAudienceActive = true;
              const tsMarker = this.buildSelectedObject(level0, totalSampleLevel1, {}, {});
              // Match the interactive DOM value (data-variable-name = Level1_value) so
              // the deselect findIndex can locate and remove the marker on uncheck.
              tsMarker.variable_label = totalSampleLevel1.Level1_value; // 'Total Sample'
              selectedItems.push(tsMarker);
            }
          } else {
          const firstAudience = level1List.filter((level1: any) => level1.Level1_value !== 'Total Sample');
          const level1 = firstAudience[0];
          const selectedLevel2 = level1.Level2?.[0]; // first item
          const selectedLevel3 = selectedLevel2.Level3?.[0] ?? {};
          if (selectedLevel2) {
            selectedItems.push(
              this.buildSelectedObject(level0, level1, selectedLevel2, selectedLevel3)
            );
          }
          }
        }
        else {
          const level1 = level1List[0];
          const deepest = this.getDeepestLevels(level1?.Level2 || [], 'first');

          if (deepest.selectedLevel2) {
            selectedItems.push(
              this.buildSelectedObject(
                level0,
                level1,
                deepest.selectedLevel2,
                deepest.selectedLevel3,
                deepest.selectedLevel4,
                deepest.selectedLevel5
              )
            );
          }
        }

        if (selectedItems.length > 0) {
          // Remove existing entry for same level0 to prevent duplicates during global default
          this.selectedObjects = this.selectedObjects.filter(
            (obj: any) => !obj.hasOwnProperty(level0)
          );
          this.selectedObjects.push({ [level0]: selectedItems });
        }
      });

      // this.applyTotalSampleToSelectedObjects();

      this.selectedObjects.forEach((obj: any) => {
        const level0Key = Object.keys(obj)[0];
        const selection = obj[level0Key]?.[0];
        if (!selection || selection.isFilter) return;
        if (
          level0Key === 'Audience' &&
          this.isAudienceTotalSample &&
          this.isTotalSampleAudienceActive
        ) {
          return;
        }

        const level0 = selection.Level0;
        const level1 = selection.Level1;
        const level2 = selection.Level2;
        const level3 = selection.Level3;
        const level4 = selection.Level4;
        const level5 = selection.Level5;

        const variableData = this.variableList.find(
          (item: any) => item.Level0 === level0
        );
        const level1Data = variableData?.Level1?.find(
          (l1: any) => l1.Level1_value === level1
        );

        if (!level1Data) return;

        let useLevel = 'Level2';
        let levelData = level1Data?.Level2;
        let currentLevel = level1Data?.Level2?.find(
          (l2: any) => l2.Level2_value === level2
        );

        if (currentLevel?.Level3?.length > 0) {
          useLevel = 'Level3';
          levelData = currentLevel.Level3;
          currentLevel = currentLevel.Level3?.find(
            (l3: any) => l3.Level3_value === level3
          );

          if (currentLevel?.Level4?.length > 0) {
            useLevel = 'Level4';
            levelData = currentLevel.Level4;
            currentLevel = currentLevel.Level4?.find(
              (l4: any) => l4.Level4_value === level4
            );

            if (currentLevel?.Level5?.length > 0) {
              useLevel = 'Level5';
              levelData = currentLevel.Level5;
            }
          }
        }

        if (level0 === 'Time Period' && this._configService.isStaticTimeFrame) {
          return;
        }

        this.checkBoxClickNotEPRadio(
          'NOTfilters',
          simulatedEvent,
          level1,
          level2,
          level3,
          level4,
          level5,
          levelData,
          useLevel,
          level1Data,
          level0,
          true
        );
      });

      if (
        this._configService.isAggregatedData &&
        this.variableListFilter.length > 0 &&
        this.variableListFilter[0]?.Level1?.length > 0
      ) {
        this.GlobalFilterSelectionForAggregated(simulatedEvent);
      }
      if(this.isSingleaudienceCohortType || this.selectedcompareacrossOption != 'Audience Snapshot'){
        this._applyAskMeFilters(simulatedEvent);
        this._configService.askMePreselection = null;
        this.SubmitClicked(false, false, true);
      }

    }

    if (this.selectedcompareacrossOption == 'Multiple Brands'||(this.selectedcompareacrossOption == 'Audience Snapshot' && !this.isSingleaudienceCohortType) ) {
      this.variableList.forEach((item: any) => {
        const level0 = item.Level0;
        const level1List = item.Level1;
        if (!level1List?.length) return;

        const selectedItems = [];

        if (level0 === 'Time Period') {
          const _askMeTP = this._findAskMeTimePeriod(level1List);
          const selectedL1Item = _askMeTP?.l1Item ?? level1List[0];
          const selectedLevel2 = _askMeTP?.level2 ?? level1List[0]?.Level2?.at(0);
          if (selectedLevel2) {
            selectedItems.push(
              this.buildSelectedObject(
                level0,
                selectedL1Item,
                selectedLevel2,
                ''
              )
            );
          }
        } else if (level0 === 'Brands') {
          const _askMeBrand = this._findAskMeBrand(level1List);
          if (_askMeBrand) {
            selectedItems.push(this.buildSelectedObject(level0, _askMeBrand.level1, { ..._askMeBrand.level2, sort_id: '1' }, ''));
          }
          const level2Array = level1List?.[0]?.Level2 || [];
          const brandsToSelect = this.getDefaultBrandLevel2Items(level2Array, 6);
          if (!_askMeBrand) brandsToSelect.forEach((selectedLevel2: any) => {
            selectedItems.push(
              this.buildSelectedObject(
                level0,
                level1List[0],
                selectedLevel2,
                ''
              )
            );
          });
        } else if (level0 === 'Audience') {
          if (this.isAudienceTotalSample) {
            const totalSampleLevel1 = level1List.find(
              (level1: any) => level1.Level1_value === 'Total Sample'
            );
            if (totalSampleLevel1) {
              totalSampleLevel1.is_selected = true;
              this.isTotalSampleAudienceActive = true;
              const tsMarker = this.buildSelectedObject(level0, totalSampleLevel1, {}, {});
              // Match the interactive DOM value (data-variable-name = Level1_value) so
              // the deselect findIndex can locate and remove the marker on uncheck.
              tsMarker.variable_label = totalSampleLevel1.Level1_value; // 'Total Sample'
              selectedItems.push(tsMarker);
              const totalSampleFirstOption = totalSampleLevel1?.Level2?.[0];
              if (totalSampleFirstOption) {
                selectedItems.push(
                  this.buildSelectedObject(level0, totalSampleLevel1, totalSampleFirstOption, '')
                );
              }
              // Default audience order for multi-cohort:
              // 1) Total Sample (marker + first option)
              // 2) Decision Maker (up to 2 options)
              // 3) If Decision Maker has only 1 option, pick Gender first option
              const decisionMaker = level1List.find(
                (level1: any) => (level1.Level1_value || '').toLowerCase() === 'decision maker'
              );

              if (decisionMaker) {
                const decisionMakerOptions = Array.isArray(decisionMaker.Level2)
                  ? decisionMaker.Level2.slice(0, 2)
                  : [];

                decisionMakerOptions.forEach((selectedLevel2: any) => {
                  selectedItems.push(
                    this.buildSelectedObject(level0, decisionMaker, selectedLevel2, '')
                  );
                });

                if (decisionMakerOptions.length === 1) {
                  const gender = level1List.find(
                    (level1: any) => (level1.Level1_value || '').toLowerCase() === 'gender'
                  );
                  const firstGenderOption = gender?.Level2?.[0];
                  if (gender && firstGenderOption) {
                    selectedItems.push(
                      this.buildSelectedObject(level0, gender, firstGenderOption, '')
                    );
                  }
                }
              } else {
                const firstAudience = level1List.find((level1: any) => level1.Level1_value !== 'Total Sample');
                if (firstAudience) {
                  firstAudience.Level2?.slice(0, 2).forEach((selectedLevel2: any) => {
                    selectedItems.push(
                      this.buildSelectedObject(level0, firstAudience, selectedLevel2, '')
                    );
                  });
                }
              }
            }
          } else {
           const firstAudience = level1List.find((level1: any) => level1.Level1_value !== 'Total Sample');
          if (firstAudience) {
            firstAudience.Level2?.slice(0, 3).forEach((selectedLevel2: any) => {
              selectedItems.push(
                this.buildSelectedObject(level0, firstAudience, selectedLevel2, '')
              );
            });
          }
          }
        }
        else {
          const level1 = level1List[0];
          const {
            selectedLevel2,
            selectedLevel3,
            selectedLevel4,
            selectedLevel5,
          } = this.getDeepestLevels(level1.Level2, 'first');
          if (selectedLevel2) {
            selectedItems.push(
              this.buildSelectedObject(
                level0,
                level1,
                selectedLevel2,
                selectedLevel3,
                selectedLevel4,
                selectedLevel5
              )
            );
          }
        }

        if (selectedItems.length > 0) {
          // Remove existing entry for same level0 to prevent duplicates during global default
          this.selectedObjects = this.selectedObjects.filter(
            (obj: any) => !obj.hasOwnProperty(level0)
          );
          this.selectedObjects.push({ [level0]: selectedItems });
        }
      });

      // this.applyTotalSampleToSelectedObjects();

      this.selectedObjects.forEach((obj: any) => {
        const level0Key = Object.keys(obj)[0];
        const selections = obj[level0Key];
        if (!selections || selections.isFilter) return;

        const variableData = this.variableList.find(
          (item: any) => item.Level0 === level0Key
        );
        if (!variableData) return;

        selections.forEach((selection: any) => {
          const level1 = selection.Level1;
          const level2 = selection.Level2;
          const level3 = selection.Level3;
          const level4 = selection.Level4;
          const level5 = selection.Level5;
          const level6 = selection.Level6;
          const level7 = selection.Level7;
          const level8 = selection.Level8;
          const level9 = selection.Level9;

          const level1Data = variableData.Level1?.find(
            (l1: any) => l1.Level1_value === level1
          );
          if (!level1Data) return;

          const level2Data = level1Data.Level2?.find(
            (l2: any) => l2.Level2_value === level2
          );
          const level3Data = level2Data?.Level3?.find(
            (l3: any) => l3.Level3_value === level3
          );
          const level4Data = level3Data?.Level4?.find(
            (l4: any) => l4.Level4_value === level4
          );
          const level5Data = level4Data?.Level5?.find(
            (l5: any) => l5.Level5_value === level5
          );
          const level6Data = level5Data?.Level6?.find(
            (l6: any) => l6.Level6_value === level6
          );
          const level7Data = level6Data?.Level7?.find(
            (l7: any) => l7.Level7_value === level7
          );
          const level8Data = level7Data?.Level8?.find(
            (l8: any) => l8.Level8_value === level8
          );
          const level9Data = level8Data?.Level7?.find(
            (l9: any) => l9.Level9_value === level9
          );

          let useLevel = 'Level2';
          let levelData = level1Data.Level2;

          if (level2Data?.Level3?.length > 0) {
            useLevel = 'Level3';
            levelData = level2Data.Level3;
          }
          if (level3Data?.Level4?.length > 0) {
            useLevel = 'Level4';
            levelData = level3Data.Level4;
          }
          if (level4Data?.Level5?.length > 0) {
            useLevel = 'Level5';
            levelData = level4Data.Level5;
          }
          if (level5Data?.Level6?.length > 0) {
            useLevel = 'Level6';
            levelData = level5Data.Level6;
          }
          if (level6Data?.Level7?.length > 0) {
            useLevel = 'Level7';
            levelData = level6Data.Level7;
          }
          if (level7Data?.Level8?.length > 0) {
            useLevel = 'Level8';
            levelData = level7Data.Level8;
          }
          if (level8Data?.Level8?.length > 0) {
            useLevel = 'Level8';
            levelData = level8Data.Level9;
          }

          if (
            level0Key === 'Time Period' &&
            this._configService.isStaticTimeFrame
          ) {
            return;
          }

          if (level0Key === 'Brands'||level0Key === 'Audience') {
            this.checkBoxClickNotEP(
              'NOTfilters',
              simulatedEvent,
              level1,
              level2,
              level3,
              level4,
              level5,
              level6,
              level7,
              level8,
              level9,
              level0Key,
              true,
              selection,
              true
            );
          } else {
            this.checkBoxClickNotEPRadio(
              'NOTfilters',
              simulatedEvent,
              level1,
              level2,
              level3,
              level4,
              level5,
              levelData,
              useLevel,
              level1Data,
              level0Key,
              true
            );
          }
        });
      });

      if (
        this._configService.isAggregatedData &&
        this.variableListFilter.length > 0 &&
        this.variableListFilter[0]?.Level1?.length > 0
      ) {
        this.GlobalFilterSelectionForAggregated(simulatedEvent);
      }
      this._applyAskMeFilters(simulatedEvent);
      this._configService.askMePreselection = null;
      this.SubmitClicked(false, false, true);
    }

    if (this.selectedcompareacrossOption === 'Multiple Markets' && this._configService.askMePreselection) {
      this.variableListMultiMarketAndCateg.forEach((item: any) => {
        const level0 = item.Level0;
        const level1List = item.Level1;
        if (!level1List?.length) return;
        const selectedItems: any[] = [];

        if (level0 === 'Time Period') {
          const _askMeTP = this._findAskMeTimePeriod(level1List);
          const selectedL1Item = _askMeTP?.l1Item ?? level1List[0];
          const selectedLevel2 = _askMeTP?.level2 ?? level1List[0]?.Level2?.at(0);
          if (selectedLevel2) {
            selectedItems.push(this.buildSelectedObject(level0, selectedL1Item, selectedLevel2, ''));
          }
        } else if (level0 === 'Markets') {
          const _askMeMarket = this._findAskMeMarket(level1List);
          if (_askMeMarket) {
            selectedItems.push(this.buildSelectedObject(level0, _askMeMarket.level1, { ..._askMeMarket.level2, sort_id: '1' }, ''));
          } else {
            const firstMarket = level1List[0]?.Level2?.[0];
            if (firstMarket) {
              selectedItems.push(this.buildSelectedObject(level0, level1List[0], firstMarket, ''));
            }
          }
        } else if (level0 === 'Brands') {
          const _askMeBrand = this._findAskMeBrand(level1List);
          if (_askMeBrand) {
            selectedItems.push(this.buildSelectedObject(level0, _askMeBrand.level1, { ..._askMeBrand.level2, sort_id: '1' }, ''));
          } else {
            const firstBrand = level1List[0]?.Level2?.[0];
            if (firstBrand) {
              selectedItems.push(this.buildSelectedObject(level0, level1List[0], firstBrand, ''));
            }
          }
        } else {
          const level1 = level1List[0];
          const { selectedLevel2, selectedLevel3, selectedLevel4, selectedLevel5 } = this.getDeepestLevels(level1.Level2, 'first');
          if (selectedLevel2) {
            selectedItems.push(this.buildSelectedObject(level0, level1, selectedLevel2, selectedLevel3, selectedLevel4, selectedLevel5));
          }
        }

        if (selectedItems.length > 0) {
          this.selectedObjects = this.selectedObjects.filter((obj: any) => !obj.hasOwnProperty(level0));
          this.selectedObjects.push({ [level0]: selectedItems });
        }
      });
      this._applyAskMeFilters(simulatedEvent);
      this._configService.askMePreselection = null;
      this.SubmitClicked(false, false, true);
    }
    //   if (this.selectedcompareacrossOption == 'Audience Snapshot'&& this.snapshotcohortType == 'multiple') {
    //   this.variableList.forEach((item: any) => {
    //     const level0 = item.Level0;
    //     const level1List = item.Level1;
    //     if (!level1List?.length) return;

    //     const selectedItems = [];

    //     if (level0 === 'Time Period') {
    //       const level2Array = level1List[0]?.Level2 || [];
    //       const selectedLevel2 = level2Array.at(-1);
    //       if (selectedLevel2) {
    //         selectedItems.push(
    //           this.buildSelectedObject(
    //             level0,
    //             level1List[0],
    //             selectedLevel2,
    //             ''
    //           )
    //         );
    //       }
    //     } else if (level0 === 'Audience') {
         
    //       const level2Array = level1List?.[1]?.Level2 || [];
    //       level2Array.slice(0, 3).forEach((selectedLevel2: any) => {
    //         selectedItems.push(
    //           this.buildSelectedObject(
    //             level0,
    //             level1List[1],
    //             selectedLevel2,
    //             ''
    //           )
    //         );
    //       });
    //     } else {
    //       const level1 = level1List[0];
    //       const {
    //         selectedLevel2,
    //         selectedLevel3,
    //         selectedLevel4,
    //         selectedLevel5,
    //       } = this.getDeepestLevels(level1.Level2, 'first');
    //       if (selectedLevel2) {
    //         selectedItems.push(
    //           this.buildSelectedObject(
    //             level0,
    //             level1,
    //             selectedLevel2,
    //             selectedLevel3,
    //             selectedLevel4,
    //             selectedLevel5
    //           )
    //         );
    //       }
    //     }

    //     if (selectedItems.length > 0) {
    //       this.selectedObjects.push({ [level0]: selectedItems });
    //     }
    //   });

    //   this.selectedObjects.forEach((obj: any) => {
    //     const level0Key = Object.keys(obj)[0];
    //     const selections = obj[level0Key];
    //     if (!selections || selections.isFilter) return;

    //     const variableData = this.variableList.find(
    //       (item: any) => item.Level0 === level0Key
    //     );
    //     if (!variableData) return;

    //     selections.forEach((selection: any) => {
    //       const level1 = selection.Level1;
    //       const level2 = selection.Level2;
    //       const level3 = selection.Level3;
    //       const level4 = selection.Level4;
    //       const level5 = selection.Level5;

    //       const level1Data = variableData.Level1?.find(
    //         (l1: any) => l1.Level1_value === level1
    //       );
    //       if (!level1Data) return;

    //       const level2Data = level1Data.Level2?.find(
    //         (l2: any) => l2.Level2_value === level2
    //       );
    //       const level3Data = level2Data?.Level3?.find(
    //         (l3: any) => l3.Level3_value === level3
    //       );
    //       const level4Data = level3Data?.Level4?.find(
    //         (l4: any) => l4.Level4_value === level4
    //       );
    //       const level5Data = level4Data?.Level5?.find(
    //         (l5: any) => l5.Level5_value === level5
    //       );

    //       let useLevel = 'Level2';
    //       let levelData = level1Data.Level2;

    //       if (level2Data?.Level3?.length > 0) {
    //         useLevel = 'Level3';
    //         levelData = level2Data.Level3;
    //       }
    //       if (level3Data?.Level4?.length > 0) {
    //         useLevel = 'Level4';
    //         levelData = level3Data.Level4;
    //       }
    //       if (level4Data?.Level5?.length > 0) {
    //         useLevel = 'Level5';
    //         levelData = level4Data.Level5;
    //       }

    //       if (
    //         level0Key === 'Time Period' &&
    //         this._configService.isStaticTimeFrame
    //       ) {
    //         return;
    //       }

    //       if (level0Key === 'Audience') {
    //         this.checkBoxClickNotEP(
    //           'NOTfilters',
    //           simulatedEvent,
    //           level1,
    //           level2,
    //           level3,
    //           level4,
    //           level5,
    //           level0Key,
    //           true,
    //           selection,
    //           true
    //         );
    //       } else {
    //         this.checkBoxClickNotEPRadio(
    //           'NOTfilters',
    //           simulatedEvent,
    //           level1,
    //           level2,
    //           level3,
    //           level4,
    //           level5,
    //           levelData,
    //           useLevel,
    //           level1Data,
    //           level0Key,
    //           true
    //         );
    //       }
    //     });
    //   });

    //   if (
    //     this._configService.isAggregatedData &&
    //     this.variableListFilter.length > 0 &&
    //     this.variableListFilter[0]?.Level1?.length > 0
    //   ) {
    //     this.GlobalFilterSelectionForAggregated(simulatedEvent);
    //   }
    //   this.SubmitClicked(false, false, true);
    // }

    if (this.selectedcompareacrossOption == 'Multiple Markets') {
      let entryPointsData = this.entryPointsData.EntryPoints.filter(
        (a: any) => a.study == this.selected_study && (a.VariableCode == 'Market' || a.Level1 == "Markets")
      );

      entryPointsData = entryPointsData.filter(
        (item: any, index: number, self: any[]) =>
          index ===
          self.findIndex(
            (t: any) =>
              (t.MetricOption || '').toLowerCase() ===
              (item.MetricOption || '').toLowerCase()
          )
      );

      if (entryPointsData && entryPointsData.length > 0) {
        const limitEntryPoints =
          entryPointsData.length > 6
            ? entryPointsData.slice(0, 6)
            : entryPointsData;

        const marketLoads = limitEntryPoints.map(
          (item: any, index: number) => ({
            response_code: item.ResponseCode,
            derived_metric_calculation: item.calculation_type || '',
            variable_label: item.MetricOption,
            Level0: item.Level1 === 'Markets' ? 'Markets' : 'Market',
            Level1: item.Level2 === 'Markets' ? 'Markets' : 'Market',
            Level2: item.MetricOption || '',
            Level3: '',
            Level4: '',
            Level5: '',
            year_code: item.year_code || null,
            is_brand_analysis: item.is_brand_analysis ? '1' : '0',
            is_derived: String(item.is_derived_variable ?? false),
            calc_type: item.calculation_type || '',
            hasNextLevel: 'false',
            variable_code: item.VariableCode,
            sort_id: (index + 1).toString(),
            is_multi_punch: item.is_multi_punch ? '1' : '0',
            date: item.date,
            is_dimension: 'false',
            is_CustomGroup: 'false',
            kibanaFilterScript: '',
            customGroupId: null,
            dataYearCode:
              item.mandatory_variable_mapping?.find(
                (m: any) => m.variable_sub_label === 'Year'
              )?.variable_code || '',
            is_time_Period_Present: item.mandatory_variable_mapping?.some(
              (m: any) => m.variable_label === 'Time Period'
            )
              ? 'true'
              : 'false',
          })
        );

        if (this.dataArray_Multiple.length > 0) {
          this.dataArray_Multiple[0].EntryPoint1 = {};
        }

        if (
          marketLoads.length > 0 &&
          this.dataArray_Multiple.length == 0 &&
          this.variableListMultiMarketAndCateg.length > 0
        ) {
          this.selectedObjects.push({ ['Markets']: marketLoads });
          marketLoads.forEach((MarketLoad: any) => {
            let MarketLoadData: any =
              this.variableListMultiMarketAndCateg?.find(
                (item: any) => item?.Level0 === MarketLoad?.Level0
              );
            if (MarketLoadData) {
              this.checkBoxClickMultiple(
                simulatedEvent,
                MarketLoad.Level0,
                MarketLoad.Level1,
                MarketLoad.variable_label,
                MarketLoad.variable_code,
                MarketLoad.response_code,
                MarketLoad.Level1,
                MarketLoad.Level2,
                MarketLoad.Level3,
                MarketLoad.Level4,
                MarketLoad.Level5,
                MarketLoad.Level0,
                true,
                MarketLoad,
                0,
                false
              );
            }
          });
          if (this.dataArray_Multiple.length > 0) {
            this.MultipleloadBtnClick(true, true);
            this.isMultiMarketOrCateg = true;
          }
        }

        if (this.variableList.length > 0) {
          this.variableList.forEach((item: any) => {
            const level0 = item.Level0;
            const level1List = item.Level1;
            if (!level1List?.length) return;
            const selectedItems = [];

            if (level0 === 'Time Period') {
              const level2Array = level1List[0]?.Level2 || [];
              const selectedLevel2 = level2Array.at(0); // first item

              if (selectedLevel2) {
                selectedItems.push(
                  this.buildSelectedObject(
                    level0,
                    level1List[0],
                    selectedLevel2,
                    ''
                  )
                );
              }
            } else if (level0 === 'Brands') {
              level1List.forEach((level1: any) => {
                const level2Items = this.getDefaultBrandLevel2Items(level1.Level2 || [], 1);
                level2Items.forEach((selectedLevel2: any) => {
                  if (selectedLevel2) {
                    selectedItems.push(
                      this.buildSelectedObject(level0, level1, selectedLevel2, '')
                    );
                  }
                });
              });
            } else {
              const level1 = level1List[0];
              const deepest = this.getDeepestLevels(
                level1?.Level2 || [],
                'first'
              );

              if (deepest.selectedLevel2) {
                selectedItems.push(
                  this.buildSelectedObject(
                    level0,
                    level1,
                    deepest.selectedLevel2,
                    deepest.selectedLevel3,
                    deepest.selectedLevel4,
                    deepest.selectedLevel5
                  )
                );
              }
            }

            if (selectedItems.length > 0) {
              this.selectedObjects.push({ [level0]: selectedItems });
            }
          });

          this.selectedObjects.forEach((obj: any) => {
            const level0Key = Object.keys(obj)[0];
            const selection = obj[level0Key]?.[0];
            if (!selection || selection.isFilter) return;

            const level0 = selection.Level0;
            const level1 = selection.Level1;
            const level2 = selection.Level2;
            const level3 = selection.Level3;
            const level4 = selection.Level4;
            const level5 = selection.Level5;

            const variableData = this.variableList.find(
              (item: any) => item.Level0 === level0
            );
            const level1Data = variableData?.Level1?.find(
              (l1: any) => l1.Level1_value === level1
            );

            if (!level1Data) return;

            let useLevel = 'Level2';
            let levelData = level1Data?.Level2;
            let currentLevel = level1Data?.Level2?.find(
              (l2: any) => l2.Level2_value === level2
            );

            if (currentLevel?.Level3?.length > 0) {
              useLevel = 'Level3';
              levelData = currentLevel.Level3;
              currentLevel = currentLevel.Level3?.find(
                (l3: any) => l3.Level3_value === level3
              );

              if (currentLevel?.Level4?.length > 0) {
                useLevel = 'Level4';
                levelData = currentLevel.Level4;
                currentLevel = currentLevel.Level4?.find(
                  (l4: any) => l4.Level4_value === level4
                );

                if (currentLevel?.Level5?.length > 0) {
                  useLevel = 'Level5';
                  levelData = currentLevel.Level5;
                }
              }
            }

            if (
              level0 === 'Time Period' &&
              this._configService.isStaticTimeFrame
            ) {
              return;
            }

            this.checkBoxClickNotEPRadio(
              'NOTfilters',
              simulatedEvent,
              level1,
              level2,
              level3,
              level4,
              level5,
              levelData,
              useLevel,
              level1Data,
              level0,
              true
            );
          });

          if (
            this._configService.isAggregatedData &&
            this.variableListFilter.length > 0 &&
            this.variableListFilter[0]?.Level1?.length > 0
          ) {
            this.GlobalFilterSelectionForAggregated(simulatedEvent);
          }

          let m = this.variableListMultiMarketAndCateg?.find(
            (item: any) => item?.Level0 === 'Markets'
          );
          m?.Level1[0].Level2.forEach((mm: any) => {
            let ispresent = marketLoads.find(
              (l: any) => l.Level2 == mm.Level2_value
            );
            if (ispresent) {
              mm.is_selected = true;
            } else {
              mm.is_selected = false;
            }
          });
          this.SubmitClicked(false, false, true);
        }
      }
    }
  }

  getDeepestLevels(level2List: any[] = [], pick: 'first' | 'last' = 'last') {
    const getItem = (list: any[]) => {
      if (!list?.length) return undefined;
      return pick === 'first' ? list[0] : list.at(-1);
    };

    const selectedLevel2 = getItem(level2List);
    if (!selectedLevel2) return {};

    const selectedLevel3 = getItem(selectedLevel2.Level3 || []);
    const selectedLevel4 = getItem(selectedLevel3?.Level4 || []);
    const selectedLevel5 = getItem(selectedLevel4?.Level5 || []);

    return {
      selectedLevel2,
      selectedLevel3,
      selectedLevel4,
      selectedLevel5,
    };
  }

  private getDefaultBrandLevel2Items(level2List: any[] = [], fallbackCount: number): any[] {
    if (this.defaultBrandList?.length > 0) {
      return this.defaultBrandList
        .map((brand: string, index: number) => {
          const level2 = level2List.find((l2: any) => l2.Level2_value === brand);
          return level2 ? { ...level2, sort_id: (index + 1).toString() } : null;
        })
        .filter((level2: any) => level2 !== null);
    }

    return level2List
      .slice(0, fallbackCount)
      .map((level2: any, index: number) => ({ ...level2, sort_id: (index + 1).toString() }));
  }

  buildSelectedObject(
    level0: string,
    level1: any,
    level2: any,
    level3: any = {},
    level4: any = {},
    level5: any = {},
    isFilter = false
  ): any {
    // Merge from shallowest to deepest — deepest (level5) has highest priority
    const source = { ...level1, ...level2, ...level3, ...level4, ...level5 };
    if (!isFilter) {
      return {
        response_code: source.response_code || '',
        derived_metric_calculation: source.derived_metric_calculation || '',
        variable_label:
          source.Level5_value ||
          source.Level4_value ||
          source.Level3_value ||
          source.Level2_value ||
          '',
        Level0: level0,
        Level1: source.Level1_value,
        Level2: source.Level2_value || '',
        Level3: source.Level3_value || '',
        Level4: source.Level4_value || '',
        Level5: source.Level5_value || '',
        year_code: source.year_code || '',
        is_brand_analysis: source.is_brand_analysis?.toString() || '',
        is_derived: source.is_derived?.toString() || '',
        calc_type: source.calc_type || '',
        hasNextLevel: source.hasNextLevel?.toString() || '',
        variable_code: source.data_variable_code || '',
        sort_id: source.sort_id?.toString() || '',
        is_multi_punch: source.is_multi_punch?.toString() || '',
        date: source.date || '',
        is_dimension: source.is_dimension?.toString() || '',
        is_CustomGroup: source.isCustomGrpPresent?.toString() || '',
        kibanaFilterScript: source.kibanaFilterScript || '',
        customGroupId: source.customGroupId || '',
        dataYearCode: source.dataYearCode || '',
        is_time_Period_Present: source.is_time_Period_Present?.toString() || '',
        isFilter: isFilter,
        Weekno_forSigcalculation: source.Weekno_forSigcalculation
      };
    } else {
      return {
        response_code: source.response_code || '',
        derived_metric_calculation: source.derived_metric_calculation || '',
        variable_label:
          source.Level5_value ||
          source.Level4_value ||
          source.Level3_value ||
          source.Level2_value ||
          '',
        Level0: '',
        Level1: level0,
        Level2: source.Level1_value,
        Level3: source.Level2_value || '',
        Level4: source.Level3_value || '',
        Level5: source.Level4_value || '',
        // Level5: source.Level5_value || "",
        year_code: source.year_code || '',
        is_brand_analysis: source.is_brand_analysis?.toString() || '',
        is_derived: source.is_derived?.toString() || '',
        calc_type: source.calc_type || '',
        hasNextLevel: source.hasNextLevel?.toString() || '',
        variable_code: source.data_variable_code || '',
        sort_id: source.sort_id?.toString() || '',
        is_multi_punch: source.is_multi_punch?.toString() || '',
        date: source.date || '',
        is_dimension: source.is_dimension?.toString() || '',
        is_CustomGroup: source.isCustomGrpPresent?.toString() || '',
        kibanaFilterScript: source.kibanaFilterScript || '',
        customGroupId: source.customGroupId || '',
        dataYearCode: source.dataYearCode || '',
        is_time_Period_Present: source.is_time_Period_Present?.toString() || '',
        isFilter: isFilter,
        Weekno_forSigcalculation: source.Weekno_forSigcalculation
      };
    }
  }

  GlobalFilterSelectionForAggregated(simulatedEvent: any) {
    this.variableListFilter[0].Level1.forEach((item: any) => {
      const level0 = item.Level0;
      const level1List = item.Level1;
      if (level0 == 'KPI' || !level1List?.length) return;
      const selectedItems = [];

      const level1 = level1List[0];

      if (level1?.Level2?.length > 0) {
        const deepest = this.getDeepestLevels(level1.Level2, 'first');

        if (deepest.selectedLevel2) {
          selectedItems.push(
            this.buildSelectedObject(
              level0,
              level1,
              deepest.selectedLevel2,
              deepest.selectedLevel3,
              deepest.selectedLevel4,
              deepest.selectedLevel5,
              true
            )
          );
        }
      } else {
        selectedItems.push(
          this.buildSelectedObject(
            level0,
            level1,
            {}, // level2
            {}, // level3
            {}, // level4
            {},
            true
          )
        );
      }
      if (selectedItems.length > 0) {
        this.selectedObjects.push({ [level0]: selectedItems });
      }
    });
    this.selectedObjects.forEach((obj: any) => {
      const level0Key = Object.keys(obj)[0];
      const selection = obj[level0Key]?.[0];
      if (!selection || !selection.isFilter) return;

      this.checkBoxClickNotEP(
        'filters',
        simulatedEvent,
        '',
        selection.Level1,
        selection.Level2,
        selection.Level3,
        selection.Level4,
        selection.Level5,
        selection.Level6,
        selection.Level7,
        selection.Level8,
        '',
        true,
        selection,
        true
      );
    });
  }
  /**
   * Finds the Level2 item matching the AskMe preselected time period.
   * Uses a two-pass search: exact match first, then substring fallback.
   * Returns null when no preselection is active.
   */
  private _findAskMeTimePeriod(level1List: any[]): { l1Item: any; level2: any } | null {
    const rawTp = this._configService.askMePreselection?.timeperiod;
    const askMeTp = Array.isArray(rawTp) ? rawTp[0] : rawTp;
    if (!askMeTp || typeof askMeTp !== 'string') return null;
    const tpLower = askMeTp.toLowerCase();
    // Pass 1: exact match
    for (const l1Item of level1List) {
      const match = (l1Item.Level2 || []).find((l2: any) =>
        (l2.Level2_value || l2.variable_label || '').toLowerCase() === tpLower
      );
      if (match) return { l1Item, level2: match };
    }
    // Pass 2: AskMe value contains the Level2 value as a substring
    for (const l1Item of level1List) {
      const match = (l1Item.Level2 || []).find((l2: any) =>
        tpLower.includes((l2.Level2_value || l2.variable_label || '').toLowerCase())
      );
      if (match) return { l1Item, level2: match };
    }
    return null;
  }

  /**
   * Finds the Level2 item fuzzy-matching the AskMe preselected brand
   * (exact → includes → contained-by). Returns null when no preselection is active.
   */
  private _findAskMeBrand(level1List: any[]): { level1: any; level2: any } | null {
    const rawBrand = this._configService.askMePreselection?.brand;
    const askMeBrand = Array.isArray(rawBrand) ? rawBrand[0] : rawBrand;
    if (!askMeBrand || typeof askMeBrand !== 'string') return null;
    const brandLower = askMeBrand.toLowerCase();
    for (const level1 of level1List) {
      const match = (level1.Level2 || []).find((l2: any) => {
        const val = (l2.Level2_value || l2.variable_label || '').toLowerCase();
        return val === brandLower || val.includes(brandLower) || brandLower.includes(val);
      });
      if (match) return { level1, level2: match };
    }
    return null;
  }

  /**
   * Finds the Level2 item exactly matching the AskMe preselected market.
   * Returns null when no preselection is active.
   */
  private _findAskMeMarket(level1List: any[]): { level1: any; level2: any } | null {
    const rawMarket = this._configService.askMePreselection?.market;
    const askMeMarket = Array.isArray(rawMarket) ? rawMarket[0] : rawMarket;
    if (!askMeMarket || typeof askMeMarket !== 'string') return null;
    const marketLower = askMeMarket.toLowerCase();
    for (const l1 of level1List) {
      const match = (l1.Level2 || []).find((l2: any) =>
        (l2.Level2_value || l2.variable_label || '').toLowerCase() === marketLower
      );
      if (match) return { level1: l1, level2: match };
    }
    return null;
  }

  private _applyAskMeFilters(simulatedEvent: any): void {
    const filterAudience = this._configService.askMePreselection?.filter_audience;
    if (!filterAudience?.length || !this.variableListFilter?.[0]?.Level1?.length) return;

    const filters: string[] = Array.isArray(filterAudience) ? filterAudience : [filterAudience];
    for (const filterStr of filters) {
      const parts = (filterStr as string).split('|');
      if (parts.length < 4) continue;
      const [l0, l1Val, l2Val, l3Val] = parts;

      const l0Group = this.variableListFilter[0].Level1.find((g: any) => g.Level0 === l0);
      if (!l0Group) continue;
      const l1Item = (l0Group.Level1 || []).find((l1: any) => l1.Level1_value === l1Val);
      if (!l1Item) continue;
      const l2Item = (l1Item.Level2 || []).find((l2: any) => l2.Level2_value === l2Val);
      if (!l2Item) continue;
      const l3Item = (l2Item.Level3 || []).find((l3: any) => l3.Level3_value === l3Val);
      if (!l3Item) continue;

      // Filter items use a shifted level convention (mirrors buildSelectedObject with isFilter=true):
      // Level0='', Level1=l0(group), Level2=Level1_value, Level3=Level2_value, Level4=Level3_value
      const filterData = {
        ...l3Item,
        Level0: '',
        Level1: l0,
        Level2: l1Val,
        Level3: l2Val,
        Level4: l3Val,
        Level5: '',
        variable_code: l3Item.data_variable_code || '',
        isFilter: true
      };
      this.checkBoxClickNotEP(
        'filters', simulatedEvent,
        l0, l1Val, l2Val, l3Val, '', '', '', '', '',
        '', true, filterData
      );
    }
  }

  isCustomBaseSelected : boolean = false;
  selectedCustomBaseReference: string[] = [];
  LoadSelectionVariableData() {
    let dataLoaded = sessionStorage.getItem('dataLoaded');
    if (!dataLoaded || this.isBrowserRefresh) {
      this._configService.isIndexSelected = false;
      const simulatedEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      });

    this.isCustomBaseSelected = this._configService.outputSnapshotData?.isCustomBaseSelected !== false;
    if (this.isCustomBaseSelected && this.selectedScenarioData[0].selectedCustomBaseReference)
    {
      this.selectedCustomBaseReference = JSON.parse(this.selectedScenarioData[0].selectedCustomBaseReference);      
    }

      // this.dataArray[0].EntryPoint1={}
      let selectionsLength = JSON.parse(
        this.selectedScenarioData[0]?.leftpanel_input_data
      )?.selections.length;
      let selectionsOrder = [];
      for (let i = 0; i < selectionsLength; i++) {
        selectionsOrder.push(
          Object.keys(
            JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)
              ?.selections[i]
          )[0]
        );
      }
      if (!this.selectedcompareacrossOption.includes('Multiple') && this.selectedcompareacrossOption != 'Audience Snapshot') {
        const timePeriodIndex = selectionsOrder.indexOf('Time Period');
        let TP = timePeriodIndex !== -1
          ? JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)
              ?.selections[timePeriodIndex]?.['Time Period']?.[0]
          : null;
        let BrandLoad = JSON.parse(
          this.selectedScenarioData[0]?.leftpanel_input_data
        )?.selections[selectionsOrder.indexOf('Brands')]?.['Brands'][0];
        if (BrandLoad == undefined) {
          BrandLoad = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data
          )?.selections[selectionsOrder.indexOf('Brand')]?.['Brand'][0];
        }
        if (BrandLoad == undefined) {
          BrandLoad = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data
          )?.selections[selectionsOrder.indexOf("Audience")]?.["Audience"][0];
        }
        let TPData: any = this.variableList?.find(
          (item: any) => item?.Level0 === TP?.Level0
        );
        let TPDataL1: any = TPData?.Level1?.find(
          (item: any) => item?.Level1_value === TP?.Level1
        );
        let BrandLoadData: any = this.variableList?.find(
          (item: any) => item?.Level0 === BrandLoad?.Level0
        );
        let BrandLoadDataL1: any = BrandLoadData?.Level1?.find(
          (item: any) => item?.Level1_value === BrandLoad?.Level1
        );
        if (!this._configService.isStaticTimeFrame && TP && TPDataL1) {
          this.checkBoxClickNotEPRadio(
            'NOTfilters',
            simulatedEvent,
            TP.Level1,
            TP.Level2,
            TP.Level3,
            TP.Level4,
            TP.Level5,
            TPDataL1?.Level2,
            'Level2',
            TPDataL1,
            TP.Level0,
            true
          );
        }
        this.checkBoxClickNotEPRadio(
          'NOTfilters',
          simulatedEvent,
          BrandLoad.Level1,
          BrandLoad.Level2,
          BrandLoad.Level3,
          BrandLoad.Level4,
          BrandLoad.Level5,
          BrandLoadDataL1?.Level2,
          'Level2',
          BrandLoadDataL1,
          BrandLoad.Level0,
          true
        );
        this.checkBoxLoadSelectionFilters(simulatedEvent, selectionsOrder);

        if (this.CheckIfMandatorySelected()) {
          this.SubmitClicked(true);
        }
      }
      if (this.selectedcompareacrossOption == 'Multiple Brands') {
        // A saved selection can be loaded while another snapshot type is still
        // active. Remove those selections before replaying the saved brands so
        // they cannot be submitted as extra cohorts.
        this.selectedObjects = [];
        this.variablesSummaryObj = [];
        this.variablesSummaryObjRadio = [];

       const timePeriodIndex = selectionsOrder.indexOf('Time Period');

        let TP = timePeriodIndex !== -1
          ? JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)
              ?.selections[timePeriodIndex]?.['Time Period']?.[0]
          : null;
       
        const brandIndex = selectionsOrder.indexOf('Brands');
        let BrandLoads = brandIndex !== -1
          ? JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)
              ?.selections[brandIndex]?.['Brands']
          : null;

        if (BrandLoads == undefined) {
          BrandLoads = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data
          )?.selections[selectionsOrder.indexOf('Brand')]?.['Brand'];
        }
        let TPData: any = this.variableList?.find(
          (item: any) => item?.Level0 === TP?.Level0
        );
        let TPDataL1: any = TPData?.Level1?.find(
          (item: any) => item?.Level1_value === TP?.Level1
        );
        BrandLoads.forEach((BrandLoad: any) => {
          let BrandLoadData: any = this.variableList?.find(
            (item: any) => item?.Level0 === BrandLoad?.Level0
          );
          let BrandLoadDataL1: any = BrandLoadData?.Level1?.find(
            (item: any) => item?.Level1_value === BrandLoad?.Level1
          );
          this.checkBoxClickNotEP(
            'NOTfilters',
            simulatedEvent,
            BrandLoad.Level1,
            BrandLoad.Level2,
            BrandLoad.Level3,
            BrandLoad.Level4,
            BrandLoad.Level5,
            BrandLoad.Level6,
            BrandLoad.Level7,
            BrandLoad.Level8,
            BrandLoad.Level9,
            BrandLoad.Level0,
            true,
            BrandLoad
          );
        });
        if (!this._configService.isStaticTimeFrame && TP && TPDataL1) {
          this.checkBoxClickNotEPRadio(
            'NOTfilters',
            simulatedEvent,
            TP?.Level1,
            TP?.Level2,
            TP?.Level3,
            TP?.Level4,
            TP?.Level5,
            TPDataL1?.Level2,
            'Level2',
            TPDataL1,
            TP?.Level0,
            true
          );
        }
        this.checkBoxLoadSelectionFilters(simulatedEvent, selectionsOrder);

        if (this.CheckIfMandatorySelected()) {
          this.SubmitClicked(true);
        }
      }

      if (this.selectedcompareacrossOption == 'Multiple Markets') {
        this.selectedObjects = [];
        this.variablesSummaryObj = [];
        this.variablesSummaryObjRadio = [];
       
        if (this.dataArray_Multiple.length > 0) {
          this.dataArray_Multiple[0].EntryPoint1 = {};
        }
        let MarketLoads = JSON.parse(
          this.selectedScenarioData[0]?.leftpanel_input_data
        )?.selections[selectionsOrder.indexOf('Markets')]['Markets'];
        if (
          MarketLoads.length > 0 &&
          this.dataArray_Multiple.length == 0 &&
          this.variableListMultiMarketAndCateg.length > 0
        ) {
          MarketLoads.forEach((MarketLoad: any) => {
            let MarketLoadData: any =
              this.variableListMultiMarketAndCateg?.find(
                (item: any) => item?.Level0 === MarketLoad?.Level0
              );
            let MarketLoadDataL1: any = MarketLoadData?.Level1?.find(
              (item: any) => item?.Level1_value === MarketLoad?.Level1
            );
            if (MarketLoadData) {
              this.checkBoxClickMultiple(
                simulatedEvent,
                MarketLoad.Level1,
                MarketLoad.Level2,
                MarketLoad.variable_label,
                MarketLoad.variable_code,
                MarketLoad.response_code,
                MarketLoad.Level1,
                MarketLoad.Level2,
                MarketLoad.Level3,
                MarketLoad.Level4,
                MarketLoad.Level5,
                MarketLoad.Level0,
                true,
                MarketLoad,
                0,
                false
              );
              //this.SwitchMakeSelectedTrueMultiple(MarketLoadData, 'NOTfilters');
            }
          });
          if (this.dataArray_Multiple.length > 0) {
            this.MultipleloadBtnClick(true);
            this.isMultiMarketOrCateg = true;
          }
        }
        if (this.dataArray_Multiple.length > 0) {
          const timePeriodIndex = selectionsOrder.indexOf('Time Period');
          let TP = timePeriodIndex !== -1
            ? JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)
                ?.selections[timePeriodIndex]?.['Time Period']?.[0]
            : null;
          let BrandLoads = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data
          )?.selections[selectionsOrder.indexOf('Brands')]?.['Brands'];
          if (BrandLoads == undefined) {
            BrandLoads = JSON.parse(
              this.selectedScenarioData[0]?.leftpanel_input_data
            )?.selections[selectionsOrder.indexOf('Brands')]?.['Brands'];
          }

          let TPData: any = this.variableList?.find(
            (item: any) => item?.Level0 === TP?.Level0
          );
          let TPDataL1: any = TPData?.Level1?.find(
            (item: any) => item?.Level1_value === TP?.Level1
          );
          BrandLoads.forEach((BrandLoad: any) => {
            let BrandLoadData: any = this.variableList?.find(
              (item: any) => item?.Level0 === BrandLoad?.Level0
            );
            let BrandLoadDataL1: any = BrandLoadData?.Level1?.find(
              (item: any) => item?.Level1_value === BrandLoad?.Level1
            );
            this.checkBoxClickNotEPRadio(
                'NOTfilters',
                simulatedEvent,
                BrandLoad.Level1,
                BrandLoad.Level2,
                BrandLoad.Level3,
                BrandLoad.Level4,
                BrandLoad.Level5,
                BrandLoadDataL1?.Level2,
                'Level2',
                BrandLoadDataL1,
                BrandLoad.Level0,
                true
              );

            // this.checkBoxClickNotEP(
            //   'NOTfilters',
            //   simulatedEvent,
            //   BrandLoad.Level1,
            //   BrandLoad.Level2,
            //   BrandLoad.Level3,
            //   BrandLoad.Level4,
            //   BrandLoad.Level5,
            //   BrandLoad.Level6,
            //   BrandLoad.Level7,
            //   BrandLoad.Level8,
            //   BrandLoad.Level9,
            //   BrandLoad.Level0,
            //   true,
            //   BrandLoad
            // );
          });
          if (!this._configService.isStaticTimeFrame && TP && TPDataL1) {
            this.checkBoxClickNotEPRadio(
              'NOTfilters',
              simulatedEvent,
              TP.Level1,
              TP.Level2,
              TP.Level3,
              TP.Level4,
              TP.Level5,
              TPDataL1?.Level2,
              'Level2',
              TPDataL1,
              TP.Level0,
              true
            );
          }
          this.checkBoxLoadSelectionFilters(simulatedEvent, selectionsOrder);

          // if(Object.keys(this.dataArray_Multiple[0].EntryPoint1).length !== 0){
          //   MarketLoads.forEach((MarketLoad: any) => {
          //     let MarketLoadData: any = this.variableListMultiMarketAndCateg?.find((item: any) => item?.Level0 === MarketLoad?.Level0);
          //     let MarketLoadDataL1: any = MarketLoadData?.Level1?.find((item: any) => item?.Level1_value === MarketLoad?.Level1);
          //     if (MarketLoadData) {
          //       this.checkBoxClickMultiple(simulatedEvent, MarketLoad.Level1, MarketLoad.Level2, MarketLoad.variable_label, MarketLoad.variable_code, MarketLoad.response_code, MarketLoad.Level1, MarketLoad.Level2, MarketLoad.Level3, MarketLoad.Level4, MarketLoad.Level5, MarketLoad.Level0, true, MarketLoad, 0, false);
          //       //this.SwitchMakeSelectedTrueMultiple(MarketLoadData, 'NOTfilters');
          //     }
          //   })
          // }
          let MarketLoads = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data
          )?.selections[selectionsOrder.indexOf('Markets')]['Markets'];
          let m = this.variableListMultiMarketAndCateg?.find(
            (item: any) => item?.Level0 === 'Markets'
          );
          m?.Level1[0].Level2.forEach((mm: any) => {
            let ispresent = MarketLoads.find(
              (l: any) => l.Level2 == mm.Level2_value
            );
            if (ispresent) {
              mm.is_selected = true;
            } else {
              mm.is_selected = false;
            }
          });

          if (this.CheckIfMandatorySelected()) {
            this.SubmitClicked(true);
          }
        }
      }
      if (this.selectedcompareacrossOption == 'Audience Snapshot') {
        const timePeriodIndex = selectionsOrder.indexOf('Time Period');
        let TP = timePeriodIndex !== -1
          ? JSON.parse(this.selectedScenarioData[0]?.leftpanel_input_data)
              ?.selections[timePeriodIndex]?.['Time Period']?.[0]
          : null;

        let BrandLoads = JSON.parse(
          this.selectedScenarioData[0]?.leftpanel_input_data
        )?.selections[selectionsOrder.indexOf('Audience')]?.['Audience'];
        if (BrandLoads == undefined) {
          BrandLoads = JSON.parse(
            this.selectedScenarioData[0]?.leftpanel_input_data
          )?.selections[selectionsOrder.indexOf('Audience')]?.['Audience'];
        }
        let TPData: any = this.variableList?.find(
          (item: any) => item?.Level0 === TP?.Level0
        );
        let TPDataL1: any = TPData?.Level1?.find(
          (item: any) => item?.Level1_value === TP?.Level1
        );
        BrandLoads.forEach((BrandLoad: any) => {
          let BrandLoadData: any = this.variableList?.find(
            (item: any) => item?.Level0 === BrandLoad?.Level0
          );
          let BrandLoadDataL1: any = BrandLoadData?.Level1?.find(
            (item: any) => item?.Level1_value === BrandLoad?.Level1
          );
          this.checkBoxClickNotEP(
            'NOTfilters',
            simulatedEvent,
            BrandLoad.Level1,
            BrandLoad.Level2,
            BrandLoad.Level3,
            BrandLoad.Level4,
            BrandLoad.Level5,
            BrandLoad.Level6,
            BrandLoad.Level7,
            BrandLoad.Level8,
            BrandLoad.Level9,
            BrandLoad.Level0,
            true,
            BrandLoad
          );
        });
        if (!this._configService.isStaticTimeFrame && TP && TPDataL1) {
          this.checkBoxClickNotEPRadio(
            'NOTfilters',
            simulatedEvent,
            TP.Level1,
            TP.Level2,
            TP.Level3,
            TP.Level4,
            TP.Level5,
            TPDataL1?.Level2,
            'Level2',
            TPDataL1,
            TP.Level0,
            true
          );
        }
        this.checkBoxLoadSelectionFilters(simulatedEvent, selectionsOrder);

        if (this.CheckIfMandatorySelected()) {
          this.SubmitClicked(true);
        }
      }
    }
  }

  checkBoxLoadSelectionFilters(simulatedEvent: any, selectionsOrder: any) {
    for (let i = 0; i < selectionsOrder.length; i++) {
      if (
        selectionsOrder[i] !== 'Brands' &&
        selectionsOrder[i] !== 'Brand' &&
        (this._configService.isStaticTimeFrame ||
          selectionsOrder[i] !== 'Time Period')
      ) {
        let selectionLength = JSON.parse(
          this.selectedScenarioData[0]?.leftpanel_input_data
        )?.selections[i][selectionsOrder[i]].length;
        let SelectionFilterData = JSON.parse(
          this.selectedScenarioData[0]?.leftpanel_input_data
        )?.selections[i][selectionsOrder[i]];
        for (let j = 0; j < selectionLength; j++) {
          this.checkBoxClickNotEP(
            'filters',
            simulatedEvent,
            SelectionFilterData[j].Level1,
            SelectionFilterData[j].Level2,
            SelectionFilterData[j].Level3,
            SelectionFilterData[j].Level4,
            SelectionFilterData[j].Level5,
            SelectionFilterData[j].Level6,
            SelectionFilterData[j].Level7,
            SelectionFilterData[j].Level8,
            SelectionFilterData[j].Level9,
            SelectionFilterData[j].Level0 ? SelectionFilterData[j].Level0 : '',
            true,
            SelectionFilterData[j]
          );
        }
      }
    }
  }

  checkAudienceCount(Group: string): number {

    return this.selectedObjects
      .filter(obj => Object.keys(obj)[0] !== Group) // remove top-level audience
      .reduce((count, obj) => {
        const key = Object.keys(obj)[0];

        // Count Level0 === 'Audience' inside nested array
        const nestedCount = obj[key].filter((item: any) => item.Level0 === Group).length;

        return count + nestedCount;
      }, 0);
  }

  //   tooltipText = this.buildTooltip(this.selection);

  // buildTooltip(data: any[]) {
  //   return data
  //     .map(x => `${x.level1} : ${x.level2} : <b>${x.level3.join(', ')}</b>`)
  //     .join('<br>');
  // }



  AdditionalFeatures() {
    this.isadditionalfeatureDropdownOpen =
      !this.isadditionalfeatureDropdownOpen;
  }

  additionalFeaturesOption(option: string) {
    this.isadditionalfeatureDropdownOpen = false;
    this.additionalFeatures.emit(option);
    // this.dataListChange.emit(this.dataArray);
  }

  private isCustomPercentageOrMeanSelected(): boolean {
    return (
      this.customContentAllowsVariable(this._configService.outputSnapshotData?.custom_content) ||
      this.customContentAllowsVariable(this.snapshotDataConfig?.custom_content)
    );
  }

  private customContentAllowsVariable(customContent: any): boolean {
    if (!Array.isArray(customContent)) {
      return false;
    }
    const selectedKeys = new Set(
      customContent
        .filter((item: any) => this.isConfigFlagOn(item?.value ?? item?.selected))
        .map((item: any) => (item?.key ?? item?.name ?? '').toString().trim().toLowerCase())
    );
    const percentageSelected = ['custom percentage', 'custom groups', 'customgroups'].some((key) =>
      selectedKeys.has(key)
    );
    const meanSelected = ['custom mean', 'custom calculations', 'customcalculations'].some((key) =>
      selectedKeys.has(key)
    );
    return percentageSelected || meanSelected;
  }

  private isConfigFlagOn(value: any): boolean {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  trackByFn(index: number, item: any) {
    return item.Level0 || item.LevelMinus || index;
  }

  trackByLevel1(index: number, item: any) {
    return item.Level1_value || item.Level0 || index;
  }

  trackByLevel2(index: number, item: any) {
    return item.Level2_value || item.Level1_value || index;
  }

  trackByLevel3(index: number, item: any) {
    return item.Level3_value || item.Level2_value || index;
  }

  trackByLevel4(index: number, item: any) {
    return item.Level4_value || item.Level3_value || index;
  }

  trackByLevel5(index: number, item: any) {
    return item.Level5_value || item.Level4_value || index;
  }

  trackByLevel6(index: number, item: any) {
    return item.Level6_value || item.Level5_value || index;
  }

  trackByLevel7(index: number, item: any) {
    return item.Level7_value || item.Level6_value || index;
  }

  trackByLevel8(index: number, item: any) {
    return item.Level8_value || item.Level7_value || index;
  }

  trackByLevel9(index: number, item: any) {
    return item.Level9_value || item.Level8_value || index;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

     // Clear caches
      this._toggleStatusCache.clear();
      this._varCodeToEntryKeyCache.clear();
      this._lastSelectedTextClickEl = null;
      this._topCache = null;
      this._topLev1Cache = null;
      this._submitButtonEl = null;
      this._entryHeaderEl = null;
      this._entryTabEl = null;
      this._btnLoadEl = null;
      this._variableTabEl = null;
    if (this.$unSubscribeSubmitData1) {
      this.$unSubscribeSubmitData1.unsubscribe();
    }
    if (this.$unSubscribeSubmitData2) {
      this.$unSubscribeSubmitData2.unsubscribe();
    }
    // if (this.$unSubscribeSubmitData3) {
    //   this.$unSubscribeSubmitData3.unsubscribe();
    // }
  }



  // Listen for click events on the document.
  // @HostListener('document:click', ['$event'])
  // onDocumentClick(event: Event): void {
  //   // Check if the click event occurred outside the <div> block.
  //   if (!this.isClickInside(event, '.sidePanelblock')) {
  //     this.sidePanelblock = false;
  //   }
  // }

  increaseLeftbgpanelWidth(event: any) {
    const parentWidth = window.innerWidth; // Get parent width
    let newWidth = 0;
    if (event?.isReset) {
      this.resetLeftpanelWidth();
    } else {
      if (event?.isIncrease && event?.level >= 3) {
        if (event?.level == 3) {
          newWidth = (80 / 100) * parentWidth; // Calculate 80% of parent
        }
        if (event?.level == 4) {
          newWidth = (100 / 100) * parentWidth; // Calculate 90% of parent
        }
         this.bgWidth=newWidth-400;
      }
      if (event?.isDecrease && event?.level >= 3) {
        if (event?.level == 3) {
          newWidth = (70 / 100) * parentWidth; // Calculate 80% of parent
        }
        if (event?.level == 4) {
          newWidth = (80 / 100) * parentWidth; // Calculate 90% of parent
        }
        this.bgWidth=newWidth-400;
      }
    }
          
    
  }

  resetLeftpanelWidth() {
    if (!this.isCreateCustomGroup) {
      const parentWidth =window.innerWidth // Get parent width
      // const currentWidth = this.leftPanel.nativeElement.offsetWidth; // Get current width in pixels
      let newWidth = 0;
      newWidth = (70 / 100) * parentWidth; // Calculate 80% of parent
      this.bgWidth=newWidth-400;
    }
    
  }
  public scrollToRightEnd(): void {
  if (this.variablesScroll && this.variablesScroll.nativeElement) {
    // Use the scrollTo method for smooth behavior
    this.variablesScroll.nativeElement.scrollTo({
      left: this.variablesScroll.nativeElement.scrollWidth,
      behavior: 'smooth' // Optional: adds smooth scrolling animation
    });

    // Alternatively, use the scrollLeft property for an immediate jump
    // this.scrollContainer.nativeElement.scrollLeft = this.scrollContainer.nativeElement.scrollWidth;
  }
}

}
